import { defineComponent as _e, openBlock as A, createElementBlock as j, createElementVNode as ne, toDisplayString as $e, createCommentVNode as ue, normalizeClass as ye, renderSlot as me, createBlock as Se, unref as q, createVNode as Oe, mergeProps as Ce, shallowRef as Hn, watch as Ve, computed as J, toValue as Ge, reactive as Jr, h as Ss, getCurrentInstance as Qr, inject as Zn, resolveComponent as Fa, createPropsRestProxy as ga, resolveDynamicComponent as Xt, withCtx as Ie, ref as pe, onMounted as pt, Transition as wn, normalizeProps as Lt, guardReactiveProps as Rt, createTextVNode as bt, Teleport as ba, useSlots as En, onUpdated as Yl, onUnmounted as Tn, withModifiers as oa, Fragment as Ye, renderList as ht, useModel as Za, mergeModels as sa, useTemplateRef as ut, nextTick as Wa, createSlots as Xa, normalizeStyle as At, isRef as Ri, onBeforeUnmount as Gl, provide as ei, withDirectives as Jt, withKeys as ti, vModelCheckbox as Kl, vModelDynamic as Fi, readonly as Jl, vShow as ni, createStaticVNode as Cs, TransitionGroup as Es, getCurrentScope as Ts, onScopeDispose as Ls, shallowReadonly as In, version as As, vModelRadio as $s, toRefs as Ca, onServerPrefetch as Is, onBeforeMount as Ds, vModelText as Ms } from "vue";
import { toArray as Os, unrefElement as Ql, tryOnScopeDispose as Rs, refDebounced as Fs, useTransition as Ns, TransitionPresets as Bs, useScrollLock as eo, onClickOutside as Ya, onKeyStroke as to, useEventListener as on, useMediaQuery as Ps, usePreferredReducedMotion as no, useVibrate as ao, useTimeoutFn as ea, useIntervalFn as zs, useDebounceFn as Vs, useElementSize as Hs, useResizeObserver as Us, usePointerSwipe as qs } from "@vueuse/core";
import { isNotNestedPath as js, cleanupNonNestedPath as Zs, useForm as Ws, useField as Xs } from "vee-validate";
import './index.css';const Ys = {
  key: 0,
  class: "lc-count-bubble"
}, zr = /* @__PURE__ */ _e({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, a) => e.count ? (A(), j("div", Ys, [
      ne("span", null, $e(Math.min(e.count, 99)), 1)
    ])) : ue("", !0);
  }
}), Je = /* @__PURE__ */ _e({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(e) {
    return (t, a) => (A(), j("i", {
      "aria-hidden": "true",
      class: ye(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), k1 = ["large", "medium", "small"], _1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "winning",
  "winning-correction",
  "zoom"
], Gs = { class: "lc-badge" }, S1 = /* @__PURE__ */ _e({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, a) => (A(), j("div", Gs, [
      me(t.$slots, "icon", {}, () => [
        e.icon ? (A(), Se(q(Je), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : ue("", !0)
      ]),
      Oe(q(zr), Ce({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      me(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Ks = (e) => e != null;
var ro = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Na = /* @__PURE__ */ ro.join(","), io = typeof Element > "u", kn = io ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Ba = !io && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, Pa = function(t, a) {
  var r;
  a === void 0 && (a = !0);
  var s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = s === "" || s === "true", n = i || a && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : Pa(t.parentNode));
  return n;
}, Js = function(t) {
  var a, r = t == null || (a = t.getAttribute) === null || a === void 0 ? void 0 : a.call(t, "contenteditable");
  return r === "" || r === "true";
}, lo = function(t, a, r) {
  if (Pa(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(Na));
  return a && kn.call(t, Na) && s.unshift(t), s = s.filter(r), s;
}, za = function(t, a, r) {
  for (var s = [], i = Array.from(t); i.length; ) {
    var n = i.shift();
    if (!Pa(n, !1))
      if (n.tagName === "SLOT") {
        var l = n.assignedElements(), o = l.length ? l : n.children, h = za(o, !0, r);
        r.flatten ? s.push.apply(s, h) : s.push({
          scopeParent: n,
          candidates: h
        });
      } else {
        var v = kn.call(n, Na);
        v && r.filter(n) && (a || !t.includes(n)) && s.push(n);
        var u = n.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(n), f = !Pa(u, !1) && (!r.shadowRootFilter || r.shadowRootFilter(n));
        if (u && f) {
          var m = za(u === !0 ? n.children : u.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: n,
            candidates: m
          });
        } else
          i.unshift.apply(i, n.children);
      }
  }
  return s;
}, oo = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || Js(t)) && !oo(t) ? 0 : t.tabIndex;
}, Qs = function(t, a) {
  var r = pn(t);
  return r < 0 && a && !oo(t) ? 0 : r;
}, ec = function(t, a) {
  return t.tabIndex === a.tabIndex ? t.documentOrder - a.documentOrder : t.tabIndex - a.tabIndex;
}, so = function(t) {
  return t.tagName === "INPUT";
}, tc = function(t) {
  return so(t) && t.type === "hidden";
}, nc = function(t) {
  var a = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return a;
}, ac = function(t, a) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === a)
      return t[r];
}, rc = function(t) {
  if (!t.name)
    return !0;
  var a = t.form || Ba(t), r = function(l) {
    return a.querySelectorAll('input[type="radio"][name="' + l + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(t.name));
  else
    try {
      s = r(t.name);
    } catch (n) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", n.message), !1;
    }
  var i = ac(s, t.form);
  return !i || i === t;
}, ic = function(t) {
  return so(t) && t.type === "radio";
}, lc = function(t) {
  return ic(t) && !rc(t);
}, oc = function(t) {
  var a, r = t && Ba(t), s = (a = r) === null || a === void 0 ? void 0 : a.host, i = !1;
  if (r && r !== t) {
    var n, l, o;
    for (i = !!((n = s) !== null && n !== void 0 && (l = n.ownerDocument) !== null && l !== void 0 && l.contains(s) || t != null && (o = t.ownerDocument) !== null && o !== void 0 && o.contains(t)); !i && s; ) {
      var h, v, u;
      r = Ba(s), s = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = s) !== null && v !== void 0 && (u = v.ownerDocument) !== null && u !== void 0 && u.contains(s));
    }
  }
  return i;
}, Ni = function(t) {
  var a = t.getBoundingClientRect(), r = a.width, s = a.height;
  return r === 0 && s === 0;
}, sc = function(t, a) {
  var r = a.displayCheck, s = a.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var n = getComputedStyle(t), l = n.visibility;
  if (l === "hidden" || l === "collapse")
    return !0;
  var o = kn.call(t, "details>summary:first-of-type"), h = o ? t.parentElement : t;
  if (kn.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var v = t; t; ) {
        var u = t.parentElement, f = Ba(t);
        if (u && !u.shadowRoot && s(u) === !0)
          return Ni(t);
        t.assignedSlot ? t = t.assignedSlot : !u && f !== t.ownerDocument ? t = f.host : t = u;
      }
      t = v;
    }
    if (oc(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Ni(t);
  return !1;
}, cc = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var a = t.parentElement; a; ) {
      if (a.tagName === "FIELDSET" && a.disabled) {
        for (var r = 0; r < a.children.length; r++) {
          var s = a.children.item(r);
          if (s.tagName === "LEGEND")
            return kn.call(a, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      a = a.parentElement;
    }
  return !1;
}, Va = function(t, a) {
  return !(a.disabled || tc(a) || sc(a, t) || // For a details element with a summary, the summary element gets the focus
  nc(a) || cc(a));
}, Vr = function(t, a) {
  return !(lc(a) || pn(a) < 0 || !Va(t, a));
}, uc = function(t) {
  var a = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(a) || a >= 0);
}, co = function(t) {
  var a = [], r = [];
  return t.forEach(function(s, i) {
    var n = !!s.scopeParent, l = n ? s.scopeParent : s, o = Qs(l, n), h = n ? co(s.candidates) : l;
    o === 0 ? n ? a.push.apply(a, h) : a.push(l) : r.push({
      documentOrder: i,
      tabIndex: o,
      item: s,
      isScope: n,
      content: h
    });
  }), r.sort(ec).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(a);
}, dc = function(t, a) {
  a = a || {};
  var r;
  return a.getShadowRoot ? r = za([t], a.includeContainer, {
    filter: Vr.bind(null, a),
    flatten: !1,
    getShadowRoot: a.getShadowRoot,
    shadowRootFilter: uc
  }) : r = lo(t, a.includeContainer, Vr.bind(null, a)), co(r);
}, fc = function(t, a) {
  a = a || {};
  var r;
  return a.getShadowRoot ? r = za([t], a.includeContainer, {
    filter: Va.bind(null, a),
    flatten: !0,
    getShadowRoot: a.getShadowRoot
  }) : r = lo(t, a.includeContainer, Va.bind(null, a)), r;
}, Dn = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return kn.call(t, Na) === !1 ? !1 : Vr(a, t);
}, hc = /* @__PURE__ */ ro.concat("iframe:not([inert]):not([inert] *)").join(","), br = function(t, a) {
  if (a = a || {}, !t)
    throw new Error("No node provided");
  return kn.call(t, hc) === !1 ? !1 : Va(a, t);
};
function Hr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var a = 0, r = Array(t); a < t; a++) r[a] = e[a];
  return r;
}
function vc(e) {
  if (Array.isArray(e)) return Hr(e);
}
function Bi(e, t) {
  var a = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!a) {
    if (Array.isArray(e) || (a = uo(e)) || t) {
      a && (e = a);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(o) {
          throw o;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, n = !0, l = !1;
  return {
    s: function() {
      a = a.call(e);
    },
    n: function() {
      var o = a.next();
      return n = o.done, o;
    },
    e: function(o) {
      l = !0, i = o;
    },
    f: function() {
      try {
        n || a.return == null || a.return();
      } finally {
        if (l) throw i;
      }
    }
  };
}
function mc(e, t, a) {
  return (t = wc(t)) in e ? Object.defineProperty(e, t, {
    value: a,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = a, e;
}
function gc(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function bc() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pi(e, t) {
  var a = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), a.push.apply(a, r);
  }
  return a;
}
function zi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var a = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pi(Object(a), !0).forEach(function(r) {
      mc(e, r, a[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : Pi(Object(a)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(a, r));
    });
  }
  return e;
}
function pc(e) {
  return vc(e) || gc(e) || uo(e) || bc();
}
function yc(e, t) {
  if (typeof e != "object" || !e) return e;
  var a = e[Symbol.toPrimitive];
  if (a !== void 0) {
    var r = a.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function wc(e) {
  var t = yc(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function uo(e, t) {
  if (e) {
    if (typeof e == "string") return Hr(e, t);
    var a = {}.toString.call(e).slice(8, -1);
    return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? Array.from(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? Hr(e, t) : void 0;
  }
}
var Gt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, a) {
    var r = Gt.getActiveTrap(t);
    a !== r && Gt.pauseTrap(t);
    var s = t.indexOf(a);
    s === -1 || t.splice(s, 1), t.push(a);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, a) {
    var r = t.indexOf(a);
    r !== -1 && t.splice(r, 1), Gt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var a = Gt.getActiveTrap(t);
    a?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var a = Gt.getActiveTrap(t);
    a && !a._isManuallyPaused() && a._setPausedState(!1);
  }
}, xc = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, kc = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, aa = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, _c = function(t) {
  return aa(t) && !t.shiftKey;
}, Sc = function(t) {
  return aa(t) && t.shiftKey;
}, Vi = function(t) {
  return setTimeout(t, 0);
}, Yn = function(t) {
  for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++)
    r[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ea = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Cc = [], Ec = function(t, a) {
  var r = a?.document || document, s = a?.trapStack || Cc, i = zi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: _c,
    isKeyBackward: Sc
  }, a), n = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, l, o = function(E, L, z) {
    return E && E[L] !== void 0 ? E[L] : i[z || L];
  }, h = function(E, L) {
    var z = typeof L?.composedPath == "function" ? L.composedPath() : void 0;
    return n.containerGroups.findIndex(function(U) {
      var X = U.container, B = U.tabbableNodes;
      return X.contains(E) || z?.includes(X) || B.find(function(ie) {
        return ie === E;
      });
    });
  }, v = function(E) {
    var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, z = L.hasFallback, U = z === void 0 ? !1 : z, X = L.params, B = X === void 0 ? [] : X, ie = i[E];
    if (typeof ie == "function" && (ie = ie.apply(void 0, pc(B))), ie === !0 && (ie = void 0), !ie) {
      if (ie === void 0 || ie === !1)
        return ie;
      throw new Error("`".concat(E, "` was specified but was not a node, or did not return a node"));
    }
    var H = ie;
    if (typeof ie == "string") {
      try {
        H = r.querySelector(ie);
      } catch (Q) {
        throw new Error("`".concat(E, '` appears to be an invalid selector; error="').concat(Q.message, '"'));
      }
      if (!H && !U)
        throw new Error("`".concat(E, "` as selector refers to no known node"));
    }
    return H;
  }, u = function(E) {
    var L = E.activeElement;
    return L ? L.shadowRoot && L.shadowRoot.activeElement !== null ? u(L.shadowRoot) : L : null;
  }, f = function() {
    var E = v("initialFocus", {
      hasFallback: !0
    });
    if (E === !1)
      return !1;
    if (E === void 0 || E && !br(E, i.tabbableOptions)) {
      var L = u(r);
      if (h(L) >= 0)
        E = L;
      else {
        var z = n.tabbableGroups[0], U = z && z.firstTabbableNode;
        E = U || v("fallbackFocus");
      }
    } else E === null && (E = v("fallbackFocus"));
    if (!E)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return E;
  }, m = function() {
    if (n.containerGroups = n.containers.map(function(E) {
      var L = dc(E, i.tabbableOptions), z = fc(E, i.tabbableOptions), U = L.length > 0 ? L[0] : void 0, X = L.length > 0 ? L[L.length - 1] : void 0, B = z.find(function(Q) {
        return Dn(Q);
      }), ie = z.slice().reverse().find(function(Q) {
        return Dn(Q);
      }), H = !!L.find(function(Q) {
        return pn(Q) > 0;
      });
      return {
        container: E,
        tabbableNodes: L,
        focusableNodes: z,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: H,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: U,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: X,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: B,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ie,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(ae) {
          var ve = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, be = L.indexOf(ae);
          return be < 0 ? ve ? z.slice(z.indexOf(ae) + 1).find(function(se) {
            return Dn(se);
          }) : z.slice(0, z.indexOf(ae)).reverse().find(function(se) {
            return Dn(se);
          }) : L[be + (ve ? 1 : -1)];
        }
      };
    }), n.tabbableGroups = n.containerGroups.filter(function(E) {
      return E.tabbableNodes.length > 0;
    }), n.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (n.containerGroups.find(function(E) {
      return E.posTabIndexesFound;
    }) && n.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, c = function(E) {
    if (E !== !1 && E !== u(document)) {
      if (!E || !E.focus) {
        c(f());
        return;
      }
      E.focus({
        preventScroll: !!i.preventScroll
      }), n.mostRecentlyFocusedNode = E, xc(E) && E.select();
    }
  }, w = function(E) {
    var L = v("setReturnFocus", {
      params: [E]
    });
    return L || (L === !1 ? !1 : E);
  }, _ = function(E) {
    var L = E.target, z = E.event, U = E.isBackward, X = U === void 0 ? !1 : U;
    L = L || Ea(z), m();
    var B = null;
    if (n.tabbableGroups.length > 0) {
      var ie = h(L, z), H = ie >= 0 ? n.containerGroups[ie] : void 0;
      if (ie < 0)
        X ? B = n.tabbableGroups[n.tabbableGroups.length - 1].lastTabbableNode : B = n.tabbableGroups[0].firstTabbableNode;
      else if (X) {
        var Q = n.tabbableGroups.findIndex(function(we) {
          var Le = we.firstTabbableNode;
          return L === Le;
        });
        if (Q < 0 && (H.container === L || br(L, i.tabbableOptions) && !Dn(L, i.tabbableOptions) && !H.nextTabbableNode(L, !1)) && (Q = ie), Q >= 0) {
          var ae = Q === 0 ? n.tabbableGroups.length - 1 : Q - 1, ve = n.tabbableGroups[ae];
          B = pn(L) >= 0 ? ve.lastTabbableNode : ve.lastDomTabbableNode;
        } else aa(z) || (B = H.nextTabbableNode(L, !1));
      } else {
        var be = n.tabbableGroups.findIndex(function(we) {
          var Le = we.lastTabbableNode;
          return L === Le;
        });
        if (be < 0 && (H.container === L || br(L, i.tabbableOptions) && !Dn(L, i.tabbableOptions) && !H.nextTabbableNode(L)) && (be = ie), be >= 0) {
          var se = be === n.tabbableGroups.length - 1 ? 0 : be + 1, ge = n.tabbableGroups[se];
          B = pn(L) >= 0 ? ge.firstTabbableNode : ge.firstDomTabbableNode;
        } else aa(z) || (B = H.nextTabbableNode(L));
      }
    } else
      B = v("fallbackFocus");
    return B;
  }, g = function(E) {
    var L = Ea(E);
    if (!(h(L, E) >= 0)) {
      if (Yn(i.clickOutsideDeactivates, E)) {
        l.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Yn(i.allowOutsideClick, E) || E.preventDefault();
    }
  }, b = function(E) {
    var L = Ea(E), z = h(L, E) >= 0;
    if (z || L instanceof Document)
      z && (n.mostRecentlyFocusedNode = L);
    else {
      E.stopImmediatePropagation();
      var U, X = !0;
      if (n.mostRecentlyFocusedNode)
        if (pn(n.mostRecentlyFocusedNode) > 0) {
          var B = h(n.mostRecentlyFocusedNode), ie = n.containerGroups[B].tabbableNodes;
          if (ie.length > 0) {
            var H = ie.findIndex(function(Q) {
              return Q === n.mostRecentlyFocusedNode;
            });
            H >= 0 && (i.isKeyForward(n.recentNavEvent) ? H + 1 < ie.length && (U = ie[H + 1], X = !1) : H - 1 >= 0 && (U = ie[H - 1], X = !1));
          }
        } else
          n.containerGroups.some(function(Q) {
            return Q.tabbableNodes.some(function(ae) {
              return pn(ae) > 0;
            });
          }) || (X = !1);
      else
        X = !1;
      X && (U = _({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: n.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(n.recentNavEvent)
      })), c(U || n.mostRecentlyFocusedNode || f());
    }
    n.recentNavEvent = void 0;
  }, S = function(E) {
    var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    n.recentNavEvent = E;
    var z = _({
      event: E,
      isBackward: L
    });
    z && (aa(E) && E.preventDefault(), c(z));
  }, T = function(E) {
    (i.isKeyForward(E) || i.isKeyBackward(E)) && S(E, i.isKeyBackward(E));
  }, I = function(E) {
    kc(E) && Yn(i.escapeDeactivates, E) !== !1 && (E.preventDefault(), l.deactivate());
  }, $ = function(E) {
    var L = Ea(E);
    h(L, E) >= 0 || Yn(i.clickOutsideDeactivates, E) || Yn(i.allowOutsideClick, E) || (E.preventDefault(), E.stopImmediatePropagation());
  }, C = function() {
    if (n.active) {
      Gt.activateTrap(s, l);
      var E;
      return i.delayInitialFocus ? E = new Promise(function(L) {
        n.delayInitialFocusTimer = Vi(function() {
          c(f()), L();
        });
      }) : c(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", $, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), E;
    }
  }, F = function(E) {
    n.active && !n.paused && l._setSubtreeIsolation(!1), n.adjacentElements.clear(), n.alreadySilent.clear();
    var L = /* @__PURE__ */ new Set(), z = /* @__PURE__ */ new Set(), U = Bi(E), X;
    try {
      for (U.s(); !(X = U.n()).done; ) {
        var B = X.value;
        L.add(B);
        for (var ie = typeof ShadowRoot < "u" && B.getRootNode() instanceof ShadowRoot, H = B; H; ) {
          L.add(H);
          var Q = H.parentElement, ae = [];
          Q ? ae = Q.children : !Q && ie && (ae = H.getRootNode().children, Q = H.getRootNode().host, ie = typeof ShadowRoot < "u" && Q.getRootNode() instanceof ShadowRoot);
          var ve = Bi(ae), be;
          try {
            for (ve.s(); !(be = ve.n()).done; ) {
              var se = be.value;
              z.add(se);
            }
          } catch (ge) {
            ve.e(ge);
          } finally {
            ve.f();
          }
          H = Q;
        }
      }
    } catch (ge) {
      U.e(ge);
    } finally {
      U.f();
    }
    L.forEach(function(ge) {
      z.delete(ge);
    }), n.adjacentElements = z;
  }, V = function() {
    if (n.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", $, !0), r.removeEventListener("keydown", T, !0), r.removeEventListener("keydown", I), l;
  }, K = function(E) {
    var L = n.mostRecentlyFocusedNode;
    if (L) {
      var z = E.some(function(X) {
        var B = Array.from(X.removedNodes);
        return B.some(function(ie) {
          return ie === L || typeof ie.contains == "function" && ie.contains(L);
        });
      });
      if (z && n.containers.some(function(X) {
        return X?.isConnected;
      })) {
        m();
        var U = f();
        c(U);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(K) : void 0, G = function() {
    O && (O.disconnect(), n.active && !n.paused && n.containers.map(function(E) {
      O.observe(E, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return l = {
    get active() {
      return n.active;
    },
    get paused() {
      return n.paused;
    },
    activate: function(E) {
      if (n.active)
        return this;
      var L = o(E, "onActivate"), z = o(E, "onPostActivate"), U = o(E, "checkCanFocusTrap"), X = Gt.getActiveTrap(s), B = !1;
      if (X && !X.paused) {
        var ie;
        (ie = X._setSubtreeIsolation) === null || ie === void 0 || ie.call(X, !1), B = !0;
      }
      try {
        U || m(), n.active = !0, n.paused = !1, n.nodeFocusedBeforeActivation = u(r), L?.({
          trap: l
        });
        var H = function() {
          U && m();
          var ve = function() {
            l._setSubtreeIsolation(!0), G(), z?.({
              trap: l
            });
          }, be = C();
          be ? be.then(ve) : ve();
        };
        if (U)
          return U(n.containers.concat()).then(H, H), this;
        H();
      } catch (ae) {
        if (X === Gt.getActiveTrap(s) && B) {
          var Q;
          (Q = X._setSubtreeIsolation) === null || Q === void 0 || Q.call(X, !0);
        }
        throw ae;
      }
      return this;
    },
    deactivate: function(E) {
      if (!n.active)
        return this;
      var L = zi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, E);
      clearTimeout(n.delayInitialFocusTimer), n.delayInitialFocusTimer = void 0, n.paused || l._setSubtreeIsolation(!1), n.alreadySilent.clear(), V(), n.active = !1, n.paused = !1, G(), Gt.deactivateTrap(s, l);
      var z = o(L, "onDeactivate"), U = o(L, "onPostDeactivate"), X = o(L, "checkCanReturnFocus"), B = o(L, "delayReturnFocus"), ie = o(L, "returnFocus", "returnFocusOnDeactivate");
      z?.({
        trap: l
      });
      var H = function() {
        ie && c(w(n.nodeFocusedBeforeActivation)), U?.({
          trap: l
        });
      }, Q = function() {
        B && ie ? Vi(H) : H();
      };
      return ie && X ? (X(w(n.nodeFocusedBeforeActivation)).then(Q, Q), this) : (Q(), this);
    },
    pause: function(E) {
      return n.active ? (n.manuallyPaused = !0, this._setPausedState(!0, E)) : this;
    },
    unpause: function(E) {
      return n.active ? (n.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, E)) : this;
    },
    updateContainerElements: function(E) {
      var L = [].concat(E).filter(Boolean);
      return n.containers = L.map(function(z) {
        return typeof z == "string" ? r.querySelector(z) : z;
      }), i.isolateSubtrees && F(n.containers), n.active && (m(), n.paused || l._setSubtreeIsolation(!0)), G(), this;
    }
  }, Object.defineProperties(l, {
    _isManuallyPaused: {
      value: function() {
        return n.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(E, L) {
        if (n.paused === E)
          return this;
        if (n.paused = E, E) {
          var z = o(L, "onPause"), U = o(L, "onPostPause");
          z?.({
            trap: l
          }), V(), l._setSubtreeIsolation(!1), G(), U?.({
            trap: l
          });
        } else {
          var X = o(L, "onUnpause"), B = o(L, "onPostUnpause");
          X?.({
            trap: l
          });
          var ie = function() {
            m();
            var Q = function() {
              l._setSubtreeIsolation(!0), G(), B?.({
                trap: l
              });
            }, ae = C();
            ae ? ae.then(Q) : Q();
          };
          ie();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(E) {
        i.isolateSubtrees && n.adjacentElements.forEach(function(L) {
          var z;
          E ? i.isolateSubtrees === "aria-hidden" ? ((L.ariaHidden === "true" || ((z = L.getAttribute("aria-hidden")) === null || z === void 0 ? void 0 : z.toLowerCase()) === "true") && n.alreadySilent.add(L), L.setAttribute("aria-hidden", "true")) : ((L.inert || L.hasAttribute("inert")) && n.alreadySilent.add(L), L.setAttribute("inert", !0)) : n.alreadySilent.has(L) || (i.isolateSubtrees === "aria-hidden" ? L.removeAttribute("aria-hidden") : L.removeAttribute("inert"));
        });
      }
    }
  }), l.updateContainerElements(t), l;
};
function Tc(e, t = {}) {
  let a;
  const { immediate: r, ...s } = t, i = Hn(!1), n = Hn(!1), l = (u) => a && a.activate(u), o = (u) => a && a.deactivate(u), h = () => {
    a && (a.pause(), n.value = !0);
  }, v = () => {
    a && (a.unpause(), n.value = !1);
  };
  return Ve(J(() => Os(Ge(e)).map((u) => {
    const f = Ge(u);
    return typeof f == "string" ? f : Ql(f);
  }).filter(Ks)), (u) => {
    if (u.length)
      if (!a)
        a = Ec(u, {
          ...s,
          onActivate(f) {
            i.value = !0, t.onActivate && t.onActivate(f);
          },
          onDeactivate(f) {
            i.value = !1, t.onDeactivate && t.onDeactivate(f);
          }
        }), r && l();
      else {
        const f = a?.active;
        a?.updateContainerElements(u), !f && r && l();
      }
  }, { flush: "post" }), Rs(() => o()), {
    hasFocus: i,
    isPaused: n,
    activate: l,
    deactivate: o,
    pause: h,
    unpause: v
  };
}
const fo = /* @__PURE__ */ _e((e, { slots: t }) => {
  const a = Hn(), r = Jr(Tc(a, e.options));
  return () => {
    if (t.default) return Ss(e.as || "div", { ref: a }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Lc = 864e5, Ac = 6e4, $c = 36e5, Hi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Un(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Hi in e ? e[Hi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Dt(e, t) {
  return Un(e, e);
}
function Ic(e, t, a) {
  const r = Dt(e);
  return isNaN(t) ? Un(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Dc(e, t, a) {
  const r = Dt(e);
  if (isNaN(t)) return Un(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), i = Un(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const n = i.getDate();
  return s >= n ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), r);
}
function Gn(e, t, a) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: i = 0,
    days: n = 0,
    hours: l = 0,
    minutes: o = 0,
    seconds: h = 0
  } = t, v = Dt(e), u = s || r ? Dc(v, s + r * 12) : v, f = n || i ? Ic(u, n + i * 7) : u, m = o + l * 60, w = (h + m * 60) * 1e3;
  return Un(e, +f + w);
}
function Ui(e) {
  const t = Dt(e), a = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return a.setUTCFullYear(t.getFullYear()), +e - +a;
}
function cn(e, ...t) {
  const a = Un.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(a);
}
function qi(e, t) {
  const a = Dt(e);
  return a.setHours(0, 0, 0, 0), a;
}
function Mc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  ), i = qi(r), n = qi(s), l = +i - Ui(i), o = +n - Ui(n);
  return Math.round((l - o) / Lc);
}
function ra(e, t) {
  const a = +Dt(e) - +Dt(t);
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function Oc(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ai(e) {
  return !(!Oc(e) && typeof e != "number" || isNaN(+Dt(e)));
}
function Rc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  ), i = r.getFullYear() - s.getFullYear(), n = r.getMonth() - s.getMonth();
  return i * 12 + n;
}
function Fc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  );
  return r.getFullYear() - s.getFullYear();
}
function Nc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  ), i = ji(r, s), n = Math.abs(
    Mc(r, s)
  );
  r.setDate(r.getDate() - i * n);
  const l = +(ji(r, s) === -i), o = i * (n - l);
  return o === 0 ? 0 : o;
}
function ji(e, t) {
  const a = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return a < 0 ? -1 : a > 0 ? 1 : a;
}
function ri(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Bc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  ), i = (+r - +s) / $c;
  return ri(a?.roundingMethod)(i);
}
function ho(e, t) {
  return +Dt(e) - +Dt(t);
}
function Pc(e, t, a) {
  const r = ho(e, t) / Ac;
  return ri(a?.roundingMethod)(r);
}
function zc(e, t) {
  const a = Dt(e);
  return a.setHours(23, 59, 59, 999), a;
}
function Vc(e, t) {
  const a = Dt(e), r = a.getMonth();
  return a.setFullYear(a.getFullYear(), r + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function Hc(e, t) {
  const a = Dt(e);
  return +zc(a) == +Vc(a);
}
function Uc(e, t, a) {
  const [r, s, i] = cn(
    a?.in,
    e,
    e,
    t
  ), n = ra(s, i), l = Math.abs(
    Rc(s, i)
  );
  if (l < 1) return 0;
  s.getMonth() === 1 && s.getDate() > 27 && s.setDate(30), s.setMonth(s.getMonth() - n * l);
  let o = ra(s, i) === -n;
  Hc(r) && l === 1 && ra(r, i) === 1 && (o = !1);
  const h = n * (l - +o);
  return h === 0 ? 0 : h;
}
function qc(e, t, a) {
  const r = ho(e, t) / 1e3;
  return ri(a?.roundingMethod)(r);
}
function jc(e, t, a) {
  const [r, s] = cn(
    a?.in,
    e,
    t
  ), i = ra(r, s), n = Math.abs(Fc(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const l = ra(r, s) === -i, o = i * (n - +l);
  return o === 0 ? 0 : o;
}
function Zc(e, t) {
  const [a, r] = cn(e, t.start, t.end);
  return { start: a, end: r };
}
function Wc(e, t) {
  const { start: a, end: r } = Zc(t?.in, e), s = {}, i = jc(r, a);
  i && (s.years = i);
  const n = Gn(a, { years: s.years }), l = Uc(r, n);
  l && (s.months = l);
  const o = Gn(n, { months: s.months }), h = Nc(r, o);
  h && (s.days = h);
  const v = Gn(o, { days: s.days }), u = Bc(r, v);
  u && (s.hours = u);
  const f = Gn(v, { hours: s.hours }), m = Pc(r, f);
  m && (s.minutes = m);
  const c = Gn(f, { minutes: s.minutes }), w = qc(r, c);
  return w && (s.seconds = w), s;
}
function vo(e) {
  return +Dt(e) < Date.now();
}
function Xc(e, t, a) {
  let r = (s) => e(s, ...t);
  return a === void 0 ? r : Object.assign(r, { lazy: a, lazyArgs: t });
}
function Ga(e, t, a) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return Xc(e, t, a);
  throw Error("Wrong number of arguments");
}
function Zi(...e) {
  return Ga(Yc, e);
}
const Yc = (e, t) => e.length >= t;
function St(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Wi(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function Gc(...e) {
  return Ga(mo, e);
}
function mo(e, t) {
  let a = { ...e, ...t };
  for (let r in t) {
    if (!(r in e)) continue;
    let { [r]: s } = e;
    if (!Wi(s)) continue;
    let { [r]: i } = t;
    Wi(i) && (a[r] = mo(s, i));
  }
  return a;
}
function Qt(...e) {
  return Ga(Kc, e);
}
function Kc(e, t) {
  if (!Zi(t, 1)) return { ...e };
  if (!Zi(t, 2)) {
    let { [t[0]]: r, ...s } = e;
    return s;
  }
  let a = { ...e };
  for (let r of t) delete a[r];
  return a;
}
function Jc(...e) {
  return Ga(Qc, e);
}
function Qc(e, t) {
  let a = {};
  for (let r of t) r in e && (a[r] = e[r]);
  return a;
}
const go = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, je = Jr(go), C1 = (e) => {
  Object.assign(je, Gc(go, e));
}, eu = /* @__PURE__ */ Symbol(), pa = () => {
  const e = Qr();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Zn(eu) : null;
}, tu = () => pa() ? Fa("NuxtTime") : "time", bo = /* @__PURE__ */ _e({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => je.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), a = tu(), r = J(() => s.value ? i.value?.toISOString() : void 0), s = J(() => i.value ? ai(i.value) : !1), i = J(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (n, l) => s.value ? (A(), Se(Xt(q(a)), Ce({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: Ie(() => [
        me(n.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : ue("", !0);
  }
}), Wn = (e) => {
  const t = Qr(), a = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : a ? Fa("NuxtLink") : Fa("RouterLink");
}, ii = /* @__PURE__ */ _e({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Wn(e.to);
    return (a, r) => (A(), Se(Xt(q(t)), Ce(a.$attrs, a.$props), {
      default: Ie(() => [
        me(a.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ca = /* @__PURE__ */ _e({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = pe(!1), a = Fs(t, 1);
    return pt(() => {
      t.value = !0;
    }), (r, s) => (A(), Se(wn, Lt(Rt({ name: e.name, mode: e.mode })), {
      default: Ie(() => [
        q(a) ? me(r.$slots, "default", {}, void 0, void 0, 0) : ue("", !0)
      ]),
      _: 3
    }, 16));
  }
}), nu = {
  key: 0,
  class: "lc-feedback-message__content"
}, Ln = /* @__PURE__ */ _e({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = J(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (a, r) => (A(), j("div", {
      class: ye(t.value),
      role: "alert"
    }, [
      Oe(q(ca), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: Ie(() => [
          e.content ? (A(), j("p", nu, [
            e.variant === "error" ? (A(), Se(q(Je), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : ue("", !0),
            bt(" " + $e(e.content), 1)
          ])) : ue("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), au = /* @__PURE__ */ _e({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, a) => e.to ? (A(), Se(ba, {
      key: 0,
      to: e.to
    }, [
      me(t.$slots, "default")
    ], 8, ["to"])) : me(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), ru = ["height", "width"], iu = ["r", "stroke-width"], lu = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], po = /* @__PURE__ */ _e({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = J(() => Math.min(100, Math.max(0, e.progress))), a = J(() => e.radius - e.strokeWidth), r = J(() => 2 * Math.PI * a.value), s = J(
      () => r.value - t.value / 100 * r.value
    );
    return (i, n) => (A(), j("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ne("circle", {
        class: ye(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: a.value,
        "stroke-width": e.strokeWidth
      }, null, 10, iu),
      ne("circle", {
        class: ye(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: a.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": s.value,
        "stroke-width": e.strokeWidth
      }, null, 10, lu)
    ], 8, ru));
  }
}), ou = { class: "lc-timer-circle" }, su = ["aria-valuenow"], cu = { class: "lc-timer-circle__content" }, uu = /* @__PURE__ */ _e({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = pe(0), a = Ns(t, {
      duration: e.durationInMs,
      transition: Bs.linear
    });
    return pt(() => {
      t.value = 100;
    }), (r, s) => (A(), j("div", ou, [
      ne("div", {
        "aria-valuenow": q(a),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Oe(q(po), Ce({ progress: q(a) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, su),
      ne("div", cu, [
        me(r.$slots, "default")
      ])
    ]));
  }
}), du = (e, t) => e in t, en = (e, t) => typeof e == "string" && Object.values(t).includes(e), E1 = ["left", "right"], T1 = ["large", "medium", "small"], L1 = ["button", "reset", "submit"], A1 = ["click", "long-press"], $1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var Ur = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(Ur || {});
const fu = ["aria-valuenow"], hu = { class: "lc-button__content" }, vu = {
  key: 0,
  class: "lc-button__label-bubble"
}, mu = {
  key: 0,
  class: "lc-button__overlay"
}, gu = { class: "lc-button__long-press-hint" }, bu = {
  key: 1,
  class: "lc-button__overlay"
}, pu = {
  key: 0,
  class: "lc-button__loading-text"
}, Xi = 1e3 / 25, Ct = /* @__PURE__ */ _e({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: "left" },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => je.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: "large" },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const a = t, r = En(), s = pe(!!r.default), i = pe(!1), n = pe(!1), l = pe(!1), o = pe(!1), h = pe(0), v = pe(null), u = pe(), f = pe(), m = pe(), c = J(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": w.value,
        "lc-button--icon-only": !s.value,
        "lc-button--link": _.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && l.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), w = J(() => e.disabled || e.loading), _ = J(() => !!(e.href || e.to) && !w.value), g = J(
      () => n.value && !e.loading && e.trigger === "long-press"
    ), b = J(() => o.value || !!v.value), S = J(() => typeof e.to == "string" ? void 0 : e.to?.replace), T = J(() => {
      const U = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? U : {
        ...U,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = J(() => _.value ? Wn(e.to) : "button"), $ = () => {
      i.value = !1, l.value = !1, G(), E();
    }, C = (U) => {
      w.value || en(U.key, Ur) && (v.value || (v.value = U.key, V()));
    }, F = (U) => {
      en(U.key, Ur) && U.key === v.value && (G(), !o.value && P());
    }, V = (U = !1) => {
      e.trigger !== "click" && (U && window.addEventListener("pointerup", O), clearTimeout(f.value), l.value = !0);
    }, K = () => {
      w.value || (o.value = !0, V(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), E(), !v.value && P();
    }, G = () => {
      v.value = null;
    }, P = () => {
      !l.value && !i.value || (i.value ? n.value = !1 : f.value = setTimeout(() => {
        n.value = !1;
      }, e.longPressHintDelay), i.value = !1, l.value = !1);
    }, E = () => {
      o.value = !1;
    }, L = () => {
      w.value || V();
    }, z = () => {
      E(), P();
    };
    return Yl(() => {
      s.value = !!r.default;
    }), Tn(() => {
      clearInterval(u.value), clearTimeout(m.value), clearTimeout(f.value);
    }), Ve(l, (U) => {
      if (!w.value) {
        if (!U) {
          clearInterval(u.value), clearTimeout(m.value), h.value = 0;
          return;
        }
        n.value = !0, u.value = setInterval(() => {
          h.value += Xi / e.longPressDelay * 100;
        }, Xi), m.value = setTimeout(() => {
          clearInterval(u.value), i.value = !0, a("longpress");
        }, e.longPressDelay);
      }
    }), (U, X) => (A(), Se(Xt(I.value), Ce(U.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: T.value,
      replace: S.value
    }, {
      "aria-busy": e.loading,
      class: c.value,
      disabled: w.value,
      onBlur: $,
      onContextmenu: X[0] || (X[0] = oa(() => {
      }, ["prevent"])),
      onKeydown: C,
      onKeyup: F,
      onPointerdown: K,
      onPointerup: O,
      onTouchend: z,
      onTouchstartPassive: L
    }), {
      default: Ie(() => [
        e.trigger === "long-press" ? (A(), j("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, fu)) : ue("", !0),
        ne("div", hu, [
          e.icon ? (A(), Se(q(Je), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : ue("", !0),
          Oe(wn, { name: "font-size-fade" }, {
            default: Ie(() => [
              U.$slots.default ? (A(), j("span", vu, [
                me(U.$slots, "default"),
                Oe(q(zr), Ce({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : ue("", !0)
            ]),
            _: 3
          }),
          U.$slots.default ? ue("", !0) : (A(), Se(q(zr), Ce({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Oe(q(ca), { name: "fade" }, {
          default: Ie(() => [
            g.value ? (A(), j("div", mu, [
              ne("span", gu, $e(e.longPressHint), 1)
            ])) : ue("", !0),
            e.loading ? (A(), j("div", bu, [
              Oe(q(Je), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? (A(), j("span", pu, $e(e.loadingText), 1)) : ue("", !0)
            ])) : ue("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), li = /* @__PURE__ */ _e({
  __name: "LcSeparator",
  props: {
    variant: { default: "default" }
  },
  setup(e) {
    return (t, a) => (A(), j("hr", {
      class: ye(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), I1 = ["dashed", "default"], yt = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), a = crypto.randomUUID();
  return t ? `lc-${t.useId() || a}` : `lc-${a}`;
}, oi = (e, t) => {
  const a = e.__vccOpts || e;
  for (const [r, s] of t)
    a[r] = s;
  return a;
}, yu = {}, wu = { viewBox: "0 0 752 8" }, xu = { id: "perforation" }, ku = ["cx"];
function _u(e, t) {
  return A(), j("svg", wu, [
    ne("mask", xu, [
      t[0] || (t[0] = ne("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      (A(!0), j(Ye, null, ht(new Array(21), (a, r) => (A(), j("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, ku))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Su = /* @__PURE__ */ oi(yu, [["render", _u]]), Cu = {}, Eu = { viewBox: "0 0 752 8" }, Tu = { id: "perforation" }, Lu = ["points"];
function Au(e, t) {
  return A(), j("svg", Eu, [
    ne("mask", Tu, [
      t[0] || (t[0] = ne("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      (A(!0), j(Ye, null, ht(new Array(150), (a, r) => (A(), j("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, Lu))), 128))
    ]),
    t[1] || (t[1] = ne("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const Yi = /* @__PURE__ */ oi(Cu, [["render", Au]]), $u = ["id"], Iu = {
  key: 0,
  class: "lc-card__background"
}, Du = {
  key: 1,
  class: /* @__PURE__ */ ye(["lc-card__perforation", "lc-card__perforation--top"])
}, Mu = {
  key: 0,
  class: "lc-card__toggle"
}, Ou = {
  key: 3,
  class: "lc-card__body-wrap"
}, Ru = ["id"], ya = /* @__PURE__ */ _e({
  __name: "LcCard",
  props: /* @__PURE__ */ sa({
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => je.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = En(), a = yt(e.id), r = pe(!!t.default), s = Za(e, "modelValue"), i = J(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": e.expandable && s.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), n = () => {
      e.expandable && (s.value = !s.value);
    };
    return Yl(() => {
      r.value = !!t.default;
    }), (l, o) => (A(), j("article", {
      id: q(a),
      class: ye(i.value)
    }, [
      l.$slots.background ? (A(), j("div", Iu, [
        me(l.$slots, "background")
      ])) : ue("", !0),
      e.variant === "transaction" ? (A(), j("div", Du, [
        Oe(Yi)
      ])) : ue("", !0),
      l.$slots.header || e.expandable ? (A(), Se(Xt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${q(a)}-region` : void 0,
        "aria-expanded": e.expandable ? s.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: n
      }, {
        default: Ie(() => [
          e.headerTo && !e.expandable ? (A(), Se(q(ii), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: Ie(() => [
              ne("header", {
                class: ye(["lc-card__header", e.headerClass])
              }, [
                me(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : (A(), j("header", {
            key: 1,
            class: ye(["lc-card__header", e.headerClass])
          }, [
            me(l.$slots, "header"),
            e.expandable ? (A(), j(Ye, { key: 0 }, [
              l.$slots.toggle ? (A(), j("div", Mu, [
                me(l.$slots, "toggle")
              ])) : (A(), Se(q(Je), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : ue("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : ue("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || s.value) ? (A(), j("div", Ou, [
        l.$slots.default ? (A(), j("div", {
          key: 0,
          class: ye(["lc-card__body", e.bodyClass])
        }, [
          me(l.$slots, "default")
        ], 2)) : ue("", !0),
        l.$slots.footer ? (A(), j("footer", {
          key: 1,
          class: ye(["lc-card__footer", e.footerClass])
        }, [
          e.showSeparator ? (A(), Se(q(li), {
            key: 0,
            variant: "dashed"
          })) : ue("", !0),
          me(l.$slots, "footer")
        ], 2)) : ue("", !0),
        e.variant !== "default" ? (A(), j("div", {
          key: 2,
          id: `${q(a)}-region`,
          class: ye(["lc-card__perforation", "lc-card__perforation--bottom"])
        }, [
          e.variant == "order" ? (A(), Se(Su, { key: 0 })) : (A(), Se(Yi, { key: 1 }))
        ], 8, Ru)) : ue("", !0)
      ])) : ue("", !0)
    ], 10, $u));
  }
}), D1 = ["large", "medium", "none"], M1 = ["large", "none", "small"], O1 = ["default", "order", "transaction"], Fu = { class: "lc-modal__card-header-wrap" }, Nu = { class: "lc-modal__card-header-actions" }, yo = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => je.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => je.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => je.lcModal.noFocusTrap },
    spacing: { default: () => je.lcModal.spacing },
    to: { default: () => je.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const a = t, r = pe(), s = eo(() => document.documentElement), i = J(() => h("close-button")), o = {
      allowOutsideClick: (f) => {
        const m = f.target;
        return m ? Ge(e.ignoreOutsideClickOn).some((c) => (typeof c == "string" ? document.querySelector(c) : Ql(c))?.contains(m) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const f = document.createElement("button");
        return f.id = "lc-modal-fallback-focus", f.hidden = !0, f;
      })(),
      immediate: !0
    }, h = (f) => e.closeTriggers.includes(f), v = (f) => {
      h(f) && a("close");
    }, u = (f) => {
      r.value = f;
    };
    return Ya(r, () => v("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), to("Escape", () => v("escape")), Ve(
      () => e.isVisible,
      (f) => {
        s.value = f;
      },
      { immediate: !0 }
    ), (f, m) => e.isVisible ? (A(), Se(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Oe(q(ca), { name: "fade" }, {
        default: Ie(() => [
          ne("div", {
            class: ye([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize
              },
              e.backgroundClass
            ])
          }, [
            Oe(q(ca), Ce(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: Ie(() => [
                (A(), Se(Xt(e.noFocusTrap ? "div" : q(fo)), {
                  options: e.noFocusTrap ? null : o
                }, {
                  default: Ie(() => [
                    me(f.$slots, "modal", Lt(Rt({ setRef: u })), () => [
                      Oe(q(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: ye([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: Ie(() => [
                          f.$slots.header || i.value ? (A(), j("header", {
                            key: 0,
                            class: ye(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ne("div", Fu, [
                              me(f.$slots, "header")
                            ]),
                            ne("div", Nu, [
                              me(f.$slots, "actions"),
                              i.value ? (A(), Se(q(Ct), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: m[0] || (m[0] = (c) => v("close-button"))
                              })) : ue("", !0)
                            ])
                          ], 2)) : ue("", !0),
                          me(f.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 2)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ue("", !0);
  }
}), R1 = ["click-outside", "close-button", "escape"], F1 = ["large", "medium", "small"], Bu = 30, Pu = 0.3, Gi = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const s = parseFloat(t[1]);
    return t[2] === "px" ? s : s / 100 * window.innerHeight;
  }
  const a = document.createElement("div");
  a.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(a);
  const r = a.getBoundingClientRect().height;
  return a.remove(), r;
}, zu = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: a,
  canClose: r
}) => {
  const s = pe(0), i = pe(0), n = pe(!1), l = pe(0), o = pe(0), h = pe(0), v = pe(0), u = J(
    () => Ge(t)[l.value] ?? Ge(t)[0]
  ), f = J(() => l.value < Ge(t).length - 1), m = () => {
    i.value = 0, s.value = 0, n.value = !1;
  }, c = () => {
    l.value = 0;
  }, w = (S, T) => (T > 0 ? S / T : 0) > Pu || S > Bu, _ = () => {
    if (!n.value) return;
    const S = v.value - h.value, T = Date.now() - o.value, I = Math.abs(S), $ = S > 0 ? "down" : "up", C = Ge(t);
    if ($ === "up" && f.value && w(I, T)) {
      const V = Gi(C[l.value]) + I;
      let K = l.value + 1, O = 1 / 0;
      for (let G = l.value + 1; G < C.length; G++) {
        const P = Math.abs(Gi(C[G]) - V);
        P < O && (O = P, K = G);
      }
      l.value = K, m();
      return;
    }
    if ($ === "down" && w(I, T) && r()) {
      n.value = !1, a();
      return;
    }
    m();
  }, g = (S) => {
    if (S.target.closest('button, a, [role="button"]')) return;
    S.currentTarget.setPointerCapture(S.pointerId), h.value = S.clientY, v.value = S.clientY, o.value = Date.now(), n.value = !0;
  }, b = (S) => {
    if (!n.value) return;
    v.value = S.clientY;
    const T = v.value - h.value;
    T < 0 && f.value ? (i.value = -T, s.value = 0) : (i.value = 0, s.value = Math.max(0, T));
  };
  return on(e, "pointerdown", g), on(e, "pointermove", b), on(e, "pointerup", _), on(e, "pointercancel", _), on(e, "lostpointercapture", _), {
    currentSnapHeight: u,
    currentSnapIndex: l,
    dismissOffset: s,
    isDragging: n,
    resetDrag: m,
    resetSnapIndex: c,
    snapTransitionOffset: i
  };
}, Vu = { class: "lc-bottom-sheet-modal__header" }, Hu = { class: "lc-bottom-sheet-modal__header-actions" }, Uu = { class: "lc-bottom-sheet" }, qu = ["aria-labelledby"], ju = { class: "lc-bottom-sheet__header-actions" }, Ta = 300, Ki = "lc-bottom-sheet__drag-area", Zu = "(width < 496px)", N1 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => je.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const a = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${Ki}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], s = t;
    let i;
    const l = `${yt()}-header`, o = ut("dragArea"), h = pe(!1), v = pe(!1), u = pe(!0), f = Ps(Zu), m = eo(() => document.documentElement), {
      currentSnapHeight: c,
      dismissOffset: w,
      isDragging: _,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: S
    } = zu({
      dragAreaRef: o,
      snapHeights: J(() => e.snapHeights),
      onClose: () => $(),
      canClose: () => F("swipe-down")
    }), T = J(
      () => e.closeTriggers.filter(
        (K) => r.includes(K)
      )
    ), I = J(() => {
      if (_.value) {
        const O = S.value !== 0;
        return {
          height: O ? `calc(${c.value} + ${S.value}px)` : c.value,
          transform: O ? "translateY(0)" : `translateY(${Math.max(0, w.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: c.value,
          transform: "translateY(100%)",
          transition: `transform ${Ta}ms ease`
        };
      const K = u.value;
      return {
        height: c.value,
        transform: K ? "translateY(100%)" : "translateY(0)",
        transition: u.value ? "none" : `height ${Ta}ms ease, transform ${Ta}ms ease`
      };
    }), $ = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), s("update:modelValue", !1);
      }, Ta));
    }, C = () => {
      F("click-outside") && $();
    }, F = (K) => e.closeTriggers.includes(K), V = (K) => {
      const O = K.target;
      v.value = O.scrollTop > 0;
    };
    return Ve(
      () => e.modelValue,
      async (K) => {
        if (!K) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, u.value = !0, m.value = !0, await Wa(), requestAnimationFrame(() => {
          u.value = !1;
        });
      },
      { immediate: !0 }
    ), to("Escape", () => {
      F("escape") && $();
    }), Tn(() => {
      clearTimeout(i), m.value = !1;
    }), (K, O) => q(f) ? e.modelValue ? (A(), Se(ba, {
      key: 1,
      to: e.to
    }, [
      ne("div", Uu, [
        ne("div", {
          class: ye(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: C
        }, null, 2),
        Oe(q(fo), { options: a }, {
          default: Ie(() => [
            ne("div", {
              "aria-labelledby": K.$slots.title ? l : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: At(I.value)
            }, [
              ne("div", {
                ref: "dragArea",
                class: ye([
                  Ki,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                O[1] || (O[1] = ne("div", { class: "lc-bottom-sheet__handle" }, [
                  ne("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                K.$slots.title || F("close-button") ? (A(), j("div", {
                  key: 0,
                  id: l,
                  class: "lc-bottom-sheet__header"
                }, [
                  me(K.$slots, "title"),
                  ne("div", ju, [
                    me(K.$slots, "actions"),
                    F("close-button") ? (A(), Se(q(Ct), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: $
                    })) : ue("", !0)
                  ])
                ])) : ue("", !0)
              ], 2),
              ne("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: V
              }, [
                me(K.$slots, "default")
              ], 544)
            ], 12, qu)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : ue("", !0) : (A(), Se(q(yo), Ce({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": T.value,
      spacing: "small",
      onClose: O[0] || (O[0] = (G) => s("update:modelValue", !1))
    }), Xa({
      default: Ie(() => [
        ne("div", {
          class: ye(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: V
        }, [
          me(K.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      K.$slots.title ? {
        name: "header",
        fn: Ie(() => [
          ne("div", Vu, [
            me(K.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      K.$slots.actions ? {
        name: "actions",
        fn: Ie(() => [
          ne("div", Hu, [
            me(K.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), B1 = ["swipe-down", "click-outside", "escape"];
function wo(e = {}) {
  let t, a = [];
  const r = ["select", "slideFocus"];
  function s(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: u
    } = t.internalEngine();
    v !== "y" && (a = u.map((f) => f.height), r.forEach((f) => t.on(f, l)), l());
  }
  function i() {
    r.forEach((v) => t.off(v, l));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function n() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((u) => a[u]).reduce((u, f) => Math.max(u, f), 0) : null;
  }
  function l() {
    n() !== null && (t.containerNode().style.height = `${n()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: s,
    destroy: i
  };
}
wo.globalOptions = void 0;
const Wu = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Kn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Jn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function La(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Ka(e = {}) {
  let t, a, r, s, i = [], n = [];
  const l = ["select"], o = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function u(b, S) {
    a = b;
    const {
      mergeOptions: T,
      optionsAtMedia: I
    } = S, $ = T(Wu, Ka.globalOptions), C = T($, e);
    t = I(C), r = a.rootNode(), s = a.slideNodes();
    const {
      watchDrag: F,
      loop: V
    } = a.internalEngine().options, K = !!F;
    t.loop && V && (v.loop = Kn(t.loop), La(r, v.loop)), t.draggable && K && (v.draggable = Kn(t.draggable), La(r, v.draggable)), t.dragging && (v.dragging = Kn(t.dragging), o.forEach((O) => a.on(O, m))), t.snapped && (v.snapped = Kn(t.snapped), l.forEach((O) => a.on(O, w)), w()), t.inView && (v.inView = Kn(t.inView), h.forEach((O) => a.on(O, _)), _());
  }
  function f() {
    o.forEach((b) => a.off(b, m)), l.forEach((b) => a.off(b, w)), h.forEach((b) => a.off(b, _)), Jn(r, v.loop), Jn(r, v.draggable), Jn(r, v.dragging), c([], i, v.snapped), c([], n, v.inView), Object.keys(v).forEach((b) => {
      const S = b;
      v[S] = [];
    });
  }
  function m(b, S) {
    (S === "pointerDown" ? La : Jn)(r, v.dragging);
  }
  function c(b = [], S = [], T) {
    const I = S.map((C) => s[C]), $ = b.map((C) => s[C]);
    return I.forEach((C) => Jn(C, T)), $.forEach((C) => La(C, T)), b;
  }
  function w() {
    const {
      slideRegistry: b
    } = a.internalEngine(), S = b[a.selectedScrollSnap()];
    i = c(S, i, v.snapped);
  }
  function _() {
    const b = a.slidesInView();
    n = c(b, n, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: u,
    destroy: f
  };
}
Ka.globalOptions = void 0;
function Xu(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ji(e) {
  return Xu(e) || Array.isArray(e);
}
function Yu() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function si(e, t) {
  const a = Object.keys(e), r = Object.keys(t);
  if (a.length !== r.length) return !1;
  const s = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return s !== i ? !1 : a.every((n) => {
    const l = e[n], o = t[n];
    return typeof l == "function" ? `${l}` == `${o}` : !Ji(l) || !Ji(o) ? l === o : si(l, o);
  });
}
function Qi(e) {
  return e.concat().sort((t, a) => t.name > a.name ? 1 : -1).map((t) => t.options);
}
function Gu(e, t) {
  if (e.length !== t.length) return !1;
  const a = Qi(e), r = Qi(t);
  return a.every((s, i) => {
    const n = r[i];
    return si(s, n);
  });
}
function ci(e) {
  return typeof e == "number";
}
function qr(e) {
  return typeof e == "string";
}
function Ja(e) {
  return typeof e == "boolean";
}
function el(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function at(e) {
  return Math.abs(e);
}
function ui(e) {
  return Math.sign(e);
}
function ia(e, t) {
  return at(e - t);
}
function Ku(e, t) {
  if (e === 0 || t === 0 || at(e) <= at(t)) return 0;
  const a = ia(at(e), at(t));
  return at(a / e);
}
function Ju(e) {
  return Math.round(e * 100) / 100;
}
function ua(e) {
  return da(e).map(Number);
}
function Ht(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function di(e, t) {
  return t === wa(e);
}
function tl(e, t = 0) {
  return Array.from(Array(e), (a, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function xo(e, t) {
  return [e, t].reduce((a, r) => (da(r).forEach((s) => {
    const i = a[s], n = r[s], l = el(i) && el(n);
    a[s] = l ? xo(i, n) : n;
  }), a), {});
}
function jr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function Qu(e, t) {
  const a = {
    start: r,
    center: s,
    end: i
  };
  function r() {
    return 0;
  }
  function s(o) {
    return i(o) / 2;
  }
  function i(o) {
    return t - o;
  }
  function n(o, h) {
    return qr(e) ? a[e](o) : e(t, o, h);
  }
  return {
    measure: n
  };
}
function fa() {
  let e = [];
  function t(s, i, n, l = {
    passive: !0
  }) {
    let o;
    if ("addEventListener" in s)
      s.addEventListener(i, n, l), o = () => s.removeEventListener(i, n, l);
    else {
      const h = s;
      h.addListener(n), o = () => h.removeListener(n);
    }
    return e.push(o), r;
  }
  function a() {
    e = e.filter((s) => s());
  }
  const r = {
    add: t,
    clear: a
  };
  return r;
}
function ed(e, t, a, r) {
  const s = fa(), i = 1e3 / 60;
  let n = null, l = 0, o = 0;
  function h() {
    s.add(e, "visibilitychange", () => {
      e.hidden && c();
    });
  }
  function v() {
    m(), s.clear();
  }
  function u(_) {
    if (!o) return;
    n || (n = _, a(), a());
    const g = _ - n;
    for (n = _, l += g; l >= i; )
      a(), l -= i;
    const b = l / i;
    r(b), o && (o = t.requestAnimationFrame(u));
  }
  function f() {
    o || (o = t.requestAnimationFrame(u));
  }
  function m() {
    t.cancelAnimationFrame(o), n = null, l = 0, o = 0;
  }
  function c() {
    n = null, l = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: a,
    render: r
  };
}
function td(e, t) {
  const a = t === "rtl", r = e === "y", s = r ? "y" : "x", i = r ? "x" : "y", n = !r && a ? -1 : 1, l = v(), o = u();
  function h(c) {
    const {
      height: w,
      width: _
    } = c;
    return r ? w : _;
  }
  function v() {
    return r ? "top" : a ? "right" : "left";
  }
  function u() {
    return r ? "bottom" : a ? "left" : "right";
  }
  function f(c) {
    return c * n;
  }
  return {
    scroll: s,
    cross: i,
    startEdge: l,
    endEdge: o,
    measureSize: h,
    direction: f
  };
}
function _n(e = 0, t = 0) {
  const a = at(e - t);
  function r(h) {
    return h < e;
  }
  function s(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || s(h);
  }
  function n(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function l(h) {
    return a ? h - a * Math.ceil((h - t) / a) : h;
  }
  return {
    length: a,
    max: t,
    min: e,
    constrain: n,
    reachedAny: i,
    reachedMax: s,
    reachedMin: r,
    removeOffset: l
  };
}
function ko(e, t, a) {
  const {
    constrain: r
  } = _n(0, e), s = e + 1;
  let i = n(t);
  function n(f) {
    return a ? at((s + f) % s) : r(f);
  }
  function l() {
    return i;
  }
  function o(f) {
    return i = n(f), u;
  }
  function h(f) {
    return v().set(l() + f);
  }
  function v() {
    return ko(e, l(), a);
  }
  const u = {
    get: l,
    set: o,
    add: h,
    clone: v
  };
  return u;
}
function nd(e, t, a, r, s, i, n, l, o, h, v, u, f, m, c, w, _, g, b) {
  const {
    cross: S,
    direction: T
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], $ = {
    passive: !1
  }, C = fa(), F = fa(), V = _n(50, 225).constrain(m.measure(20)), K = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, G = c ? 43 : 25;
  let P = !1, E = 0, L = 0, z = !1, U = !1, X = !1, B = !1;
  function ie(fe) {
    if (!b) return;
    function Re(He) {
      (Ja(b) || b(fe, He)) && se(He);
    }
    const Be = t;
    C.add(Be, "dragstart", (He) => He.preventDefault(), $).add(Be, "touchmove", () => {
    }, $).add(Be, "touchend", () => {
    }).add(Be, "touchstart", Re).add(Be, "mousedown", Re).add(Be, "touchcancel", we).add(Be, "contextmenu", we).add(Be, "click", Le, !0);
  }
  function H() {
    C.clear(), F.clear();
  }
  function Q() {
    const fe = B ? a : t;
    F.add(fe, "touchmove", ge, $).add(fe, "touchend", we).add(fe, "mousemove", ge, $).add(fe, "mouseup", we);
  }
  function ae(fe) {
    const Re = fe.nodeName || "";
    return I.includes(Re);
  }
  function ve() {
    return (c ? O : K)[B ? "mouse" : "touch"];
  }
  function be(fe, Re) {
    const Be = u.add(ui(fe) * -1), He = v.byDistance(fe, !c).distance;
    return c || at(fe) < V ? He : _ && Re ? He * 0.5 : v.byIndex(Be.get(), 0).distance;
  }
  function se(fe) {
    const Re = jr(fe, r);
    B = Re, X = c && Re && !fe.buttons && P, P = ia(s.get(), n.get()) >= 2, !(Re && fe.button !== 0) && (ae(fe.target) || (z = !0, i.pointerDown(fe), h.useFriction(0).useDuration(0), s.set(n), Q(), E = i.readPoint(fe), L = i.readPoint(fe, S), f.emit("pointerDown")));
  }
  function ge(fe) {
    if (!jr(fe, r) && fe.touches.length >= 2) return we(fe);
    const Be = i.readPoint(fe), He = i.readPoint(fe, S), We = ia(Be, E), Pe = ia(He, L);
    if (!U && !B && (!fe.cancelable || (U = We > Pe, !U)))
      return we(fe);
    const Fe = i.pointerMove(fe);
    We > w && (X = !0), h.useFriction(0.3).useDuration(0.75), l.start(), s.add(T(Fe)), fe.preventDefault();
  }
  function we(fe) {
    const Be = v.byDistance(0, !1).index !== u.get(), He = i.pointerUp(fe) * ve(), We = be(T(He), Be), Pe = Ku(He, We), Fe = G - 10 * Pe, nt = g + Pe / 50;
    U = !1, z = !1, F.clear(), h.useDuration(Fe).useFriction(nt), o.distance(We, !c), B = !1, f.emit("pointerUp");
  }
  function Le(fe) {
    X && (fe.stopPropagation(), fe.preventDefault(), X = !1);
  }
  function Ze() {
    return z;
  }
  return {
    init: ie,
    destroy: H,
    pointerDown: Ze
  };
}
function ad(e, t) {
  let r, s;
  function i(u) {
    return u.timeStamp;
  }
  function n(u, f) {
    const c = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (jr(u, t) ? u : u.touches[0])[c];
  }
  function l(u) {
    return r = u, s = u, n(u);
  }
  function o(u) {
    const f = n(u) - n(s), m = i(u) - i(r) > 170;
    return s = u, m && (r = u), f;
  }
  function h(u) {
    if (!r || !s) return 0;
    const f = n(s) - n(r), m = i(u) - i(r), c = i(u) - i(s) > 170, w = f / m;
    return m && !c && at(w) > 0.1 ? w : 0;
  }
  return {
    pointerDown: l,
    pointerMove: o,
    pointerUp: h,
    readPoint: n
  };
}
function rd() {
  function e(a) {
    const {
      offsetTop: r,
      offsetLeft: s,
      offsetWidth: i,
      offsetHeight: n
    } = a;
    return {
      top: r,
      right: s + i,
      bottom: r + n,
      left: s,
      width: i,
      height: n
    };
  }
  return {
    measure: e
  };
}
function id(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function ld(e, t, a, r, s, i, n) {
  const l = [e].concat(r);
  let o, h, v = [], u = !1;
  function f(_) {
    return s.measureSize(n.measure(_));
  }
  function m(_) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const S of b) {
        if (u) return;
        const T = S.target === e, I = r.indexOf(S.target), $ = T ? h : v[I], C = f(T ? e : r[I]);
        if (at(C - $) >= 0.5) {
          _.reInit(), t.emit("resize");
          break;
        }
      }
    }
    o = new ResizeObserver((b) => {
      (Ja(i) || i(_, b)) && g(b);
    }), a.requestAnimationFrame(() => {
      l.forEach((b) => o.observe(b));
    });
  }
  function c() {
    u = !0, o && o.disconnect();
  }
  return {
    init: m,
    destroy: c
  };
}
function od(e, t, a, r, s, i) {
  let n = 0, l = 0, o = s, h = i, v = e.get(), u = 0;
  function f() {
    const $ = r.get() - e.get(), C = !o;
    let F = 0;
    return C ? (n = 0, a.set(r), e.set(r), F = $) : (a.set(e), n += $ / o, n *= h, v += n, e.add(n), F = v - u), l = ui(F), u = v, I;
  }
  function m() {
    const $ = r.get() - t.get();
    return at($) < 1e-3;
  }
  function c() {
    return o;
  }
  function w() {
    return l;
  }
  function _() {
    return n;
  }
  function g() {
    return S(s);
  }
  function b() {
    return T(i);
  }
  function S($) {
    return o = $, I;
  }
  function T($) {
    return h = $, I;
  }
  const I = {
    direction: w,
    duration: c,
    velocity: _,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: T,
    useDuration: S
  };
  return I;
}
function sd(e, t, a, r, s) {
  const i = s.measure(10), n = s.measure(50), l = _n(0.1, 0.99);
  let o = !1;
  function h() {
    return !(o || !e.reachedAny(a.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const c = e.reachedMin(t.get()) ? "min" : "max", w = at(e[c] - t.get()), _ = a.get() - t.get(), g = l.constrain(w / n);
    a.subtract(_ * g), !m && at(_) < i && (a.set(e.constrain(a.get())), r.useDuration(25).useBaseFriction());
  }
  function u(m) {
    o = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: u
  };
}
function cd(e, t, a, r, s) {
  const i = _n(-t + e, 0), n = u(), l = v(), o = f();
  function h(c, w) {
    return ia(c, w) <= 1;
  }
  function v() {
    const c = n[0], w = Ht(n), _ = n.lastIndexOf(c), g = n.indexOf(w) + 1;
    return _n(_, g);
  }
  function u() {
    return a.map((c, w) => {
      const {
        min: _,
        max: g
      } = i, b = i.constrain(c), S = !w, T = di(a, w);
      return S ? g : T || h(_, b) ? _ : h(g, b) ? g : b;
    }).map((c) => parseFloat(c.toFixed(3)));
  }
  function f() {
    if (t <= e + s) return [i.max];
    if (r === "keepSnaps") return n;
    const {
      min: c,
      max: w
    } = l;
    return n.slice(c, w);
  }
  return {
    snapsContained: o,
    scrollContainLimit: l
  };
}
function ud(e, t, a) {
  const r = t[0], s = a ? r - e : Ht(t);
  return {
    limit: _n(s, r)
  };
}
function dd(e, t, a, r) {
  const i = t.min + 0.1, n = t.max + 0.1, {
    reachedMin: l,
    reachedMax: o
  } = _n(i, n);
  function h(f) {
    return f === 1 ? o(a.get()) : f === -1 ? l(a.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((c) => c.add(m));
  }
  return {
    loop: v
  };
}
function fd(e) {
  const {
    max: t,
    length: a
  } = e;
  function r(i) {
    const n = i - t;
    return a ? n / -a : 0;
  }
  return {
    get: r
  };
}
function hd(e, t, a, r, s) {
  const {
    startEdge: i,
    endEdge: n
  } = e, {
    groupSlides: l
  } = s, o = u().map(t.measure), h = f(), v = m();
  function u() {
    return l(r).map((w) => Ht(w)[n] - w[0][i]).map(at);
  }
  function f() {
    return r.map((w) => a[i] - w[i]).map((w) => -at(w));
  }
  function m() {
    return l(h).map((w) => w[0]).map((w, _) => w + o[_]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function vd(e, t, a, r, s, i) {
  const {
    groupSlides: n
  } = s, {
    min: l,
    max: o
  } = r, h = v();
  function v() {
    const f = n(i), m = !e || t === "keepSnaps";
    return a.length === 1 ? [i] : m ? f : f.slice(l, o).map((c, w, _) => {
      const g = !w, b = di(_, w);
      if (g) {
        const S = Ht(_[0]) + 1;
        return tl(S);
      }
      if (b) {
        const S = wa(i) - Ht(_)[0] + 1;
        return tl(S, Ht(_)[0]);
      }
      return c;
    });
  }
  return {
    slideRegistry: h
  };
}
function md(e, t, a, r, s) {
  const {
    reachedAny: i,
    removeOffset: n,
    constrain: l
  } = r;
  function o(c) {
    return c.concat().sort((w, _) => at(w) - at(_))[0];
  }
  function h(c) {
    const w = e ? n(c) : l(c), _ = t.map((b, S) => ({
      diff: v(b - w, 0),
      index: S
    })).sort((b, S) => at(b.diff) - at(S.diff)), {
      index: g
    } = _[0];
    return {
      index: g,
      distance: w
    };
  }
  function v(c, w) {
    const _ = [c, c + a, c - a];
    if (!e) return c;
    if (!w) return o(_);
    const g = _.filter((b) => ui(b) === w);
    return g.length ? o(g) : Ht(_) - a;
  }
  function u(c, w) {
    const _ = t[c] - s.get(), g = v(_, w);
    return {
      index: c,
      distance: g
    };
  }
  function f(c, w) {
    const _ = s.get() + c, {
      index: g,
      distance: b
    } = h(_), S = !e && i(_);
    if (!w || S) return {
      index: g,
      distance: c
    };
    const T = t[g] - b, I = c + v(T, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: u,
    shortcut: v
  };
}
function gd(e, t, a, r, s, i, n) {
  function l(u) {
    const f = u.distance, m = u.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (a.set(t.get()), t.set(u.index), n.emit("select"));
  }
  function o(u, f) {
    const m = s.byDistance(u, f);
    l(m);
  }
  function h(u, f) {
    const m = t.clone().set(u), c = s.byIndex(m.get(), f);
    l(c);
  }
  return {
    distance: o,
    index: h
  };
}
function bd(e, t, a, r, s, i, n, l) {
  const o = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!l) return;
    function c(w) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      n.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = a.findIndex((S) => S.includes(w));
      ci(b) && (s.useDuration(0), r.index(b, 0), n.emit("slideFocus"));
    }
    i.add(document, "keydown", u, !1), t.forEach((w, _) => {
      i.add(w, "focus", (g) => {
        (Ja(l) || l(m, g)) && c(_);
      }, o);
    });
  }
  function u(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function ta(e) {
  let t = e;
  function a() {
    return t;
  }
  function r(o) {
    t = n(o);
  }
  function s(o) {
    t += n(o);
  }
  function i(o) {
    t -= n(o);
  }
  function n(o) {
    return ci(o) ? o : o.get();
  }
  return {
    get: a,
    set: r,
    add: s,
    subtract: i
  };
}
function _o(e, t) {
  const a = e.scroll === "x" ? n : l, r = t.style;
  let s = null, i = !1;
  function n(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function l(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function o(f) {
    if (i) return;
    const m = Ju(e.direction(f));
    m !== s && (r.transform = a(m), s = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: o,
    toggleActive: h
  };
}
function pd(e, t, a, r, s, i, n, l, o) {
  const v = ua(s), u = ua(s).reverse(), f = g().concat(b());
  function m(C, F) {
    return C.reduce((V, K) => V - s[K], F);
  }
  function c(C, F) {
    return C.reduce((V, K) => m(V, F) > 0 ? V.concat([K]) : V, []);
  }
  function w(C) {
    return i.map((F, V) => ({
      start: F - r[V] + 0.5 + C,
      end: F + t - 0.5 + C
    }));
  }
  function _(C, F, V) {
    const K = w(F);
    return C.map((O) => {
      const G = V ? 0 : -a, P = V ? a : 0, E = V ? "end" : "start", L = K[O][E];
      return {
        index: O,
        loopPoint: L,
        slideLocation: ta(-1),
        translate: _o(e, o[O]),
        target: () => l.get() > L ? G : P
      };
    });
  }
  function g() {
    const C = n[0], F = c(u, C);
    return _(F, a, !1);
  }
  function b() {
    const C = t - n[0] - 1, F = c(v, C);
    return _(F, -a, !0);
  }
  function S() {
    return f.every(({
      index: C
    }) => {
      const F = v.filter((V) => V !== C);
      return m(F, t) <= 0.1;
    });
  }
  function T() {
    f.forEach((C) => {
      const {
        target: F,
        translate: V,
        slideLocation: K
      } = C, O = F();
      O !== K.get() && (V.to(O), K.set(O));
    });
  }
  function I() {
    f.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: S,
    clear: I,
    loop: T,
    loopPoints: f
  };
}
function yd(e, t, a) {
  let r, s = !1;
  function i(o) {
    if (!a) return;
    function h(v) {
      for (const u of v)
        if (u.type === "childList") {
          o.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      s || (Ja(a) || a(o, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function n() {
    r && r.disconnect(), s = !0;
  }
  return {
    init: i,
    destroy: n
  };
}
function wd(e, t, a, r) {
  const s = {};
  let i = null, n = null, l, o = !1;
  function h() {
    l = new IntersectionObserver((c) => {
      o || (c.forEach((w) => {
        const _ = t.indexOf(w.target);
        s[_] = w;
      }), i = null, n = null, a.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((c) => l.observe(c));
  }
  function v() {
    l && l.disconnect(), o = !0;
  }
  function u(c) {
    return da(s).reduce((w, _) => {
      const g = parseInt(_), {
        isIntersecting: b
      } = s[g];
      return (c && b || !c && !b) && w.push(g), w;
    }, []);
  }
  function f(c = !0) {
    if (c && i) return i;
    if (!c && n) return n;
    const w = u(c);
    return c && (i = w), c || (n = w), w;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function xd(e, t, a, r, s, i) {
  const {
    measureSize: n,
    startEdge: l,
    endEdge: o
  } = e, h = a[0] && s, v = c(), u = w(), f = a.map(n), m = _();
  function c() {
    if (!h) return 0;
    const b = a[0];
    return at(t[l] - b[l]);
  }
  function w() {
    if (!h) return 0;
    const b = i.getComputedStyle(Ht(r));
    return parseFloat(b.getPropertyValue(`margin-${o}`));
  }
  function _() {
    return a.map((b, S, T) => {
      const I = !S, $ = di(T, S);
      return I ? f[S] + v : $ ? f[S] + u : T[S + 1][l] - b[l];
    }).map(at);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: u
  };
}
function kd(e, t, a, r, s, i, n, l, o) {
  const {
    startEdge: h,
    endEdge: v,
    direction: u
  } = e, f = ci(a);
  function m(g, b) {
    return ua(g).filter((S) => S % b === 0).map((S) => g.slice(S, S + b));
  }
  function c(g) {
    return g.length ? ua(g).reduce((b, S, T) => {
      const I = Ht(b) || 0, $ = I === 0, C = S === wa(g), F = s[h] - i[I][h], V = s[h] - i[S][v], K = !r && $ ? u(n) : 0, O = !r && C ? u(l) : 0, G = at(V - O - (F + K));
      return T && G > t + o && b.push(S), C && b.push(g.length), b;
    }, []).map((b, S, T) => {
      const I = Math.max(T[S - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function w(g) {
    return f ? m(g, a) : c(g);
  }
  return {
    groupSlides: w
  };
}
function _d(e, t, a, r, s, i, n) {
  const {
    align: l,
    axis: o,
    direction: h,
    startIndex: v,
    loop: u,
    duration: f,
    dragFree: m,
    dragThreshold: c,
    inViewThreshold: w,
    slidesToScroll: _,
    skipSnaps: g,
    containScroll: b,
    watchResize: S,
    watchSlides: T,
    watchDrag: I,
    watchFocus: $
  } = i, C = 2, F = rd(), V = F.measure(t), K = a.map(F.measure), O = td(o, h), G = O.measureSize(V), P = id(G), E = Qu(l, G), L = !u && !!b, z = u || !!b, {
    slideSizes: U,
    slideSizesWithGaps: X,
    startGap: B,
    endGap: ie
  } = xd(O, V, K, a, z, s), H = kd(O, G, _, u, V, K, B, ie, C), {
    snaps: Q,
    snapsAligned: ae
  } = hd(O, E, V, K, H), ve = -Ht(Q) + Ht(X), {
    snapsContained: be,
    scrollContainLimit: se
  } = cd(G, ve, ae, b, C), ge = L ? be : ae, {
    limit: we
  } = ud(ve, ge, u), Le = ko(wa(ge), v, u), Ze = Le.clone(), Ne = ua(a), fe = ({
    dragHandler: k,
    scrollBody: y,
    scrollBounds: Y,
    options: {
      loop: W
    }
  }) => {
    W || Y.constrain(k.pointerDown()), y.seek();
  }, Re = ({
    scrollBody: k,
    translate: y,
    location: Y,
    offsetLocation: W,
    previousLocation: ce,
    scrollLooper: R,
    slideLooper: le,
    dragHandler: p,
    animation: de,
    eventHandler: Ae,
    scrollBounds: d,
    options: {
      loop: re
    }
  }, te) => {
    const x = k.settled(), N = !d.shouldConstrain(), ee = re ? x : x && N, De = ee && !p.pointerDown();
    De && de.stop();
    const xe = Y.get() * te + ce.get() * (1 - te);
    W.set(xe), re && (R.loop(k.direction()), le.loop()), y.to(W.get()), De && Ae.emit("settle"), ee || Ae.emit("scroll");
  }, Be = ed(r, s, () => fe(D), (k) => Re(D, k)), He = 0.68, We = ge[Le.get()], Pe = ta(We), Fe = ta(We), nt = ta(We), xt = ta(We), kt = od(Pe, nt, Fe, xt, f, He), vt = md(u, ge, ve, we, xt), Ft = gd(Be, Le, Ze, kt, vt, xt, n), Mt = fd(we), wt = fa(), Ut = wd(t, a, n, w), {
    slideRegistry: $t
  } = vd(L, b, ge, se, H, Ne), st = bd(e, a, $t, Ft, kt, wt, n, $), D = {
    ownerDocument: r,
    ownerWindow: s,
    eventHandler: n,
    containerRect: V,
    slideRects: K,
    animation: Be,
    axis: O,
    dragHandler: nd(O, e, r, s, xt, ad(O, s), Pe, Be, Ft, kt, vt, Le, n, P, m, c, g, He, I),
    eventStore: wt,
    percentOfView: P,
    index: Le,
    indexPrevious: Ze,
    limit: we,
    location: Pe,
    offsetLocation: nt,
    previousLocation: Fe,
    options: i,
    resizeHandler: ld(t, n, s, a, O, S, F),
    scrollBody: kt,
    scrollBounds: sd(we, nt, xt, kt, P),
    scrollLooper: dd(ve, we, nt, [Pe, nt, Fe, xt]),
    scrollProgress: Mt,
    scrollSnapList: ge.map(Mt.get),
    scrollSnaps: ge,
    scrollTarget: vt,
    scrollTo: Ft,
    slideLooper: pd(O, G, ve, U, X, Q, ge, nt, a),
    slideFocus: st,
    slidesHandler: yd(t, n, T),
    slidesInView: Ut,
    slideIndexes: Ne,
    slideRegistry: $t,
    slidesToScroll: H,
    target: xt,
    translate: _o(O, t)
  };
  return D;
}
function Sd() {
  let e = {}, t;
  function a(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function s(h) {
    return r(h).forEach((v) => v(t, h)), o;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), o;
  }
  function n(h, v) {
    return e[h] = r(h).filter((u) => u !== v), o;
  }
  function l() {
    e = {};
  }
  const o = {
    init: a,
    emit: s,
    off: n,
    on: i,
    clear: l
  };
  return o;
}
const Cd = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Ed(e) {
  function t(i, n) {
    return xo(i, n || {});
  }
  function a(i) {
    const n = i.breakpoints || {}, l = da(n).filter((o) => e.matchMedia(o).matches).map((o) => n[o]).reduce((o, h) => t(o, h), {});
    return t(i, l);
  }
  function r(i) {
    return i.map((n) => da(n.breakpoints || {})).reduce((n, l) => n.concat(l), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: a,
    optionsMediaQueries: r
  };
}
function Td(e) {
  let t = [];
  function a(i, n) {
    return t = n.filter(({
      options: l
    }) => e.optionsAtMedia(l).active !== !1), t.forEach((l) => l.init(i, e)), n.reduce((l, o) => Object.assign(l, {
      [o.name]: o
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: a,
    destroy: r
  };
}
function Ha(e, t, a) {
  const r = e.ownerDocument, s = r.defaultView, i = Ed(s), n = Td(i), l = fa(), o = Sd(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: u
  } = i, {
    on: f,
    off: m,
    emit: c
  } = o, w = O;
  let _ = !1, g, b = h(Cd, Ha.globalOptions), S = h(b), T = [], I, $, C;
  function F() {
    const {
      container: Ne,
      slides: fe
    } = S;
    $ = (qr(Ne) ? e.querySelector(Ne) : Ne) || e.children[0];
    const Be = qr(fe) ? $.querySelectorAll(fe) : fe;
    C = [].slice.call(Be || $.children);
  }
  function V(Ne) {
    const fe = _d(e, $, C, r, s, Ne, o);
    if (Ne.loop && !fe.slideLooper.canLoop()) {
      const Re = Object.assign({}, Ne, {
        loop: !1
      });
      return V(Re);
    }
    return fe;
  }
  function K(Ne, fe) {
    _ || (b = h(b, Ne), S = v(b), T = fe || T, F(), g = V(S), u([b, ...T.map(({
      options: Re
    }) => Re)]).forEach((Re) => l.add(Re, "change", O)), S.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(Ze), g.eventHandler.init(Ze), g.resizeHandler.init(Ze), g.slidesHandler.init(Ze), g.options.loop && g.slideLooper.loop(), $.offsetParent && C.length && g.dragHandler.init(Ze), I = n.init(Ze, T)));
  }
  function O(Ne, fe) {
    const Re = H();
    G(), K(h({
      startIndex: Re
    }, Ne), fe), o.emit("reInit");
  }
  function G() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), n.destroy(), l.clear();
  }
  function P() {
    _ || (_ = !0, l.clear(), G(), o.emit("destroy"), o.clear());
  }
  function E(Ne, fe, Re) {
    !S.active || _ || (g.scrollBody.useBaseFriction().useDuration(fe === !0 ? 0 : S.duration), g.scrollTo.index(Ne, Re || 0));
  }
  function L(Ne) {
    const fe = g.index.add(1).get();
    E(fe, Ne, -1);
  }
  function z(Ne) {
    const fe = g.index.add(-1).get();
    E(fe, Ne, 1);
  }
  function U() {
    return g.index.add(1).get() !== H();
  }
  function X() {
    return g.index.add(-1).get() !== H();
  }
  function B() {
    return g.scrollSnapList;
  }
  function ie() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function H() {
    return g.index.get();
  }
  function Q() {
    return g.indexPrevious.get();
  }
  function ae() {
    return g.slidesInView.get();
  }
  function ve() {
    return g.slidesInView.get(!1);
  }
  function be() {
    return I;
  }
  function se() {
    return g;
  }
  function ge() {
    return e;
  }
  function we() {
    return $;
  }
  function Le() {
    return C;
  }
  const Ze = {
    canScrollNext: U,
    canScrollPrev: X,
    containerNode: we,
    internalEngine: se,
    destroy: P,
    off: m,
    on: f,
    emit: c,
    plugins: be,
    previousScrollSnap: Q,
    reInit: w,
    rootNode: ge,
    scrollNext: L,
    scrollPrev: z,
    scrollProgress: ie,
    scrollSnapList: B,
    scrollTo: E,
    selectedScrollSnap: H,
    slideNodes: Le,
    slidesInView: ae,
    slidesNotInView: ve
  };
  return K(t, a), setTimeout(() => o.emit("init"), 0), Ze;
}
Ha.globalOptions = void 0;
function Qa(e = {}, t = []) {
  const a = Ri(e), r = Ri(t);
  let s = a ? e.value : e, i = r ? t.value : t;
  const n = Hn(), l = Hn();
  function o() {
    l.value && l.value.reInit(s, i);
  }
  return pt(() => {
    !Yu() || !n.value || (Ha.globalOptions = Qa.globalOptions, l.value = Ha(n.value, s, i));
  }), Gl(() => {
    l.value && l.value.destroy();
  }), a && Ve(e, (h) => {
    si(s, h) || (s = h, o());
  }), r && Ve(t, (h) => {
    Gu(i, h) || (i = h, o());
  }), [n, l];
}
Qa.globalOptions = void 0;
const P1 = ["default", "highlight"], z1 = ["click", "keyboard"], Zr = /* @__PURE__ */ Symbol();
var Ma = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ma || {});
const Ld = ["tabindex"], nl = 1.08, Ad = /* @__PURE__ */ _e({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = {
      align: "start",
      containScroll: "trimSnaps"
    }, i = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, n = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: !e.disableSwipe,
      watchResize: ({ containerNode: ae, emit: ve, reInit: be }, se) => {
        if (!e.adaptiveHeight) return !0;
        for (const ge of se) {
          if (ae() === ge.target) return !0;
          requestAnimationFrame(() => {
            be(), ve("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? i : s
    }, l = [
      ...e.adaptiveHeight ? [wo()] : [],
      Ka({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [o, h] = Qa(
      {
        ...n,
        startIndex: e.defaultIndex
      },
      l
    ), v = Zn(Zr, () => null, !0), u = no(), f = pe(0), m = pe(e.disableSwipe), c = pe(!1), w = pe(!1), _ = pe(), g = pe(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((ae, ve) => ve)
      )
    ), b = J(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--draggable": !m.value,
        "lc-carousel--keyboard-enabled": E("keyboard"),
        "lc-carousel--swipe-hint": w.value
      }
    ]), S = () => {
      e.disableSwipe || (h.value?.reInit({
        ...n,
        watchDrag: !1
      }), m.value = !0);
    }, T = () => {
      e.disableSwipe || (h.value?.reInit({
        ...n,
        watchDrag: !0
      }), m.value = !1);
    }, I = (ae, ve) => e.keyExtractor ? e.keyExtractor(ae, ve) : e.keyProp && du(e.keyProp, ae) ? String(ae[e.keyProp]) : String(ve), $ = (ae) => {
      const ve = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return L(ae) ? ve : {
        ...ve,
        "aria-hidden": "true",
        inert: "true"
      };
    }, C = ({ clientX: ae }) => {
      if (!h.value || !E("click") || m.value) return;
      const be = h.value.slideNodes().map((se) => se.getBoundingClientRect());
      for (const [se, { left: ge, right: we }] of be.entries())
        if (!(ae < ge || ae > we)) {
          U(se);
          break;
        }
    }, F = () => {
      c.value = !0, H(), Q(), r("ready");
    }, V = (ae) => {
      if (!(!en(ae.key, Ma) || !E("keyboard") || m.value))
        switch (ae.preventDefault(), ae.stopPropagation(), ae.key) {
          case Ma.ArrowLeft:
            B();
            break;
          case Ma.ArrowRight:
            X();
            break;
        }
    }, K = () => {
      v?.disable();
    }, O = () => {
      v?.enable();
    }, G = () => {
      H(), Q();
    }, P = () => {
      const ae = h.value?.selectedScrollSnap() ?? 0;
      r("changed", ae);
    }, E = (ae) => e.moveTriggers.includes(ae), L = (ae) => g.value.has(ae), z = (ae) => !ae || u.value === "reduce", U = (ae, ve = !0) => {
      h.value?.scrollTo(ae, z(ve));
    }, X = (ae = !0) => {
      h.value?.scrollNext(z(ae));
    }, B = (ae = !0) => {
      h.value?.scrollPrev(z(ae));
    }, ie = async () => {
      w.value || (w.value = !0, await new Promise((ae) => {
        _.value = setTimeout(() => {
          w.value = !1, ae();
        }, 1800);
      }));
    }, H = () => {
      if (!h.value || e.variant !== "highlight") return;
      const { rootNode: ae, slideNodes: ve } = h.value, be = ve(), ge = ae().getBoundingClientRect(), we = ge.left + ge.width / 2;
      let Le = be[0], Ze = 1 / 0;
      be.forEach((Be) => {
        const He = Be.getBoundingClientRect(), We = He.left + He.width / 2, Pe = Math.abs(We - we);
        Pe < Ze && (Le = Be, Ze = Pe);
      });
      const Re = Le.offsetWidth * (nl - 1) / 2;
      be.forEach((Be, He) => {
        if (Be === Le) {
          f.value = He, Be.style.transform = `scale(${nl.toString()}) translateX(0px)`, Be.style.zIndex = "1";
          return;
        }
        const We = Be.getBoundingClientRect(), Fe = We.left + We.width / 2 < we ? -1 : 1;
        Be.style.transform = `scale(1) translateX(${(Fe * Re).toString()}px)`, Be.style.zIndex = "0";
      });
    }, Q = () => {
      if (!h.value) return;
      const ae = h.value.slidesInView();
      if (!ae.length) return;
      const ve = e.slides.length, be = /* @__PURE__ */ new Set();
      ae.forEach((se) => {
        for (let ge = -e.visibleSlideBuffer; ge <= e.visibleSlideBuffer; ge++) {
          const we = (se + ge + ve) % ve;
          be.add(we);
        }
      }), g.value = be;
    };
    return pt(() => {
      h.value && h.value.on("init", F).on("pointerDown", K).on("pointerUp", O).on("reInit", G).on("resize", Q).on("scroll", H).on("select", P).on("slidesChanged", H).on("slidesInView", Q);
    }), Tn(() => {
      clearTimeout(_.value);
    }), Ve(
      [() => e.disableSwipe, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([ae, ve, be, se]) => {
        m.value = ae, h.value?.reInit({
          ...n,
          loop: ve,
          skipSnaps: be,
          watchDrag: !ae,
          ...se === "highlight" ? i : s
        });
      }
    ), t({
      disable: S,
      enable: T,
      moveToIndex: U,
      next: X,
      prev: B,
      showSwipeHint: ie
    }), ei(Zr, {
      disable: S,
      enable: T
    }), (ae, ve) => (A(), j("div", {
      class: ye(b.value),
      tabindex: E("keyboard") ? 0 : void 0,
      onClickPassive: C,
      onKeydown: V
    }, [
      ne("div", {
        ref_key: "emblaRef",
        ref: o,
        class: "lc-carousel__container"
      }, [
        ne("div", Ce({ id: e.id }, { class: "lc-carousel__wrap" }), [
          (A(!0), j(Ye, null, ht(e.slides, (be, se) => me(ae.$slots, "slide", Ce({ ref_for: !0 }, { slide: be, index: se }, {
            key: I(be, se),
            attributes: $(se),
            isHighlighted: f.value === se,
            isVisible: L(se)
          }))), 128))
        ], 16)
      ], 512)
    ], 42, Ld));
  }
}), $d = ["for"], Id = { class: "lc-checkbox__control" }, Dd = ["id", "data-click-name"], Md = ["id"], V1 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = yt(e.id), { vibrate: s } = ao(), i = J(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), n = J({
      get: () => e.value,
      set: (l) => {
        a("update:value", l), s();
      }
    });
    return (l, o) => (A(), j("div", {
      class: ye([i.value, l.$attrs.class])
    }, [
      ne("label", {
        class: "lc-checkbox__wrap",
        for: q(r)
      }, [
        ne("div", Id, [
          Jt(ne("input", Ce({ id: q(r) }, {
            ...Qt(l.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": o[0] || (o[0] = (h) => n.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: o[1] || (o[1] = ti((h) => n.value = !n.value, ["enter"]))
          }), null, 16, Dd), [
            [Kl, n.value]
          ]),
          Oe(q(Je), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? (A(), j("span", {
          key: 0,
          id: `${q(r)}-label`,
          class: "lc-checkbox__label"
        }, $e(e.label), 9, Md)) : ue("", !0)
      ], 8, $d),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Od = () => typeof window > "u";
function So(e, t) {
  const a = pa(), r = typeof e == "string" ? e : void 0, s = typeof e == "function" ? e : t;
  if (a)
    return r ? a.useState(r, s) : a.useState(s);
  const i = s ? Ge(s()) : void 0;
  return pe(i);
}
const fi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, Co = (e, t) => Wc({
  end: new Date(t),
  start: new Date(e)
}), Eo = ({ date: e, format: t, locale: a, timeZone: r }) => new Intl.DateTimeFormat(a ?? "en-US", {
  ...fi[t],
  timeZone: r
}).format(new Date(e)), pr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), Rd = /* @__PURE__ */ _e({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const a = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, s = Od(), i = So(() => /* @__PURE__ */ new Date()), n = pe(), l = pe(!1), o = J(() => {
      if (l.value) return a;
      const { hours: g, minutes: b, seconds: S } = Co(i.value, f.value);
      return {
        ...a,
        hours: g || 0,
        minutes: b || 0,
        seconds: S || 0
      };
    }), h = J(() => v.value ? f.value.toISOString() : void 0), v = J(() => ai(f.value)), u = J(() => {
      const { hours: g, minutes: b, seconds: S } = o.value, T = `${pr(b)}:${pr(S)}`;
      return e.variant === "without-hours" ? T : `${pr(g)}:${T}`;
    }), f = J(() => new Date(e.expiresAt)), m = () => {
      l.value = !0, r("expired"), clearInterval(n.value);
    }, c = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, w = () => vo(f.value), _ = () => {
      n.value && clearTimeout(n.value), n.value = setInterval(() => {
        w() ? m() : c();
      }, 1e3);
    };
    return Gl(() => {
      clearInterval(n.value);
    }), Ve(
      h,
      () => {
        s || (l.value = !1, _());
      },
      {
        immediate: !0
      }
    ), (g, b) => v.value ? (A(), j("time", Ce({ key: 0 }, { datetime: h.value }, { class: "lc-countdown" }), $e(u.value), 17)) : ue("", !0);
  }
}), H1 = ["default", "without-hours"], Fd = { class: "lc-data-list" }, U1 = /* @__PURE__ */ _e({
  __name: "LcDataList",
  setup(e) {
    return (t, a) => (A(), j("ul", Fd, [
      me(t.$slots, "default")
    ]));
  }
}), Nd = { class: "lc-data-list-item" }, Bd = { class: "lc-data-list-item__content" }, Pd = {
  key: 0,
  class: "lc-data-list-item__headline"
}, zd = {
  key: 0,
  class: "lc-data-list-item__text"
}, Vd = { key: 0 }, Hd = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, q1 = /* @__PURE__ */ _e({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, a) => (A(), j("li", Nd, [
      ne("div", Bd, [
        ne("section", null, [
          e.headline ? (A(), j("span", Pd, $e(e.headline), 1)) : ue("", !0),
          me(t.$slots, "default", {}, () => [
            e.text ? (A(), j("p", zd, $e(e.text), 1)) : ue("", !0)
          ])
        ]),
        t.$slots.suffix ? (A(), j("aside", Vd, [
          me(t.$slots, "suffix")
        ])) : ue("", !0)
      ]),
      t.$slots.underneath ? (A(), j("div", Hd, [
        me(t.$slots, "underneath")
      ])) : ue("", !0)
    ]));
  }
});
var Ud = Object.defineProperty, qd = (e, t, a) => t in e ? Ud(e, t, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[t] = a, la = (e, t, a) => qd(e, typeof t != "symbol" ? t + "" : t, a);
const al = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, rl = (e, t, a) => e.replaceAll(t, "").replace(a, ".").replace("..", ".").replace(/[^.\d]/g, ""), il = (e, t, a) => {
  var r;
  return new Intl.NumberFormat(((r = a.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, jd = (e, t = !0, a) => {
  var r, s, i, n;
  const l = ((r = a.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", o = ((s = a.number) == null ? void 0 : s.fraction) ?? 0;
  let h = il(0, o, a);
  const v = h.formatToParts(1000.12), u = ((i = v.find((_) => _.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((n = v.find((_) => _.type === "decimal")) == null ? void 0 : n.value) ?? ".", m = rl(e, u, f);
  if (Number.isNaN(parseFloat(m))) return l;
  const c = m.split(".");
  if (c[1] != null && c[1].length >= 1) {
    const _ = c[1].length <= o ? c[1].length : o;
    h = il(_, o, a);
  }
  let w = h.format(parseFloat(m));
  return t ? o > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (w += f) : w = rl(w, u, f), l + w;
}, To = (e) => JSON.parse(e.replaceAll("'", '"')), Zd = (e, t = {}) => {
  const a = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (a.mask = Wd(e.dataset.maska)), e.dataset.maskaEager != null && (a.eager = Aa(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (a.reversed = Aa(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (a.tokensReplace = Aa(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (a.tokens = Xd(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = Aa(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (a.number = r), a;
}, Aa = (e) => e !== "" ? !!JSON.parse(e) : !0, Wd = (e) => e.startsWith("[") && e.endsWith("]") ? To(e) : e, Xd = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return To(e);
  const t = {};
  return e.split("|").forEach((a) => {
    const r = a.split(":");
    t[r[0]] = {
      pattern: Lo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, Lo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class Yd {
  constructor(t = {}) {
    la(this, "opts", {}), la(this, "memo", /* @__PURE__ */ new Map());
    const a = { ...t };
    if (a.tokens != null) {
      a.tokens = a.tokensReplace ? { ...a.tokens } : { ...al, ...a.tokens };
      for (const r of Object.values(a.tokens))
        typeof r.pattern == "string" && (r.pattern = Lo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      a.tokens = al;
    Array.isArray(a.mask) && (a.mask.length > 1 ? a.mask = [...a.mask].sort((r, s) => r.length - s.length) : a.mask = a.mask[0] ?? ""), a.mask === "" && (a.mask = null), this.opts = a;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const a = this.findMask(String(t));
    if (this.opts.mask == null || a == null) return !1;
    const r = this.process(String(t), a).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= a.length;
  }
  findMask(t) {
    const a = this.opts.mask;
    if (a == null)
      return null;
    if (typeof a == "string")
      return a;
    if (typeof a == "function")
      return a(t);
    const r = this.process(t, a.slice(-1).pop() ?? "", !1);
    return a.find((s) => this.process(t, s, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const a = [], r = [];
    return t.split("").forEach((s, i) => {
      s === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : a.push(s);
    }), { mask: a.join(""), escaped: r };
  }
  process(t, a, r = !0) {
    if (this.opts.number != null) return jd(t, r, this.opts);
    if (a == null) return t;
    const s = `v=${t},mr=${a},m=${r ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: i, escaped: n } = this.escapeMask(a), l = [], o = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", u = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => _ > -1 && g > -1 : () => _ < i.length && g < t.length, m = (S) => !this.isReversed() && S <= u || this.isReversed() && S >= u;
    let c, w = -1, _ = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const S = i.charAt(_), T = o[S], I = T?.transform != null ? T.transform(t.charAt(g)) : t.charAt(g);
      if (!n.includes(_) && T != null ? (I.match(T.pattern) != null ? (l[v](I), T.repeated ? (w === -1 ? w = _ : _ === u && _ !== w && (_ = w - h), u === w && (_ -= h)) : T.multiple && (b = !0, _ -= h), _ += h) : T.multiple ? b && (_ += h, g -= h, b = !1) : I === c ? c = void 0 : T.optional && (_ += h, g -= h), g += h) : (r && !this.isEager() && l[v](S), I === S && !this.isEager() ? g += h : c = S, this.isEager() || (_ += h)), this.isEager())
        for (; m(_) && (o[i.charAt(_)] == null || n.includes(_)); ) {
          if (r) {
            if (l[v](i.charAt(_)), t.charAt(g) === i.charAt(_)) {
              _ += h, g += h;
              continue;
            }
          } else i.charAt(_) === t.charAt(g) && (g += h);
          _ += h;
        }
    }
    return this.memo.set(s, l.join("")), this.memo.get(s);
  }
}
class Gd {
  constructor(t, a = {}) {
    la(this, "items", /* @__PURE__ */ new Map()), la(this, "eventAbortController"), la(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const s = r.target, i = this.items.get(s);
      if (i === void 0) return;
      const n = "inputType" in r && r.inputType.startsWith("delete"), l = i.isEager(), o = n && l && i.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, n, () => this.setValue(s, o));
    }), this.options = a, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var a;
    t.value !== "" && t.value !== ((a = this.processInput(t)) == null ? void 0 : a.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const a = this.getOptions(this.options);
    for (const r of t) {
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const s = new Yd(Zd(r, a));
      this.items.set(r, s), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: a, preProcess: r, postProcess: s, ...i } = t;
    return i;
  }
  fixCursor(t, a, r) {
    var s, i;
    const n = t.selectionStart, l = t.value;
    if (r(), n === null || n === l.length && !a) return;
    const o = t.value, h = l.slice(0, n), v = o.slice(0, n), u = (s = this.processInput(t, h)) == null ? void 0 : s.unmasked, f = (i = this.processInput(t, v)) == null ? void 0 : i.unmasked;
    if (u === void 0 || f === void 0) return;
    let m = n;
    h !== v && (m += a ? o.length - l.length : u.length - f.length), t.setSelectionRange(m, m);
  }
  setValue(t, a) {
    const r = this.processInput(t, a);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, a) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let s = a ?? t.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let i = r.masked(s);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(s),
      completed: r.completed(s)
    };
  }
}
const yr = /* @__PURE__ */ new WeakMap(), Kd = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const a = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : a && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, Jd = (e, t) => {
  var a;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || r?.type === "file") return;
  let s = {};
  if (t.value != null && (s = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (n) => {
      const l = t.modifiers.unmasked ? n.unmasked : t.modifiers.completed ? n.completed : n.masked;
      Kd(t, l);
    };
    s.onMaska = s.onMaska == null ? i : Array.isArray(s.onMaska) ? [...s.onMaska, i] : [s.onMaska, i];
  }
  yr.has(r) ? (a = yr.get(r)) == null || a.update(s) : yr.set(r, new Gd(r, s));
}, Qd = ["for"], ef = ["id"], tf = { class: "lc-input__input-wrap" }, nf = ["data-testid"], af = ["data-testid"], er = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = { Z: { pattern: "[1-9]" } }, s = a, i = ut("input"), n = yt(e.id), l = pe(!1), o = J(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = J(() => ({
      "aria-labelledby": e.label ? `${n}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: n,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => l.value = !0,
      onFocusout: () => l.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = J(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": l.value || !!e.value || typeof e.value == "number"
      }
    ]), u = J(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = J({
      get: () => e.value,
      set: (c) => {
        s("update:value", c);
      }
    }), m = (c) => c.mask !== void 0;
    return pt(() => {
      e.autofocus && i.value?.focus(), e.value && s("update:value", e.value);
    }), t({ ref: i }), (c, w) => (A(), j("div", {
      class: ye([o.value, c.$attrs.class])
    }, [
      ne("label", {
        class: "lc-input__wrap",
        for: q(n)
      }, [
        e.label ? (A(), j("span", {
          key: 0,
          id: `${q(n)}-label`,
          class: ye(v.value)
        }, $e(e.label), 11, ef)) : ue("", !0),
        ne("div", tf, [
          c.$slots.prefix ? (A(), j("div", {
            key: 0,
            class: ye(["lc-input__prefix", e.prefixClass])
          }, [
            me(c.$slots, "prefix")
          ], 2)) : ue("", !0),
          e.mask ? Jt((A(), j("input", Ce({
            key: 1,
            ref: "input"
          }, {
            ...Qt(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": w[0] || (w[0] = (_) => f.value = _),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, nf)), [
            [Fi, f.value],
            [q(Jd), u.value]
          ]) : Jt((A(), j("input", Ce({
            key: 2,
            ref: "input"
          }, {
            ...Qt(c.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": w[1] || (w[1] = (_) => f.value = _),
            "data-testid": c.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, af)), [
            [Fi, f.value]
          ]),
          c.$slots.suffix ? (A(), j("div", {
            key: 3,
            class: ye(["lc-input__suffix", e.suffixClass])
          }, [
            me(c.$slots, "suffix")
          ], 2)) : ue("", !0)
        ])
      ], 8, Qd),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), j1 = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], Z1 = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], W1 = /* @__PURE__ */ _e({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (a, r) => (A(), Se(q(er), Ce({ ...a.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), rf = { class: "lc-description-list" }, X1 = /* @__PURE__ */ _e({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, a) => (A(), j("dl", rf, [
      me(t.$slots, "default")
    ]));
  }
}), Ao = /* @__PURE__ */ Symbol();
var rn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(rn || {});
const Y1 = /* @__PURE__ */ _e({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = ga(e, ["index"]), i = ut("input"), n = Zn(Ao, () => null, !0), l = J(() => Ge(n?.config)), o = J(() => s.disabled || !!Ge(n?.disabled)), h = J(() => o.value ? "*" : "#"), v = J({
      get: () => o.value ? "X" : f.value,
      set: (c) => {
        if (o.value || c === "X") return;
        const w = typeof c == "number" ? c : null;
        r("update:value", w), n?.updateValue(e.index, w);
      }
    }), u = J(() => n ? `${Ge(n.name)}_input_${e.index}` : s.name), f = J(() => n ? Ge(n.value)?.[e.index] : s.value), m = (c) => {
      if (en(c.key, rn))
        switch (c.key !== rn.Dead && c.preventDefault(), c.key) {
          case rn.ArrowLeft:
            n?.focusPrevious(e.index);
            break;
          case rn.ArrowRight:
            n?.focusNext(e.index);
            break;
          case rn.Backspace:
          case rn.Delete:
            v.value = null;
            break;
          case rn.Dead: {
            const w = c.target;
            w?.blur(), setTimeout(() => w?.focus(), 1);
            break;
          }
          default: {
            const w = parseInt(c.key);
            v.value = w, n?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: o,
      index: e.index,
      inputRef: i
    }), (c, w) => (A(), Se(q(er), Ce({ ref: "input" }, { ...c.$attrs, ...s, ...l.value, disabled: o.value, mask: h.value, name: u.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: o.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), lf = ["id"], of = ["id"], sf = ["aria-labelledby"], G1 = /* @__PURE__ */ _e({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = pe([]), i = yt(e.id), n = (f, m) => {
      const c = [...e.value ?? []];
      c[f] = m, r("update:value", c);
    }, l = () => {
      const f = s.value.findIndex((m) => !m.disabled);
      s.value[f]?.inputRef?.ref?.focus();
    }, o = (f) => {
      if (f < 0 || f >= s.value.length) return;
      const m = s.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (n(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const w = s.value.slice(0, f).reverse().find(({ disabled: _ }) => !_)?.index;
      typeof w == "number" && (o(w), n(w, null));
    }, v = (f, m = !0) => {
      const c = m ? f + 1 : f - 1;
      if (c < 0 || c >= s.value.length) return;
      const w = s.value[c];
      if (w.disabled) {
        v(c, m);
        return;
      }
      w.inputRef?.ref?.focus();
    }, u = (f) => {
      const m = f;
      m?.inputRef?.ref && (s.value[m.index] = m);
    };
    return pt(l), t({ focusFirstEnabledInput: l, focusInputByIndex: o }), ei(Ao, {
      config: Jl(
        J(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => (A(), j("fieldset", Ce(f.$attrs, {
      id: q(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? (A(), j("legend", {
        key: 0,
        id: `${q(i)}-label`,
        class: ye(["lc-digit-input-group__label", e.legendClass])
      }, [
        me(f.$slots, "legend")
      ], 10, of)) : ue("", !0),
      ne("div", {
        "aria-labelledby": f.$slots.legend ? `${q(i)}-label` : void 0,
        class: ye(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        me(f.$slots, "default", Lt(Rt({ setRef: u })))
      ], 10, sf),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, lf));
  }
}), cf = ["id"], uf = ["aria-controls", "aria-expanded"], df = ["id"], ff = /* @__PURE__ */ _e({
  __name: "LcExpandable",
  props: /* @__PURE__ */ sa({
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = yt(e.id), a = Za(e, "modelValue"), r = J(() => [
      "lc-expandable",
      {
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": a.value
      }
    ]), s = () => {
      a.value = !a.value;
    };
    return (i, n) => (A(), j("article", Ce(i.$attrs, {
      id: q(t),
      class: r.value
    }), [
      ne("button", Ce({
        "aria-controls": `${q(t)}-region`
      }, { disabled: e.disabled }, {
        "aria-expanded": a.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: s
      }), [
        me(i.$slots, "header"),
        e.disabled ? ue("", !0) : (A(), Se(q(Je), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        }))
      ], 16, uf),
      Jt(ne("section", {
        id: `${q(t)}-region`,
        class: ye(["lc-expandable__content", e.contentClass]),
        role: "region"
      }, [
        me(i.$slots, "default")
      ], 10, df), [
        [ni, a.value]
      ])
    ], 16, cf));
  }
}), hf = { class: "lc-expandable-list" }, K1 = /* @__PURE__ */ _e({
  __name: "LcExpandableList",
  setup(e) {
    return (t, a) => (A(), j("div", hf, [
      me(t.$slots, "default")
    ]));
  }
}), vf = () => {
  const e = pe(!1);
  return pt(() => {
    e.value = !0;
  }), Tn(() => {
    e.value = !1;
  }), e;
}, mf = {
  key: 0,
  class: "lc-fly-out__illustration"
}, gf = { class: "lc-fly-out__message" }, J1 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => je.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => je.lcFlyOut.to },
    visibleInSeconds: { default: () => je.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const a = t, r = vf(), s = J(() => e.visibleInSeconds * 1e3), { start: i, stop: n } = ea(
      () => {
        a("update:isVisible", !1);
      },
      s,
      { immediate: !1 }
    );
    return Tn(n), Ve(
      () => e.isVisible,
      (l) => {
        l ? i() : n();
      },
      { immediate: !0 }
    ), (l, o) => q(r) ? (A(), Se(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Oe(q(ca), { name: "slide-down-lg" }, {
        default: Ie(() => [
          e.isVisible ? (A(), j("div", Ce({ key: 0 }, l.$attrs, { class: "lc-fly-out__container" }), [
            Oe(q(uu), {
              class: "lc-fly-out__timer",
              "duration-in-ms": s.value
            }, {
              default: Ie(() => [
                Oe(q(Ct), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: o[0] || (o[0] = (h) => l.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            l.$slots.default ? (A(), j("div", mf, [
              me(l.$slots, "default")
            ])) : ue("", !0),
            ne("p", gf, $e(e.message), 1)
          ], 16)) : ue("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : ue("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function ll(e) {
  return Number(e) >= 0;
}
function bf(e) {
  return typeof e == "object" && e !== null;
}
function pf(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function ol(e) {
  if (!bf(e) || pf(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function $o(e, t) {
  return Object.keys(t).forEach((a) => {
    if (ol(t[a]) && ol(e[a])) {
      e[a] || (e[a] = {}), $o(e[a], t[a]);
      return;
    }
    e[a] = t[a];
  }), e;
}
function yf(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var s;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const n = i;
        if (n.name !== "ValidationError")
          throw i;
        if (!(!((s = n.inner) === null || s === void 0) && s.length) && n.errors.length)
          return { errors: [{ path: n.path, errors: n.errors }] };
        const l = n.inner.reduce((o, h) => {
          const v = h.path || "";
          return o[v] || (o[v] = { errors: [], path: v }), o[v].errors.push(...h.errors), o;
        }, {});
        return { errors: Object.values(l) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? $o(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return sl(e.spec);
        const s = wf(r, e);
        return s ? sl(s) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function sl(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function wf(e, t) {
  if (!cl(t))
    return null;
  if (js(e)) {
    const s = t.fields[Zs(e)];
    return s?.spec || null;
  }
  const a = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let s = 0; s < a.length; s++) {
    const i = a[s];
    if (cl(r) && i in r.fields ? r = r.fields[i] : xf(r) && ll(i) ? r = r.spec.types[Number(i)] : ll(i) && kf(r) && (r = r.innerType), s === a.length - 1)
      return r.spec;
  }
  return null;
}
function xf(e) {
  return ha(e) && e.type === "tuple";
}
function cl(e) {
  return ha(e) && e.type === "object";
}
function kf(e) {
  return ha(e) && e.type === "array";
}
const Q1 = /* @__PURE__ */ _e({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const a = e, { isFieldValid: r, isSubmitting: s, meta: i, resetField: n, resetForm: l, setErrors: o, validate: h, values: v } = Ws({
      initialValues: a.initialValues,
      validateOnMount: a.validateOnMount,
      validationSchema: a.validationSchema ? yf(a.validationSchema) : void 0
    }), u = async (f) => {
      f.preventDefault();
      try {
        s.value = !0;
        const { valid: m, values: c } = await h();
        m && a.onSubmit && await a.onSubmit(c), m && a.resetOnSubmit && l();
      } finally {
        s.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: n,
      resetForm: l,
      setErrors: o,
      validate: h,
      values: v
    }), (f, m) => (A(), j("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: u
    }, [
      me(f.$slots, "default", Lt(Rt({ isSubmitting: q(s), meta: q(i), values: q(v) })))
    ], 32));
  }
}), eg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Io = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Io || {});
const Nt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, _f = { class: "lc-form-field" }, tg = /* @__PURE__ */ _e({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const a = {
      aggressive: () => [Nt.Blur, Nt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Change],
      lazy: () => [Nt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: s,
      handleChange: i,
      meta: n,
      value: l
    } = Xs(() => e.name, {}, { validateOnValueUpdate: !1 }), o = {
      [Nt.Blur]: (f) => u(f, !0),
      [Nt.Change]: (f) => i(f, !0),
      [Nt.Update]: (f) => i(f, !0)
    }, h = J(() => ({
      errorMessage: r.value,
      name: e.name,
      value: l.value,
      ...v.value
    })), v = J(() => {
      const f = {
        [Nt.Blur]: (m) => u(m, !1),
        [Nt.Update]: (m) => i(m, !1)
      };
      return a[e.mode]({
        errorMessage: r,
        meta: n
      }).forEach((m) => {
        f[m] = o[m];
      }), f;
    }), u = async (f, m) => {
      if (s(f, m), await Wa(), !f) return;
      const c = new CustomEvent(Io.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(c);
    };
    return t({ field: h }), (f, m) => (A(), j("div", _f, [
      me(f.$slots, "default", Lt(Rt({ field: h.value })))
    ]));
  }
}), Sf = ["id"], Cf = { ref: "wrapper" }, Ef = { class: "lc-header__wrap" }, Tf = { class: "lc-header__left-button-wrap" }, Lf = { class: "lc-header__headline-wrap" }, Af = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, $f = ["id", "aria-labelledby"], If = { class: "lc-header__fly-out-content-container" }, ng = /* @__PURE__ */ _e({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => je.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => je.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = ut("wrapper"), a = yt(e.id), r = pe(!1), s = J(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ya(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...Ge(e.ignoreOutsideClickOn)] }
    ), (n, l) => (A(), j("header", {
      id: q(a),
      class: ye(s.value)
    }, [
      ne("div", Cf, [
        ne("div", Ef, [
          ne("div", Tf, [
            Oe(q(Ct), Ce({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: l[0] || (l[0] = (o) => n.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ne("div", Lf, [
            ne("h1", {
              class: ye(["lc-header__headline", e.headlineClass])
            }, [
              me(n.$slots, "headline")
            ], 2)
          ]),
          me(n.$slots, "right", {}, () => [
            e.withFlyOut ? (A(), j("div", Af, [
              Oe(q(Ct), {
                id: `${q(a)}-toggle`,
                "aria-controls": `${q(a)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: ye(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: Ie(() => [
                  me(n.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : ue("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? (A(), j("div", {
          key: 0,
          id: `${q(a)}-region`,
          "aria-labelledby": `${q(a)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ne("div", If, [
            ne("div", {
              class: ye(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              me(n.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, $f)) : ue("", !0)
      ], 512),
      me(n.$slots, "default")
    ], 10, Sf));
  }
}), Df = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = J(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (a, r) => (A(), j("div", {
      class: ye(t.value),
      style: At({
        "--ball-opacity": e.opacity
      })
    }, $e(e.content), 7));
  }
}), Mf = { class: "lc-high-frequency-ball-background" }, Do = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, a) => (A(), j("div", Mf, [
      (A(!0), j(Ye, null, ht(e.ballConfig, (r, s) => (A(), Se(Df, {
        key: s,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: At({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ne("div", {
        class: ye(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), Of = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, Rf = { class: "lc-lottery-jackpot__value" }, Ff = { class: "lc-lottery-jackpot__currency" }, Nf = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, ul = 10 ** 9, dl = 10 ** 6, Bf = "mil millones", Pf = "mil M", Mo = /* @__PURE__ */ _e({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = ul * 100, a = dl * 100, r = J(() => {
      let n;
      const l = e.value >= t, o = e.value >= a;
      switch (!0) {
        case l:
          n = Math.floor(e.value / ul) / 100;
          break;
        case o:
          n = Math.floor(e.value / dl) / 100;
          break;
        default:
          n = e.value / 100;
          break;
      }
      const [h, v] = n.toFixed(2).split("."), u = v.replace(/0+$/, ""), f = o || l;
      let m = u;
      !f && u.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && u.length > 1 && (m = u.slice(0, 1));
      const c = m.length > 0 ? [h, m].join(".") : h, w = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: w,
        minimumFractionDigits: w
      }).format(Number(c));
    }), s = J(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: n }) => n === "currency")?.value ?? e.currency
    ), i = J(() => {
      if (e.value < a) return null;
      const n = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return n === Bf ? Pf : n;
    });
    return (n, l) => (A(), j("div", {
      class: ye([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? (A(), j("span", Of, $e(e.placeholder), 1)) : (A(), j(Ye, { key: 1 }, [
        ne("span", Rf, [
          ne("span", Ff, $e(s.value), 1),
          ne("span", null, $e(r.value), 1)
        ]),
        i.value ? (A(), j("span", Nf, $e(i.value), 1)) : ue("", !0)
      ], 64))
    ], 2));
  }
}), ag = ["large", "medium", "small"], Oo = () => typeof window < "u", zf = { class: "lc-info-button__modal" }, Vf = { class: "lc-info-button__modal-header" }, Hf = { class: "lc-info-button__modal-headline" }, Uf = { class: "lc-info-button__modal-text" }, Ro = /* @__PURE__ */ _e({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => je.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => je.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = Oo(), a = pe(!1), r = () => {
      a.value = !1;
    }, s = () => {
      e.disabled || (a.value = !0);
    };
    return (i, n) => (A(), j("div", {
      class: ye(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Oe(q(Ct), Ce({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: s
      }), null, 16, ["aria-label"]),
      q(t) && a.value ? (A(), Se(q(yo), Ce({ key: 0 }, { to: e.to, isVisible: a.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: Ie(() => [
          ne("div", zf, [
            ne("header", Vf, [
              ne("span", Hf, $e(e.headline), 1),
              Oe(q(Ct), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            me(i.$slots, "default", {}, () => [
              ne("p", Uf, $e(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : ue("", !0)
    ], 2));
  }
}), rg = ["default", "prominent"], qf = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", jf = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", Zf = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", Wf = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", Xf = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, Yf = ["src"], Gf = {
  key: 2,
  class: "lc-teaser-badge__text"
}, Kf = ["src"], Jf = 8, an = 10, Qf = 20, e0 = /* @__PURE__ */ _e({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = J(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": a.value
      }
    ]), a = J(() => s.value.length > 1), r = J(() => {
      switch (e.variant) {
        case "fire":
          return qf;
        case "pie":
          return Zf;
        case "star":
          return Wf;
        default:
          return null;
      }
    }), s = J(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, Qf);
      if (i.length <= Jf) return [i];
      const l = i.split(" ").filter(Boolean);
      if (l.length === 1)
        return [
          i.slice(0, an),
          i.slice(an)
        ];
      let o = "";
      const h = [];
      return l.forEach((v) => {
        if (o.length + v.length + (o.length ? 1 : 0) <= an) {
          o.length > 0 && (o += " "), o += v;
          return;
        }
        if (v.length > an) {
          if (o.length > 0) {
            let u = 0;
            o.length < an && (o += " ", u = an - o.length, o += v.slice(0, u)), h.push(o), h.push(v.slice(u)), o = "";
            return;
          }
          h.push(v.slice(0, an)), o = v.slice(an);
          return;
        }
        h.push(o), o = v;
      }), o.length > 0 && h.push(o), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, n) => (A(), j("div", {
      class: ye(t.value)
    }, [
      e.variant === "price-tag" ? (A(), j("svg", Xf, [...n[0] || (n[0] = [
        ne("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : ue("", !0),
      r.value ? (A(), j("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, Yf)) : ue("", !0),
      e.variant !== "new" ? (A(), j("span", Gf, $e(s.value.join(`
`)), 1)) : (A(), j("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: q(jf),
        width: "48"
      }, null, 8, Kf)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? (A(), Se(q(Ro), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ue("", !0)
    ], 2));
  }
}), ig = ["fire", "lightning", "money", "star"], lg = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], og = ["bottom-m", "bottom-xl", "top-m", "top-xl"], Fo = ["badge", "default", "hero"];
var No = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(No || {});
const t0 = { class: "lc-teaser-hero-badge__text-wrap" }, n0 = /* @__PURE__ */ _e({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => No.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, a) => (A(), j("div", {
      class: ye(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: At({
        "--teaser-badge-color": e.color
      })
    }, [
      ne("div", t0, [
        ne("span", null, $e(e.title), 1),
        ne("span", null, $e(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? (A(), Se(q(Ro), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${q(je).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : ue("", !0)
    ], 6));
  }
}), a0 = (e) => !!e.title && !!e.subtitle, r0 = { class: "lc-teaser__background" }, tr = /* @__PURE__ */ _e({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = En(), a = J(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, s) => (A(), Se(q(ya), Ce({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: a.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Xa({
      default: Ie(() => [
        me(r.$slots, "default"),
        e.badge ? (A(), j(Ye, { key: 0 }, [
          q(a0)(e.badge) ? (A(), Se(n0, Lt(Ce({ key: 0 }, e.badge)), null, 16)) : (A(), Se(e0, Lt(Ce({ key: 1 }, e.badge)), null, 16))
        ], 64)) : ue("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: Ie(() => [
          ne("div", r0, [
            me(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: Ie(() => [
          me(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: Ie(() => [
          me(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), i0 = { class: "lc-high-frequency-teaser__background" }, l0 = { class: "lc-high-frequency-teaser__jackpot-section" }, o0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, s0 = { class: "lc-high-frequency-teaser__button-container" }, c0 = { class: "lc-high-frequency-teaser__button-wrap" }, u0 = { class: "lc-high-frequency-teaser__hint-container" }, d0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, sg = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    En();
    const t = J(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), a = J(
      () => e.primaryButtonProps.to ? Wn(e.primaryButtonProps.to) : "div"
    );
    return (r, s) => (A(), Se(q(tr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: Ie(() => [
        ne("div", i0, [
          Oe(q(Do), Lt(Rt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: Ie(() => [
        me(r.$slots, "lottery-logo")
      ]),
      default: Ie(() => [
        ne("section", l0, [
          (A(), Se(Xt(a.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ie(() => [
              e.headline ? (A(), j("strong", o0, $e(e.headline), 1)) : ue("", !0),
              Oe(q(Mo), Ce(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", s0, [
          ne("div", c0, [
            me(r.$slots, "primary-button", {}, () => [
              Oe(q(Ct), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: s[0] || (s[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: Ie(() => [
                  bt($e(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ne("section", u0, [
          e.hint ? (A(), j("p", d0, [
            me(r.$slots, "hint", {}, () => [
              bt($e(e.hint), 1)
            ])
          ])) : ue("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), f0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, h0 = ["stroke"], v0 = ["stroke"], m0 = ["id"], g0 = ["id"], b0 = /* @__PURE__ */ _e({
  __name: "ArrowsIcon",
  setup(e) {
    const t = yt(), a = J(() => `arrows-grad1-${t}`), r = J(() => `arrows-grad2-${t}`);
    return (s, i) => (A(), j("svg", f0, [
      ne("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${a.value})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, h0),
      i[2] || (i[2] = ne("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${r.value})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, v0),
      i[3] || (i[3] = ne("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ne("defs", null, [
        ne("linearGradient", {
          id: a.value,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...i[0] || (i[0] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])], 8, m0),
        ne("linearGradient", {
          id: r.value,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...i[1] || (i[1] = [
          ne("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])], 8, g0)
      ])
    ]));
  }
}), p0 = {}, y0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function w0(e, t) {
  return A(), j("svg", y0, [...t[0] || (t[0] = [
    Cs('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const x0 = /* @__PURE__ */ oi(p0, [["render", w0], ["__scopeId", "data-v-0c679bcf"]]), k0 = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, _0 = ["fill"], S0 = /* @__PURE__ */ _e({
  __name: "PlayButtonIcon",
  setup(e) {
    const a = `play-btn-grad-${yt()}`;
    return (r, s) => (A(), j("svg", k0, [
      s[1] || (s[1] = ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ne("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${a})`
      }, null, 8, _0),
      ne("defs", null, [
        ne("radialGradient", {
          id: a,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...s[0] || (s[0] = [
          ne("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ne("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), Qn = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, C0 = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, E0 = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, T0 = { class: "lc-high-frequency-teaser-watch__game-badge" }, L0 = { class: "lc-high-frequency-teaser-watch__game-label" }, A0 = { class: "lc-high-frequency-teaser-watch__game-number" }, $0 = { class: "lc-high-frequency-teaser-watch__game-icon" }, I0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, D0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, M0 = { class: "lc-high-frequency-teaser-watch__timer-value" }, O0 = { class: "lc-high-frequency-teaser-watch__timer-unit" }, R0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, F0 = { class: "lc-high-frequency-teaser-watch__main" }, N0 = { class: "lc-high-frequency-teaser-watch__title" }, cg = /* @__PURE__ */ _e({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = pe("idle"), a = pe(e.gameNumber), r = pe(!1), s = pe(0), i = J(() => e.to ? Wn(e.to) : "div"), n = J(() => String(a.value).split("")), l = J(() => t.value === "spinning"), o = J(() => t.value === "idle" || l.value), h = J(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": l.value
    })), v = J(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": l.value
    })), u = J(() => ({
      "lc-high-frequency-teaser-watch__arrows--spinning": l.value,
      "lc-high-frequency-teaser-watch__arrows--idle-spin": s.value > 0 && t.value === "idle"
    })), f = J(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: c } = zs(
      () => {
        t.value === "idle" && e.isOperational && s.value++;
      },
      Qn.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: w, stop: _ } = ea(
      () => {
        t.value = "spinning";
      },
      Qn.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ea(
      () => t.value = "paused",
      Qn.PAUSE_DELAY,
      { immediate: !1 }
    ), S = pe(e.gameNumber), { start: T, stop: I } = ea(
      () => {
        t.value = "label", a.value = S.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      Qn.LABEL_DELAY,
      { immediate: !1 }
    ), { start: $, stop: C } = ea(
      () => {
        t.value = "idle", r.value = !1, c();
      },
      Qn.IDLE_DELAY,
      { immediate: !1 }
    ), F = () => {
      _(), b(), I(), C();
    };
    return Ve(
      () => e.isOperational,
      (V) => {
        V ? c() : (F(), m(), t.value = "idle", r.value = !1);
      }
    ), Ve(
      () => e.gameNumber,
      (V, K) => {
        if (V === K || !e.isOperational) {
          a.value = V;
          return;
        }
        F(), m(), S.value = V, t.value = "idle", w(), g(), T(), $();
      }
    ), (V, K) => (A(), Se(Xt(i.value), Lt(Rt({ to: e.to })), {
      default: Ie(() => [
        Oe(q(tr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: Ie(() => [
            ne("div", C0, [
              Oe(q(Do), Ce({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: Ie(() => [
            ne("div", E0, [
              ne("div", T0, [
                ne("span", L0, $e(e.gameLabel), 1),
                ne("span", A0, [
                  (A(!0), j(Ye, null, ht(n.value, (O, G) => (A(), j("span", {
                    key: `pos-${G}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Oe(Es, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: Ie(() => [
                        (A(), j("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: At({ transitionDelay: `${G * 35}ms` })
                        }, $e(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ne("div", $0, [
                Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: Ie(() => [
                    e.isOperational ? ue("", !0) : (A(), j("div", I0, [
                      Oe(x0)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? (A(), j("div", D0, [
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: Ie(() => [
                      o.value ? (A(), j("div", {
                        key: 0,
                        class: ye(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ne("span", {
                          class: ye(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ne("span", M0, $e(e.timerValueLabel), 1),
                          ne("span", O0, $e(e.timerUnitLabel), 1)
                        ], 2),
                        (A(), j("div", {
                          key: `arrows-${s.value}`,
                          class: ye(["lc-high-frequency-teaser-watch__arrows", u.value])
                        }, [
                          Oe(b0)
                        ], 2))
                      ], 2)) : ue("", !0)
                    ]),
                    _: 1
                  }),
                  Oe(wn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: Ie(() => [
                      t.value === "label" ? (A(), j("div", R0, [
                        me(V.$slots, "new-game-label")
                      ])) : ue("", !0)
                    ]),
                    _: 3
                  })
                ])) : ue("", !0)
              ])
            ])
          ]),
          footer: Ie(() => [
            me(V.$slots, "message")
          ]),
          default: Ie(() => [
            ne("div", F0, [
              ne("div", {
                class: ye(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Oe(S0)
              ], 2),
              ne("span", N0, $e(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Fn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", B0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var $a = 0; $a < Fn.length; $a++)
  B0[Fn.charCodeAt($a)] = $a;
var P0 = function(e) {
  var t = new Uint8Array(e), a, r = t.length, s = "";
  for (a = 0; a < r; a += 3)
    s += Fn[t[a] >> 2], s += Fn[(t[a] & 3) << 4 | t[a + 1] >> 4], s += Fn[(t[a + 1] & 15) << 2 | t[a + 2] >> 6], s += Fn[t[a + 2] & 63];
  return r % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : r % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
}, z0 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], na = (e) => {
  let t = 0;
  for (let a = 0; a < e.length; a++) {
    let r = e[a], s = z0.indexOf(r);
    t = t * 83 + s;
  }
  return t;
}, wr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, xr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, V0 = (e) => e < 0 ? -1 : 1, kr = (e, t) => V0(e) * Math.pow(Math.abs(e), t), fl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, H0 = (e) => {
  if (!e || e.length < 6) throw new fl("The blurhash string must be at least 6 characters");
  let t = na(e[0]), a = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * a) throw new fl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * a}`);
}, U0 = (e) => {
  let t = e >> 16, a = e >> 8 & 255, r = e & 255;
  return [wr(t), wr(a), wr(r)];
}, q0 = (e, t) => {
  let a = Math.floor(e / 361), r = Math.floor(e / 19) % 19, s = e % 19;
  return [kr((a - 9) / 9, 2) * t, kr((r - 9) / 9, 2) * t, kr((s - 9) / 9, 2) * t];
}, j0 = (e, t, a, r) => {
  H0(e), r = r | 1;
  let s = na(e[0]), i = Math.floor(s / 9) + 1, n = s % 9 + 1, l = (na(e[1]) + 1) / 166, o = new Array(n * i);
  for (let u = 0; u < o.length; u++) if (u === 0) {
    let f = na(e.substring(2, 6));
    o[u] = U0(f);
  } else {
    let f = na(e.substring(4 + u * 2, 6 + u * 2));
    o[u] = q0(f, l * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * a);
  for (let u = 0; u < a; u++) for (let f = 0; f < t; f++) {
    let m = 0, c = 0, w = 0;
    for (let S = 0; S < i; S++) for (let T = 0; T < n; T++) {
      let I = Math.cos(Math.PI * f * T / t) * Math.cos(Math.PI * u * S / a), $ = o[T + S * n];
      m += $[0] * I, c += $[1] * I, w += $[2] * I;
    }
    let _ = xr(m), g = xr(c), b = xr(w);
    v[4 * f + 0 + u * h] = _, v[4 * f + 1 + u * h] = g, v[4 * f + 2 + u * h] = b, v[4 * f + 3 + u * h] = 255;
  }
  return v;
}, Z0 = j0;
function W0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function X0(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _r = { exports: {} }, Sr = {}, hl;
function un() {
  return hl || (hl = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function a(i, n) {
      return Object.prototype.hasOwnProperty.call(i, n);
    }
    e.assign = function(i) {
      for (var n = Array.prototype.slice.call(arguments, 1); n.length; ) {
        var l = n.shift();
        if (l) {
          if (typeof l != "object")
            throw new TypeError(l + "must be non-object");
          for (var o in l)
            a(l, o) && (i[o] = l[o]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, n) {
      return i.length === n ? i : i.subarray ? i.subarray(0, n) : (i.length = n, i);
    };
    var r = {
      arraySet: function(i, n, l, o, h) {
        if (n.subarray && i.subarray) {
          i.set(n.subarray(l, l + o), h);
          return;
        }
        for (var v = 0; v < o; v++)
          i[h + v] = n[l + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var n, l, o, h, v, u;
        for (o = 0, n = 0, l = i.length; n < l; n++)
          o += i[n].length;
        for (u = new Uint8Array(o), h = 0, n = 0, l = i.length; n < l; n++)
          v = i[n], u.set(v, h), h += v.length;
        return u;
      }
    }, s = {
      arraySet: function(i, n, l, o, h) {
        for (var v = 0; v < o; v++)
          i[h + v] = n[l + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
    }, e.setTyped(t);
  })(Sr)), Sr;
}
var Mn = {}, zt = {}, mn = {}, vl;
function Y0() {
  if (vl) return mn;
  vl = 1;
  var e = un(), t = 4, a = 0, r = 1, s = 2;
  function i(y) {
    for (var Y = y.length; --Y >= 0; )
      y[Y] = 0;
  }
  var n = 0, l = 1, o = 2, h = 3, v = 258, u = 29, f = 256, m = f + 1 + u, c = 30, w = 19, _ = 2 * m + 1, g = 15, b = 16, S = 7, T = 256, I = 16, $ = 17, C = 18, F = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), V = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), K = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], G = 512, P = new Array((m + 2) * 2);
  i(P);
  var E = new Array(c * 2);
  i(E);
  var L = new Array(G);
  i(L);
  var z = new Array(v - h + 1);
  i(z);
  var U = new Array(u);
  i(U);
  var X = new Array(c);
  i(X);
  function B(y, Y, W, ce, R) {
    this.static_tree = y, this.extra_bits = Y, this.extra_base = W, this.elems = ce, this.max_length = R, this.has_stree = y && y.length;
  }
  var ie, H, Q;
  function ae(y, Y) {
    this.dyn_tree = y, this.max_code = 0, this.stat_desc = Y;
  }
  function ve(y) {
    return y < 256 ? L[y] : L[256 + (y >>> 7)];
  }
  function be(y, Y) {
    y.pending_buf[y.pending++] = Y & 255, y.pending_buf[y.pending++] = Y >>> 8 & 255;
  }
  function se(y, Y, W) {
    y.bi_valid > b - W ? (y.bi_buf |= Y << y.bi_valid & 65535, be(y, y.bi_buf), y.bi_buf = Y >> b - y.bi_valid, y.bi_valid += W - b) : (y.bi_buf |= Y << y.bi_valid & 65535, y.bi_valid += W);
  }
  function ge(y, Y, W) {
    se(
      y,
      W[Y * 2],
      W[Y * 2 + 1]
      /*.Len*/
    );
  }
  function we(y, Y) {
    var W = 0;
    do
      W |= y & 1, y >>>= 1, W <<= 1;
    while (--Y > 0);
    return W >>> 1;
  }
  function Le(y) {
    y.bi_valid === 16 ? (be(y, y.bi_buf), y.bi_buf = 0, y.bi_valid = 0) : y.bi_valid >= 8 && (y.pending_buf[y.pending++] = y.bi_buf & 255, y.bi_buf >>= 8, y.bi_valid -= 8);
  }
  function Ze(y, Y) {
    var W = Y.dyn_tree, ce = Y.max_code, R = Y.stat_desc.static_tree, le = Y.stat_desc.has_stree, p = Y.stat_desc.extra_bits, de = Y.stat_desc.extra_base, Ae = Y.stat_desc.max_length, d, re, te, x, N, ee, De = 0;
    for (x = 0; x <= g; x++)
      y.bl_count[x] = 0;
    for (W[y.heap[y.heap_max] * 2 + 1] = 0, d = y.heap_max + 1; d < _; d++)
      re = y.heap[d], x = W[W[re * 2 + 1] * 2 + 1] + 1, x > Ae && (x = Ae, De++), W[re * 2 + 1] = x, !(re > ce) && (y.bl_count[x]++, N = 0, re >= de && (N = p[re - de]), ee = W[re * 2], y.opt_len += ee * (x + N), le && (y.static_len += ee * (R[re * 2 + 1] + N)));
    if (De !== 0) {
      do {
        for (x = Ae - 1; y.bl_count[x] === 0; )
          x--;
        y.bl_count[x]--, y.bl_count[x + 1] += 2, y.bl_count[Ae]--, De -= 2;
      } while (De > 0);
      for (x = Ae; x !== 0; x--)
        for (re = y.bl_count[x]; re !== 0; )
          te = y.heap[--d], !(te > ce) && (W[te * 2 + 1] !== x && (y.opt_len += (x - W[te * 2 + 1]) * W[te * 2], W[te * 2 + 1] = x), re--);
    }
  }
  function Ne(y, Y, W) {
    var ce = new Array(g + 1), R = 0, le, p;
    for (le = 1; le <= g; le++)
      ce[le] = R = R + W[le - 1] << 1;
    for (p = 0; p <= Y; p++) {
      var de = y[p * 2 + 1];
      de !== 0 && (y[p * 2] = we(ce[de]++, de));
    }
  }
  function fe() {
    var y, Y, W, ce, R, le = new Array(g + 1);
    for (W = 0, ce = 0; ce < u - 1; ce++)
      for (U[ce] = W, y = 0; y < 1 << F[ce]; y++)
        z[W++] = ce;
    for (z[W - 1] = ce, R = 0, ce = 0; ce < 16; ce++)
      for (X[ce] = R, y = 0; y < 1 << V[ce]; y++)
        L[R++] = ce;
    for (R >>= 7; ce < c; ce++)
      for (X[ce] = R << 7, y = 0; y < 1 << V[ce] - 7; y++)
        L[256 + R++] = ce;
    for (Y = 0; Y <= g; Y++)
      le[Y] = 0;
    for (y = 0; y <= 143; )
      P[y * 2 + 1] = 8, y++, le[8]++;
    for (; y <= 255; )
      P[y * 2 + 1] = 9, y++, le[9]++;
    for (; y <= 279; )
      P[y * 2 + 1] = 7, y++, le[7]++;
    for (; y <= 287; )
      P[y * 2 + 1] = 8, y++, le[8]++;
    for (Ne(P, m + 1, le), y = 0; y < c; y++)
      E[y * 2 + 1] = 5, E[y * 2] = we(y, 5);
    ie = new B(P, F, f + 1, m, g), H = new B(E, V, 0, c, g), Q = new B(new Array(0), K, 0, w, S);
  }
  function Re(y) {
    var Y;
    for (Y = 0; Y < m; Y++)
      y.dyn_ltree[Y * 2] = 0;
    for (Y = 0; Y < c; Y++)
      y.dyn_dtree[Y * 2] = 0;
    for (Y = 0; Y < w; Y++)
      y.bl_tree[Y * 2] = 0;
    y.dyn_ltree[T * 2] = 1, y.opt_len = y.static_len = 0, y.last_lit = y.matches = 0;
  }
  function Be(y) {
    y.bi_valid > 8 ? be(y, y.bi_buf) : y.bi_valid > 0 && (y.pending_buf[y.pending++] = y.bi_buf), y.bi_buf = 0, y.bi_valid = 0;
  }
  function He(y, Y, W, ce) {
    Be(y), be(y, W), be(y, ~W), e.arraySet(y.pending_buf, y.window, Y, W, y.pending), y.pending += W;
  }
  function We(y, Y, W, ce) {
    var R = Y * 2, le = W * 2;
    return y[R] < y[le] || y[R] === y[le] && ce[Y] <= ce[W];
  }
  function Pe(y, Y, W) {
    for (var ce = y.heap[W], R = W << 1; R <= y.heap_len && (R < y.heap_len && We(Y, y.heap[R + 1], y.heap[R], y.depth) && R++, !We(Y, ce, y.heap[R], y.depth)); )
      y.heap[W] = y.heap[R], W = R, R <<= 1;
    y.heap[W] = ce;
  }
  function Fe(y, Y, W) {
    var ce, R, le = 0, p, de;
    if (y.last_lit !== 0)
      do
        ce = y.pending_buf[y.d_buf + le * 2] << 8 | y.pending_buf[y.d_buf + le * 2 + 1], R = y.pending_buf[y.l_buf + le], le++, ce === 0 ? ge(y, R, Y) : (p = z[R], ge(y, p + f + 1, Y), de = F[p], de !== 0 && (R -= U[p], se(y, R, de)), ce--, p = ve(ce), ge(y, p, W), de = V[p], de !== 0 && (ce -= X[p], se(y, ce, de)));
      while (le < y.last_lit);
    ge(y, T, Y);
  }
  function nt(y, Y) {
    var W = Y.dyn_tree, ce = Y.stat_desc.static_tree, R = Y.stat_desc.has_stree, le = Y.stat_desc.elems, p, de, Ae = -1, d;
    for (y.heap_len = 0, y.heap_max = _, p = 0; p < le; p++)
      W[p * 2] !== 0 ? (y.heap[++y.heap_len] = Ae = p, y.depth[p] = 0) : W[p * 2 + 1] = 0;
    for (; y.heap_len < 2; )
      d = y.heap[++y.heap_len] = Ae < 2 ? ++Ae : 0, W[d * 2] = 1, y.depth[d] = 0, y.opt_len--, R && (y.static_len -= ce[d * 2 + 1]);
    for (Y.max_code = Ae, p = y.heap_len >> 1; p >= 1; p--)
      Pe(y, W, p);
    d = le;
    do
      p = y.heap[
        1
        /*SMALLEST*/
      ], y.heap[
        1
        /*SMALLEST*/
      ] = y.heap[y.heap_len--], Pe(
        y,
        W,
        1
        /*SMALLEST*/
      ), de = y.heap[
        1
        /*SMALLEST*/
      ], y.heap[--y.heap_max] = p, y.heap[--y.heap_max] = de, W[d * 2] = W[p * 2] + W[de * 2], y.depth[d] = (y.depth[p] >= y.depth[de] ? y.depth[p] : y.depth[de]) + 1, W[p * 2 + 1] = W[de * 2 + 1] = d, y.heap[
        1
        /*SMALLEST*/
      ] = d++, Pe(
        y,
        W,
        1
        /*SMALLEST*/
      );
    while (y.heap_len >= 2);
    y.heap[--y.heap_max] = y.heap[
      1
      /*SMALLEST*/
    ], Ze(y, Y), Ne(W, Ae, y.bl_count);
  }
  function xt(y, Y, W) {
    var ce, R = -1, le, p = Y[1], de = 0, Ae = 7, d = 4;
    for (p === 0 && (Ae = 138, d = 3), Y[(W + 1) * 2 + 1] = 65535, ce = 0; ce <= W; ce++)
      le = p, p = Y[(ce + 1) * 2 + 1], !(++de < Ae && le === p) && (de < d ? y.bl_tree[le * 2] += de : le !== 0 ? (le !== R && y.bl_tree[le * 2]++, y.bl_tree[I * 2]++) : de <= 10 ? y.bl_tree[$ * 2]++ : y.bl_tree[C * 2]++, de = 0, R = le, p === 0 ? (Ae = 138, d = 3) : le === p ? (Ae = 6, d = 3) : (Ae = 7, d = 4));
  }
  function kt(y, Y, W) {
    var ce, R = -1, le, p = Y[1], de = 0, Ae = 7, d = 4;
    for (p === 0 && (Ae = 138, d = 3), ce = 0; ce <= W; ce++)
      if (le = p, p = Y[(ce + 1) * 2 + 1], !(++de < Ae && le === p)) {
        if (de < d)
          do
            ge(y, le, y.bl_tree);
          while (--de !== 0);
        else le !== 0 ? (le !== R && (ge(y, le, y.bl_tree), de--), ge(y, I, y.bl_tree), se(y, de - 3, 2)) : de <= 10 ? (ge(y, $, y.bl_tree), se(y, de - 3, 3)) : (ge(y, C, y.bl_tree), se(y, de - 11, 7));
        de = 0, R = le, p === 0 ? (Ae = 138, d = 3) : le === p ? (Ae = 6, d = 3) : (Ae = 7, d = 4);
      }
  }
  function vt(y) {
    var Y;
    for (xt(y, y.dyn_ltree, y.l_desc.max_code), xt(y, y.dyn_dtree, y.d_desc.max_code), nt(y, y.bl_desc), Y = w - 1; Y >= 3 && y.bl_tree[O[Y] * 2 + 1] === 0; Y--)
      ;
    return y.opt_len += 3 * (Y + 1) + 5 + 5 + 4, Y;
  }
  function Ft(y, Y, W, ce) {
    var R;
    for (se(y, Y - 257, 5), se(y, W - 1, 5), se(y, ce - 4, 4), R = 0; R < ce; R++)
      se(y, y.bl_tree[O[R] * 2 + 1], 3);
    kt(y, y.dyn_ltree, Y - 1), kt(y, y.dyn_dtree, W - 1);
  }
  function Mt(y) {
    var Y = 4093624447, W;
    for (W = 0; W <= 31; W++, Y >>>= 1)
      if (Y & 1 && y.dyn_ltree[W * 2] !== 0)
        return a;
    if (y.dyn_ltree[18] !== 0 || y.dyn_ltree[20] !== 0 || y.dyn_ltree[26] !== 0)
      return r;
    for (W = 32; W < f; W++)
      if (y.dyn_ltree[W * 2] !== 0)
        return r;
    return a;
  }
  var wt = !1;
  function Ut(y) {
    wt || (fe(), wt = !0), y.l_desc = new ae(y.dyn_ltree, ie), y.d_desc = new ae(y.dyn_dtree, H), y.bl_desc = new ae(y.bl_tree, Q), y.bi_buf = 0, y.bi_valid = 0, Re(y);
  }
  function $t(y, Y, W, ce) {
    se(y, (n << 1) + (ce ? 1 : 0), 3), He(y, Y, W);
  }
  function st(y) {
    se(y, l << 1, 3), ge(y, T, P), Le(y);
  }
  function D(y, Y, W, ce) {
    var R, le, p = 0;
    y.level > 0 ? (y.strm.data_type === s && (y.strm.data_type = Mt(y)), nt(y, y.l_desc), nt(y, y.d_desc), p = vt(y), R = y.opt_len + 3 + 7 >>> 3, le = y.static_len + 3 + 7 >>> 3, le <= R && (R = le)) : R = le = W + 5, W + 4 <= R && Y !== -1 ? $t(y, Y, W, ce) : y.strategy === t || le === R ? (se(y, (l << 1) + (ce ? 1 : 0), 3), Fe(y, P, E)) : (se(y, (o << 1) + (ce ? 1 : 0), 3), Ft(y, y.l_desc.max_code + 1, y.d_desc.max_code + 1, p + 1), Fe(y, y.dyn_ltree, y.dyn_dtree)), Re(y), ce && Be(y);
  }
  function k(y, Y, W) {
    return y.pending_buf[y.d_buf + y.last_lit * 2] = Y >>> 8 & 255, y.pending_buf[y.d_buf + y.last_lit * 2 + 1] = Y & 255, y.pending_buf[y.l_buf + y.last_lit] = W & 255, y.last_lit++, Y === 0 ? y.dyn_ltree[W * 2]++ : (y.matches++, Y--, y.dyn_ltree[(z[W] + f + 1) * 2]++, y.dyn_dtree[ve(Y) * 2]++), y.last_lit === y.lit_bufsize - 1;
  }
  return mn._tr_init = Ut, mn._tr_stored_block = $t, mn._tr_flush_block = D, mn._tr_tally = k, mn._tr_align = st, mn;
}
var Cr, ml;
function Bo() {
  if (ml) return Cr;
  ml = 1;
  function e(t, a, r, s) {
    for (var i = t & 65535 | 0, n = t >>> 16 & 65535 | 0, l = 0; r !== 0; ) {
      l = r > 2e3 ? 2e3 : r, r -= l;
      do
        i = i + a[s++] | 0, n = n + i | 0;
      while (--l);
      i %= 65521, n %= 65521;
    }
    return i | n << 16 | 0;
  }
  return Cr = e, Cr;
}
var Er, gl;
function Po() {
  if (gl) return Er;
  gl = 1;
  function e() {
    for (var r, s = [], i = 0; i < 256; i++) {
      r = i;
      for (var n = 0; n < 8; n++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      s[i] = r;
    }
    return s;
  }
  var t = e();
  function a(r, s, i, n) {
    var l = t, o = n + i;
    r ^= -1;
    for (var h = n; h < o; h++)
      r = r >>> 8 ^ l[(r ^ s[h]) & 255];
    return r ^ -1;
  }
  return Er = a, Er;
}
var Tr, bl;
function hi() {
  return bl || (bl = 1, Tr = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Tr;
}
var pl;
function G0() {
  if (pl) return zt;
  pl = 1;
  var e = un(), t = Y0(), a = Bo(), r = Po(), s = hi(), i = 0, n = 1, l = 3, o = 4, h = 5, v = 0, u = 1, f = -2, m = -3, c = -5, w = -1, _ = 1, g = 2, b = 3, S = 4, T = 0, I = 2, $ = 8, C = 9, F = 15, V = 8, K = 29, O = 256, G = O + 1 + K, P = 30, E = 19, L = 2 * G + 1, z = 15, U = 3, X = 258, B = X + U + 1, ie = 32, H = 42, Q = 69, ae = 73, ve = 91, be = 103, se = 113, ge = 666, we = 1, Le = 2, Ze = 3, Ne = 4, fe = 3;
  function Re(d, re) {
    return d.msg = s[re], re;
  }
  function Be(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function He(d) {
    for (var re = d.length; --re >= 0; )
      d[re] = 0;
  }
  function We(d) {
    var re = d.state, te = re.pending;
    te > d.avail_out && (te = d.avail_out), te !== 0 && (e.arraySet(d.output, re.pending_buf, re.pending_out, te, d.next_out), d.next_out += te, re.pending_out += te, d.total_out += te, d.avail_out -= te, re.pending -= te, re.pending === 0 && (re.pending_out = 0));
  }
  function Pe(d, re) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, re), d.block_start = d.strstart, We(d.strm);
  }
  function Fe(d, re) {
    d.pending_buf[d.pending++] = re;
  }
  function nt(d, re) {
    d.pending_buf[d.pending++] = re >>> 8 & 255, d.pending_buf[d.pending++] = re & 255;
  }
  function xt(d, re, te, x) {
    var N = d.avail_in;
    return N > x && (N = x), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(re, d.input, d.next_in, N, te), d.state.wrap === 1 ? d.adler = a(d.adler, re, N, te) : d.state.wrap === 2 && (d.adler = r(d.adler, re, N, te)), d.next_in += N, d.total_in += N, N);
  }
  function kt(d, re) {
    var te = d.max_chain_length, x = d.strstart, N, ee, De = d.prev_length, xe = d.nice_match, Ee = d.strstart > d.w_size - B ? d.strstart - (d.w_size - B) : 0, Ue = d.window, dt = d.w_mask, Qe = d.prev, qe = d.strstart + X, it = Ue[x + De - 1], mt = Ue[x + De];
    d.prev_length >= d.good_match && (te >>= 2), xe > d.lookahead && (xe = d.lookahead);
    do
      if (N = re, !(Ue[N + De] !== mt || Ue[N + De - 1] !== it || Ue[N] !== Ue[x] || Ue[++N] !== Ue[x + 1])) {
        x += 2, N++;
        do
          ;
        while (Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && Ue[++x] === Ue[++N] && x < qe);
        if (ee = X - (qe - x), x = qe - X, ee > De) {
          if (d.match_start = re, De = ee, ee >= xe)
            break;
          it = Ue[x + De - 1], mt = Ue[x + De];
        }
      }
    while ((re = Qe[re & dt]) > Ee && --te !== 0);
    return De <= d.lookahead ? De : d.lookahead;
  }
  function vt(d) {
    var re = d.w_size, te, x, N, ee, De;
    do {
      if (ee = d.window_size - d.lookahead - d.strstart, d.strstart >= re + (re - B)) {
        e.arraySet(d.window, d.window, re, re, 0), d.match_start -= re, d.strstart -= re, d.block_start -= re, x = d.hash_size, te = x;
        do
          N = d.head[--te], d.head[te] = N >= re ? N - re : 0;
        while (--x);
        x = re, te = x;
        do
          N = d.prev[--te], d.prev[te] = N >= re ? N - re : 0;
        while (--x);
        ee += re;
      }
      if (d.strm.avail_in === 0)
        break;
      if (x = xt(d.strm, d.window, d.strstart + d.lookahead, ee), d.lookahead += x, d.lookahead + d.insert >= U)
        for (De = d.strstart - d.insert, d.ins_h = d.window[De], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[De + U - 1]) & d.hash_mask, d.prev[De & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = De, De++, d.insert--, !(d.lookahead + d.insert < U)); )
          ;
    } while (d.lookahead < B && d.strm.avail_in !== 0);
  }
  function Ft(d, re) {
    var te = 65535;
    for (te > d.pending_buf_size - 5 && (te = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (vt(d), d.lookahead === 0 && re === i)
          return we;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var x = d.block_start + te;
      if ((d.strstart === 0 || d.strstart >= x) && (d.lookahead = d.strstart - x, d.strstart = x, Pe(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - B && (Pe(d, !1), d.strm.avail_out === 0))
        return we;
    }
    return d.insert = 0, re === o ? (Pe(d, !0), d.strm.avail_out === 0 ? Ze : Ne) : (d.strstart > d.block_start && (Pe(d, !1), d.strm.avail_out === 0), we);
  }
  function Mt(d, re) {
    for (var te, x; ; ) {
      if (d.lookahead < B) {
        if (vt(d), d.lookahead < B && re === i)
          return we;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), te !== 0 && d.strstart - te <= d.w_size - B && (d.match_length = kt(d, te)), d.match_length >= U)
        if (x = t._tr_tally(d, d.strstart - d.match_start, d.match_length - U), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= U) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        x = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (x && (Pe(d, !1), d.strm.avail_out === 0))
        return we;
    }
    return d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === o ? (Pe(d, !0), d.strm.avail_out === 0 ? Ze : Ne) : d.last_lit && (Pe(d, !1), d.strm.avail_out === 0) ? we : Le;
  }
  function wt(d, re) {
    for (var te, x, N; ; ) {
      if (d.lookahead < B) {
        if (vt(d), d.lookahead < B && re === i)
          return we;
        if (d.lookahead === 0)
          break;
      }
      if (te = 0, d.lookahead >= U && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = U - 1, te !== 0 && d.prev_length < d.max_lazy_match && d.strstart - te <= d.w_size - B && (d.match_length = kt(d, te), d.match_length <= 5 && (d.strategy === _ || d.match_length === U && d.strstart - d.match_start > 4096) && (d.match_length = U - 1)), d.prev_length >= U && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - U, x = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - U), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + U - 1]) & d.hash_mask, te = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = U - 1, d.strstart++, x && (Pe(d, !1), d.strm.avail_out === 0))
          return we;
      } else if (d.match_available) {
        if (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), x && Pe(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return we;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < U - 1 ? d.strstart : U - 1, re === o ? (Pe(d, !0), d.strm.avail_out === 0 ? Ze : Ne) : d.last_lit && (Pe(d, !1), d.strm.avail_out === 0) ? we : Le;
  }
  function Ut(d, re) {
    for (var te, x, N, ee, De = d.window; ; ) {
      if (d.lookahead <= X) {
        if (vt(d), d.lookahead <= X && re === i)
          return we;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= U && d.strstart > 0 && (N = d.strstart - 1, x = De[N], x === De[++N] && x === De[++N] && x === De[++N])) {
        ee = d.strstart + X;
        do
          ;
        while (x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && x === De[++N] && N < ee);
        d.match_length = X - (ee - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= U ? (te = t._tr_tally(d, 1, d.match_length - U), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), te && (Pe(d, !1), d.strm.avail_out === 0))
        return we;
    }
    return d.insert = 0, re === o ? (Pe(d, !0), d.strm.avail_out === 0 ? Ze : Ne) : d.last_lit && (Pe(d, !1), d.strm.avail_out === 0) ? we : Le;
  }
  function $t(d, re) {
    for (var te; ; ) {
      if (d.lookahead === 0 && (vt(d), d.lookahead === 0)) {
        if (re === i)
          return we;
        break;
      }
      if (d.match_length = 0, te = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, te && (Pe(d, !1), d.strm.avail_out === 0))
        return we;
    }
    return d.insert = 0, re === o ? (Pe(d, !0), d.strm.avail_out === 0 ? Ze : Ne) : d.last_lit && (Pe(d, !1), d.strm.avail_out === 0) ? we : Le;
  }
  function st(d, re, te, x, N) {
    this.good_length = d, this.max_lazy = re, this.nice_length = te, this.max_chain = x, this.func = N;
  }
  var D;
  D = [
    /*      good lazy nice chain */
    new st(0, 0, 0, 0, Ft),
    /* 0 store only */
    new st(4, 4, 8, 4, Mt),
    /* 1 max speed, no lazy matches */
    new st(4, 5, 16, 8, Mt),
    /* 2 */
    new st(4, 6, 32, 32, Mt),
    /* 3 */
    new st(4, 4, 16, 16, wt),
    /* 4 lazy matches */
    new st(8, 16, 32, 32, wt),
    /* 5 */
    new st(8, 16, 128, 128, wt),
    /* 6 */
    new st(8, 32, 128, 256, wt),
    /* 7 */
    new st(32, 128, 258, 1024, wt),
    /* 8 */
    new st(32, 258, 258, 4096, wt)
    /* 9 max compression */
  ];
  function k(d) {
    d.window_size = 2 * d.w_size, He(d.head), d.max_lazy_match = D[d.level].max_lazy, d.good_match = D[d.level].good_length, d.nice_match = D[d.level].nice_length, d.max_chain_length = D[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = U - 1, d.match_available = 0, d.ins_h = 0;
  }
  function y() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = $, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(L * 2), this.dyn_dtree = new e.Buf16((2 * P + 1) * 2), this.bl_tree = new e.Buf16((2 * E + 1) * 2), He(this.dyn_ltree), He(this.dyn_dtree), He(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(z + 1), this.heap = new e.Buf16(2 * G + 1), He(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * G + 1), He(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function Y(d) {
    var re;
    return !d || !d.state ? Re(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, re = d.state, re.pending = 0, re.pending_out = 0, re.wrap < 0 && (re.wrap = -re.wrap), re.status = re.wrap ? H : se, d.adler = re.wrap === 2 ? 0 : 1, re.last_flush = i, t._tr_init(re), v);
  }
  function W(d) {
    var re = Y(d);
    return re === v && k(d.state), re;
  }
  function ce(d, re) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = re, v);
  }
  function R(d, re, te, x, N, ee) {
    if (!d)
      return f;
    var De = 1;
    if (re === w && (re = 6), x < 0 ? (De = 0, x = -x) : x > 15 && (De = 2, x -= 16), N < 1 || N > C || te !== $ || x < 8 || x > 15 || re < 0 || re > 9 || ee < 0 || ee > S)
      return Re(d, f);
    x === 8 && (x = 9);
    var xe = new y();
    return d.state = xe, xe.strm = d, xe.wrap = De, xe.gzhead = null, xe.w_bits = x, xe.w_size = 1 << xe.w_bits, xe.w_mask = xe.w_size - 1, xe.hash_bits = N + 7, xe.hash_size = 1 << xe.hash_bits, xe.hash_mask = xe.hash_size - 1, xe.hash_shift = ~~((xe.hash_bits + U - 1) / U), xe.window = new e.Buf8(xe.w_size * 2), xe.head = new e.Buf16(xe.hash_size), xe.prev = new e.Buf16(xe.w_size), xe.lit_bufsize = 1 << N + 6, xe.pending_buf_size = xe.lit_bufsize * 4, xe.pending_buf = new e.Buf8(xe.pending_buf_size), xe.d_buf = 1 * xe.lit_bufsize, xe.l_buf = 3 * xe.lit_bufsize, xe.level = re, xe.strategy = ee, xe.method = te, W(d);
  }
  function le(d, re) {
    return R(d, re, $, F, V, T);
  }
  function p(d, re) {
    var te, x, N, ee;
    if (!d || !d.state || re > h || re < 0)
      return d ? Re(d, f) : f;
    if (x = d.state, !d.output || !d.input && d.avail_in !== 0 || x.status === ge && re !== o)
      return Re(d, d.avail_out === 0 ? c : f);
    if (x.strm = d, te = x.last_flush, x.last_flush = re, x.status === H)
      if (x.wrap === 2)
        d.adler = 0, Fe(x, 31), Fe(x, 139), Fe(x, 8), x.gzhead ? (Fe(
          x,
          (x.gzhead.text ? 1 : 0) + (x.gzhead.hcrc ? 2 : 0) + (x.gzhead.extra ? 4 : 0) + (x.gzhead.name ? 8 : 0) + (x.gzhead.comment ? 16 : 0)
        ), Fe(x, x.gzhead.time & 255), Fe(x, x.gzhead.time >> 8 & 255), Fe(x, x.gzhead.time >> 16 & 255), Fe(x, x.gzhead.time >> 24 & 255), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, x.gzhead.os & 255), x.gzhead.extra && x.gzhead.extra.length && (Fe(x, x.gzhead.extra.length & 255), Fe(x, x.gzhead.extra.length >> 8 & 255)), x.gzhead.hcrc && (d.adler = r(d.adler, x.pending_buf, x.pending, 0)), x.gzindex = 0, x.status = Q) : (Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, 0), Fe(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Fe(x, fe), x.status = se);
      else {
        var De = $ + (x.w_bits - 8 << 4) << 8, xe = -1;
        x.strategy >= g || x.level < 2 ? xe = 0 : x.level < 6 ? xe = 1 : x.level === 6 ? xe = 2 : xe = 3, De |= xe << 6, x.strstart !== 0 && (De |= ie), De += 31 - De % 31, x.status = se, nt(x, De), x.strstart !== 0 && (nt(x, d.adler >>> 16), nt(x, d.adler & 65535)), d.adler = 1;
      }
    if (x.status === Q)
      if (x.gzhead.extra) {
        for (N = x.pending; x.gzindex < (x.gzhead.extra.length & 65535) && !(x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)); )
          Fe(x, x.gzhead.extra[x.gzindex] & 255), x.gzindex++;
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), x.gzindex === x.gzhead.extra.length && (x.gzindex = 0, x.status = ae);
      } else
        x.status = ae;
    if (x.status === ae)
      if (x.gzhead.name) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            ee = 1;
            break;
          }
          x.gzindex < x.gzhead.name.length ? ee = x.gzhead.name.charCodeAt(x.gzindex++) & 255 : ee = 0, Fe(x, ee);
        } while (ee !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), ee === 0 && (x.gzindex = 0, x.status = ve);
      } else
        x.status = ve;
    if (x.status === ve)
      if (x.gzhead.comment) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), We(d), N = x.pending, x.pending === x.pending_buf_size)) {
            ee = 1;
            break;
          }
          x.gzindex < x.gzhead.comment.length ? ee = x.gzhead.comment.charCodeAt(x.gzindex++) & 255 : ee = 0, Fe(x, ee);
        } while (ee !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), ee === 0 && (x.status = be);
      } else
        x.status = be;
    if (x.status === be && (x.gzhead.hcrc ? (x.pending + 2 > x.pending_buf_size && We(d), x.pending + 2 <= x.pending_buf_size && (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), d.adler = 0, x.status = se)) : x.status = se), x.pending !== 0) {
      if (We(d), d.avail_out === 0)
        return x.last_flush = -1, v;
    } else if (d.avail_in === 0 && Be(re) <= Be(te) && re !== o)
      return Re(d, c);
    if (x.status === ge && d.avail_in !== 0)
      return Re(d, c);
    if (d.avail_in !== 0 || x.lookahead !== 0 || re !== i && x.status !== ge) {
      var Ee = x.strategy === g ? $t(x, re) : x.strategy === b ? Ut(x, re) : D[x.level].func(x, re);
      if ((Ee === Ze || Ee === Ne) && (x.status = ge), Ee === we || Ee === Ze)
        return d.avail_out === 0 && (x.last_flush = -1), v;
      if (Ee === Le && (re === n ? t._tr_align(x) : re !== h && (t._tr_stored_block(x, 0, 0, !1), re === l && (He(x.head), x.lookahead === 0 && (x.strstart = 0, x.block_start = 0, x.insert = 0))), We(d), d.avail_out === 0))
        return x.last_flush = -1, v;
    }
    return re !== o ? v : x.wrap <= 0 ? u : (x.wrap === 2 ? (Fe(x, d.adler & 255), Fe(x, d.adler >> 8 & 255), Fe(x, d.adler >> 16 & 255), Fe(x, d.adler >> 24 & 255), Fe(x, d.total_in & 255), Fe(x, d.total_in >> 8 & 255), Fe(x, d.total_in >> 16 & 255), Fe(x, d.total_in >> 24 & 255)) : (nt(x, d.adler >>> 16), nt(x, d.adler & 65535)), We(d), x.wrap > 0 && (x.wrap = -x.wrap), x.pending !== 0 ? v : u);
  }
  function de(d) {
    var re;
    return !d || !d.state ? f : (re = d.state.status, re !== H && re !== Q && re !== ae && re !== ve && re !== be && re !== se && re !== ge ? Re(d, f) : (d.state = null, re === se ? Re(d, m) : v));
  }
  function Ae(d, re) {
    var te = re.length, x, N, ee, De, xe, Ee, Ue, dt;
    if (!d || !d.state || (x = d.state, De = x.wrap, De === 2 || De === 1 && x.status !== H || x.lookahead))
      return f;
    for (De === 1 && (d.adler = a(d.adler, re, te, 0)), x.wrap = 0, te >= x.w_size && (De === 0 && (He(x.head), x.strstart = 0, x.block_start = 0, x.insert = 0), dt = new e.Buf8(x.w_size), e.arraySet(dt, re, te - x.w_size, x.w_size, 0), re = dt, te = x.w_size), xe = d.avail_in, Ee = d.next_in, Ue = d.input, d.avail_in = te, d.next_in = 0, d.input = re, vt(x); x.lookahead >= U; ) {
      N = x.strstart, ee = x.lookahead - (U - 1);
      do
        x.ins_h = (x.ins_h << x.hash_shift ^ x.window[N + U - 1]) & x.hash_mask, x.prev[N & x.w_mask] = x.head[x.ins_h], x.head[x.ins_h] = N, N++;
      while (--ee);
      x.strstart = N, x.lookahead = U - 1, vt(x);
    }
    return x.strstart += x.lookahead, x.block_start = x.strstart, x.insert = x.lookahead, x.lookahead = 0, x.match_length = x.prev_length = U - 1, x.match_available = 0, d.next_in = Ee, d.input = Ue, d.avail_in = xe, x.wrap = De, v;
  }
  return zt.deflateInit = le, zt.deflateInit2 = R, zt.deflateReset = W, zt.deflateResetKeep = Y, zt.deflateSetHeader = ce, zt.deflate = p, zt.deflateEnd = de, zt.deflateSetDictionary = Ae, zt.deflateInfo = "pako deflate (from Nodeca project)", zt;
}
var gn = {}, yl;
function zo() {
  if (yl) return gn;
  yl = 1;
  var e = un(), t = !0, a = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    a = !1;
  }
  for (var r = new e.Buf8(256), s = 0; s < 256; s++)
    r[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
  r[254] = r[254] = 1, gn.string2buf = function(n) {
    var l, o, h, v, u, f = n.length, m = 0;
    for (v = 0; v < f; v++)
      o = n.charCodeAt(v), (o & 64512) === 55296 && v + 1 < f && (h = n.charCodeAt(v + 1), (h & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (h - 56320), v++)), m += o < 128 ? 1 : o < 2048 ? 2 : o < 65536 ? 3 : 4;
    for (l = new e.Buf8(m), u = 0, v = 0; u < m; v++)
      o = n.charCodeAt(v), (o & 64512) === 55296 && v + 1 < f && (h = n.charCodeAt(v + 1), (h & 64512) === 56320 && (o = 65536 + (o - 55296 << 10) + (h - 56320), v++)), o < 128 ? l[u++] = o : o < 2048 ? (l[u++] = 192 | o >>> 6, l[u++] = 128 | o & 63) : o < 65536 ? (l[u++] = 224 | o >>> 12, l[u++] = 128 | o >>> 6 & 63, l[u++] = 128 | o & 63) : (l[u++] = 240 | o >>> 18, l[u++] = 128 | o >>> 12 & 63, l[u++] = 128 | o >>> 6 & 63, l[u++] = 128 | o & 63);
    return l;
  };
  function i(n, l) {
    if (l < 65534 && (n.subarray && a || !n.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(n, l));
    for (var o = "", h = 0; h < l; h++)
      o += String.fromCharCode(n[h]);
    return o;
  }
  return gn.buf2binstring = function(n) {
    return i(n, n.length);
  }, gn.binstring2buf = function(n) {
    for (var l = new e.Buf8(n.length), o = 0, h = l.length; o < h; o++)
      l[o] = n.charCodeAt(o);
    return l;
  }, gn.buf2string = function(n, l) {
    var o, h, v, u, f = l || n.length, m = new Array(f * 2);
    for (h = 0, o = 0; o < f; ) {
      if (v = n[o++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (u = r[v], u > 4) {
        m[h++] = 65533, o += u - 1;
        continue;
      }
      for (v &= u === 2 ? 31 : u === 3 ? 15 : 7; u > 1 && o < f; )
        v = v << 6 | n[o++] & 63, u--;
      if (u > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, gn.utf8border = function(n, l) {
    var o;
    for (l = l || n.length, l > n.length && (l = n.length), o = l - 1; o >= 0 && (n[o] & 192) === 128; )
      o--;
    return o < 0 || o === 0 ? l : o + r[n[o]] > l ? o : l;
  }, gn;
}
var Lr, wl;
function Vo() {
  if (wl) return Lr;
  wl = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Lr = e, Lr;
}
var xl;
function K0() {
  if (xl) return Mn;
  xl = 1;
  var e = G0(), t = un(), a = zo(), r = hi(), s = Vo(), i = Object.prototype.toString, n = 0, l = 4, o = 0, h = 1, v = 2, u = -1, f = 0, m = 8;
  function c(b) {
    if (!(this instanceof c)) return new c(b);
    this.options = t.assign({
      level: u,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var S = this.options;
    S.raw && S.windowBits > 0 ? S.windowBits = -S.windowBits : S.gzip && S.windowBits > 0 && S.windowBits < 16 && (S.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
    var T = e.deflateInit2(
      this.strm,
      S.level,
      S.method,
      S.windowBits,
      S.memLevel,
      S.strategy
    );
    if (T !== o)
      throw new Error(r[T]);
    if (S.header && e.deflateSetHeader(this.strm, S.header), S.dictionary) {
      var I;
      if (typeof S.dictionary == "string" ? I = a.string2buf(S.dictionary) : i.call(S.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(S.dictionary) : I = S.dictionary, T = e.deflateSetDictionary(this.strm, I), T !== o)
        throw new Error(r[T]);
      this._dict_set = !0;
    }
  }
  c.prototype.push = function(b, S) {
    var T = this.strm, I = this.options.chunkSize, $, C;
    if (this.ended)
      return !1;
    C = S === ~~S ? S : S === !0 ? l : n, typeof b == "string" ? T.input = a.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? T.input = new Uint8Array(b) : T.input = b, T.next_in = 0, T.avail_in = T.input.length;
    do {
      if (T.avail_out === 0 && (T.output = new t.Buf8(I), T.next_out = 0, T.avail_out = I), $ = e.deflate(T, C), $ !== h && $ !== o)
        return this.onEnd($), this.ended = !0, !1;
      (T.avail_out === 0 || T.avail_in === 0 && (C === l || C === v)) && (this.options.to === "string" ? this.onData(a.buf2binstring(t.shrinkBuf(T.output, T.next_out))) : this.onData(t.shrinkBuf(T.output, T.next_out)));
    } while ((T.avail_in > 0 || T.avail_out === 0) && $ !== h);
    return C === l ? ($ = e.deflateEnd(this.strm), this.onEnd($), this.ended = !0, $ === o) : (C === v && (this.onEnd(o), T.avail_out = 0), !0);
  }, c.prototype.onData = function(b) {
    this.chunks.push(b);
  }, c.prototype.onEnd = function(b) {
    b === o && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function w(b, S) {
    var T = new c(S);
    if (T.push(b, !0), T.err)
      throw T.msg || r[T.err];
    return T.result;
  }
  function _(b, S) {
    return S = S || {}, S.raw = !0, w(b, S);
  }
  function g(b, S) {
    return S = S || {}, S.gzip = !0, w(b, S);
  }
  return Mn.Deflate = c, Mn.deflate = w, Mn.deflateRaw = _, Mn.gzip = g, Mn;
}
var On = {}, Bt = {}, Ar, kl;
function J0() {
  if (kl) return Ar;
  kl = 1;
  var e = 30, t = 12;
  return Ar = function(r, s) {
    var i, n, l, o, h, v, u, f, m, c, w, _, g, b, S, T, I, $, C, F, V, K, O, G, P;
    i = r.state, n = r.next_in, G = r.input, l = n + (r.avail_in - 5), o = r.next_out, P = r.output, h = o - (s - r.avail_out), v = o + (r.avail_out - 257), u = i.dmax, f = i.wsize, m = i.whave, c = i.wnext, w = i.window, _ = i.hold, g = i.bits, b = i.lencode, S = i.distcode, T = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (_ += G[n++] << g, g += 8, _ += G[n++] << g, g += 8), $ = b[_ & T];
        t:
          for (; ; ) {
            if (C = $ >>> 24, _ >>>= C, g -= C, C = $ >>> 16 & 255, C === 0)
              P[o++] = $ & 65535;
            else if (C & 16) {
              F = $ & 65535, C &= 15, C && (g < C && (_ += G[n++] << g, g += 8), F += _ & (1 << C) - 1, _ >>>= C, g -= C), g < 15 && (_ += G[n++] << g, g += 8, _ += G[n++] << g, g += 8), $ = S[_ & I];
              n:
                for (; ; ) {
                  if (C = $ >>> 24, _ >>>= C, g -= C, C = $ >>> 16 & 255, C & 16) {
                    if (V = $ & 65535, C &= 15, g < C && (_ += G[n++] << g, g += 8, g < C && (_ += G[n++] << g, g += 8)), V += _ & (1 << C) - 1, V > u) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (_ >>>= C, g -= C, C = o - h, V > C) {
                      if (C = V - C, C > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (K = 0, O = w, c === 0) {
                        if (K += f - C, C < F) {
                          F -= C;
                          do
                            P[o++] = w[K++];
                          while (--C);
                          K = o - V, O = P;
                        }
                      } else if (c < C) {
                        if (K += f + c - C, C -= c, C < F) {
                          F -= C;
                          do
                            P[o++] = w[K++];
                          while (--C);
                          if (K = 0, c < F) {
                            C = c, F -= C;
                            do
                              P[o++] = w[K++];
                            while (--C);
                            K = o - V, O = P;
                          }
                        }
                      } else if (K += c - C, C < F) {
                        F -= C;
                        do
                          P[o++] = w[K++];
                        while (--C);
                        K = o - V, O = P;
                      }
                      for (; F > 2; )
                        P[o++] = O[K++], P[o++] = O[K++], P[o++] = O[K++], F -= 3;
                      F && (P[o++] = O[K++], F > 1 && (P[o++] = O[K++]));
                    } else {
                      K = o - V;
                      do
                        P[o++] = P[K++], P[o++] = P[K++], P[o++] = P[K++], F -= 3;
                      while (F > 2);
                      F && (P[o++] = P[K++], F > 1 && (P[o++] = P[K++]));
                    }
                  } else if ((C & 64) === 0) {
                    $ = S[($ & 65535) + (_ & (1 << C) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((C & 64) === 0) {
              $ = b[($ & 65535) + (_ & (1 << C) - 1)];
              continue t;
            } else if (C & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (n < l && o < v);
    F = g >> 3, n -= F, g -= F << 3, _ &= (1 << g) - 1, r.next_in = n, r.next_out = o, r.avail_in = n < l ? 5 + (l - n) : 5 - (n - l), r.avail_out = o < v ? 257 + (v - o) : 257 - (o - v), i.hold = _, i.bits = g;
  }, Ar;
}
var $r, _l;
function Q0() {
  if (_l) return $r;
  _l = 1;
  var e = un(), t = 15, a = 852, r = 592, s = 0, i = 1, n = 2, l = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], o = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return $r = function(f, m, c, w, _, g, b, S) {
    var T = S.bits, I = 0, $ = 0, C = 0, F = 0, V = 0, K = 0, O = 0, G = 0, P = 0, E = 0, L, z, U, X, B, ie = null, H = 0, Q, ae = new e.Buf16(t + 1), ve = new e.Buf16(t + 1), be = null, se = 0, ge, we, Le;
    for (I = 0; I <= t; I++)
      ae[I] = 0;
    for ($ = 0; $ < w; $++)
      ae[m[c + $]]++;
    for (V = T, F = t; F >= 1 && ae[F] === 0; F--)
      ;
    if (V > F && (V = F), F === 0)
      return _[g++] = 1 << 24 | 64 << 16 | 0, _[g++] = 1 << 24 | 64 << 16 | 0, S.bits = 1, 0;
    for (C = 1; C < F && ae[C] === 0; C++)
      ;
    for (V < C && (V = C), G = 1, I = 1; I <= t; I++)
      if (G <<= 1, G -= ae[I], G < 0)
        return -1;
    if (G > 0 && (f === s || F !== 1))
      return -1;
    for (ve[1] = 0, I = 1; I < t; I++)
      ve[I + 1] = ve[I] + ae[I];
    for ($ = 0; $ < w; $++)
      m[c + $] !== 0 && (b[ve[m[c + $]]++] = $);
    if (f === s ? (ie = be = b, Q = 19) : f === i ? (ie = l, H -= 257, be = o, se -= 257, Q = 256) : (ie = h, be = v, Q = -1), E = 0, $ = 0, I = C, B = g, K = V, O = 0, U = -1, P = 1 << V, X = P - 1, f === i && P > a || f === n && P > r)
      return 1;
    for (; ; ) {
      ge = I - O, b[$] < Q ? (we = 0, Le = b[$]) : b[$] > Q ? (we = be[se + b[$]], Le = ie[H + b[$]]) : (we = 96, Le = 0), L = 1 << I - O, z = 1 << K, C = z;
      do
        z -= L, _[B + (E >> O) + z] = ge << 24 | we << 16 | Le | 0;
      while (z !== 0);
      for (L = 1 << I - 1; E & L; )
        L >>= 1;
      if (L !== 0 ? (E &= L - 1, E += L) : E = 0, $++, --ae[I] === 0) {
        if (I === F)
          break;
        I = m[c + b[$]];
      }
      if (I > V && (E & X) !== U) {
        for (O === 0 && (O = V), B += C, K = I - O, G = 1 << K; K + O < F && (G -= ae[K + O], !(G <= 0)); )
          K++, G <<= 1;
        if (P += 1 << K, f === i && P > a || f === n && P > r)
          return 1;
        U = E & X, _[U] = V << 24 | K << 16 | B - g | 0;
      }
    }
    return E !== 0 && (_[B + E] = I - O << 24 | 64 << 16 | 0), S.bits = V, 0;
  }, $r;
}
var Sl;
function eh() {
  if (Sl) return Bt;
  Sl = 1;
  var e = un(), t = Bo(), a = Po(), r = J0(), s = Q0(), i = 0, n = 1, l = 2, o = 4, h = 5, v = 6, u = 0, f = 1, m = 2, c = -2, w = -3, _ = -4, g = -5, b = 8, S = 1, T = 2, I = 3, $ = 4, C = 5, F = 6, V = 7, K = 8, O = 9, G = 10, P = 11, E = 12, L = 13, z = 14, U = 15, X = 16, B = 17, ie = 18, H = 19, Q = 20, ae = 21, ve = 22, be = 23, se = 24, ge = 25, we = 26, Le = 27, Ze = 28, Ne = 29, fe = 30, Re = 31, Be = 32, He = 852, We = 592, Pe = 15, Fe = Pe;
  function nt(R) {
    return (R >>> 24 & 255) + (R >>> 8 & 65280) + ((R & 65280) << 8) + ((R & 255) << 24);
  }
  function xt() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function kt(R) {
    var le;
    return !R || !R.state ? c : (le = R.state, R.total_in = R.total_out = le.total = 0, R.msg = "", le.wrap && (R.adler = le.wrap & 1), le.mode = S, le.last = 0, le.havedict = 0, le.dmax = 32768, le.head = null, le.hold = 0, le.bits = 0, le.lencode = le.lendyn = new e.Buf32(He), le.distcode = le.distdyn = new e.Buf32(We), le.sane = 1, le.back = -1, u);
  }
  function vt(R) {
    var le;
    return !R || !R.state ? c : (le = R.state, le.wsize = 0, le.whave = 0, le.wnext = 0, kt(R));
  }
  function Ft(R, le) {
    var p, de;
    return !R || !R.state || (de = R.state, le < 0 ? (p = 0, le = -le) : (p = (le >> 4) + 1, le < 48 && (le &= 15)), le && (le < 8 || le > 15)) ? c : (de.window !== null && de.wbits !== le && (de.window = null), de.wrap = p, de.wbits = le, vt(R));
  }
  function Mt(R, le) {
    var p, de;
    return R ? (de = new xt(), R.state = de, de.window = null, p = Ft(R, le), p !== u && (R.state = null), p) : c;
  }
  function wt(R) {
    return Mt(R, Fe);
  }
  var Ut = !0, $t, st;
  function D(R) {
    if (Ut) {
      var le;
      for ($t = new e.Buf32(512), st = new e.Buf32(32), le = 0; le < 144; )
        R.lens[le++] = 8;
      for (; le < 256; )
        R.lens[le++] = 9;
      for (; le < 280; )
        R.lens[le++] = 7;
      for (; le < 288; )
        R.lens[le++] = 8;
      for (s(n, R.lens, 0, 288, $t, 0, R.work, { bits: 9 }), le = 0; le < 32; )
        R.lens[le++] = 5;
      s(l, R.lens, 0, 32, st, 0, R.work, { bits: 5 }), Ut = !1;
    }
    R.lencode = $t, R.lenbits = 9, R.distcode = st, R.distbits = 5;
  }
  function k(R, le, p, de) {
    var Ae, d = R.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), de >= d.wsize ? (e.arraySet(d.window, le, p - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Ae = d.wsize - d.wnext, Ae > de && (Ae = de), e.arraySet(d.window, le, p - de, Ae, d.wnext), de -= Ae, de ? (e.arraySet(d.window, le, p - de, de, 0), d.wnext = de, d.whave = d.wsize) : (d.wnext += Ae, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Ae))), 0;
  }
  function y(R, le) {
    var p, de, Ae, d, re, te, x, N, ee, De, xe, Ee, Ue, dt, Qe = 0, qe, it, mt, _t, fn, nn, et, Et, ft = new e.Buf8(4), Pt, Ot, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!R || !R.state || !R.output || !R.input && R.avail_in !== 0)
      return c;
    p = R.state, p.mode === E && (p.mode = L), re = R.next_out, Ae = R.output, x = R.avail_out, d = R.next_in, de = R.input, te = R.avail_in, N = p.hold, ee = p.bits, De = te, xe = x, Et = u;
    e:
      for (; ; )
        switch (p.mode) {
          case S:
            if (p.wrap === 0) {
              p.mode = L;
              break;
            }
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if (p.wrap & 2 && N === 35615) {
              p.check = 0, ft[0] = N & 255, ft[1] = N >>> 8 & 255, p.check = a(p.check, ft, 2, 0), N = 0, ee = 0, p.mode = T;
              break;
            }
            if (p.flags = 0, p.head && (p.head.done = !1), !(p.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              R.msg = "incorrect header check", p.mode = fe;
              break;
            }
            if ((N & 15) !== b) {
              R.msg = "unknown compression method", p.mode = fe;
              break;
            }
            if (N >>>= 4, ee -= 4, et = (N & 15) + 8, p.wbits === 0)
              p.wbits = et;
            else if (et > p.wbits) {
              R.msg = "invalid window size", p.mode = fe;
              break;
            }
            p.dmax = 1 << et, R.adler = p.check = 1, p.mode = N & 512 ? G : E, N = 0, ee = 0;
            break;
          case T:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if (p.flags = N, (p.flags & 255) !== b) {
              R.msg = "unknown compression method", p.mode = fe;
              break;
            }
            if (p.flags & 57344) {
              R.msg = "unknown header flags set", p.mode = fe;
              break;
            }
            p.head && (p.head.text = N >> 8 & 1), p.flags & 512 && (ft[0] = N & 255, ft[1] = N >>> 8 & 255, p.check = a(p.check, ft, 2, 0)), N = 0, ee = 0, p.mode = I;
          /* falls through */
          case I:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            p.head && (p.head.time = N), p.flags & 512 && (ft[0] = N & 255, ft[1] = N >>> 8 & 255, ft[2] = N >>> 16 & 255, ft[3] = N >>> 24 & 255, p.check = a(p.check, ft, 4, 0)), N = 0, ee = 0, p.mode = $;
          /* falls through */
          case $:
            for (; ee < 16; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            p.head && (p.head.xflags = N & 255, p.head.os = N >> 8), p.flags & 512 && (ft[0] = N & 255, ft[1] = N >>> 8 & 255, p.check = a(p.check, ft, 2, 0)), N = 0, ee = 0, p.mode = C;
          /* falls through */
          case C:
            if (p.flags & 1024) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              p.length = N, p.head && (p.head.extra_len = N), p.flags & 512 && (ft[0] = N & 255, ft[1] = N >>> 8 & 255, p.check = a(p.check, ft, 2, 0)), N = 0, ee = 0;
            } else p.head && (p.head.extra = null);
            p.mode = F;
          /* falls through */
          case F:
            if (p.flags & 1024 && (Ee = p.length, Ee > te && (Ee = te), Ee && (p.head && (et = p.head.extra_len - p.length, p.head.extra || (p.head.extra = new Array(p.head.extra_len)), e.arraySet(
              p.head.extra,
              de,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Ee,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              et
            )), p.flags & 512 && (p.check = a(p.check, de, Ee, d)), te -= Ee, d += Ee, p.length -= Ee), p.length))
              break e;
            p.length = 0, p.mode = V;
          /* falls through */
          case V:
            if (p.flags & 2048) {
              if (te === 0)
                break e;
              Ee = 0;
              do
                et = de[d + Ee++], p.head && et && p.length < 65536 && (p.head.name += String.fromCharCode(et));
              while (et && Ee < te);
              if (p.flags & 512 && (p.check = a(p.check, de, Ee, d)), te -= Ee, d += Ee, et)
                break e;
            } else p.head && (p.head.name = null);
            p.length = 0, p.mode = K;
          /* falls through */
          case K:
            if (p.flags & 4096) {
              if (te === 0)
                break e;
              Ee = 0;
              do
                et = de[d + Ee++], p.head && et && p.length < 65536 && (p.head.comment += String.fromCharCode(et));
              while (et && Ee < te);
              if (p.flags & 512 && (p.check = a(p.check, de, Ee, d)), te -= Ee, d += Ee, et)
                break e;
            } else p.head && (p.head.comment = null);
            p.mode = O;
          /* falls through */
          case O:
            if (p.flags & 512) {
              for (; ee < 16; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              if (N !== (p.check & 65535)) {
                R.msg = "header crc mismatch", p.mode = fe;
                break;
              }
              N = 0, ee = 0;
            }
            p.head && (p.head.hcrc = p.flags >> 9 & 1, p.head.done = !0), R.adler = p.check = 0, p.mode = E;
            break;
          case G:
            for (; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            R.adler = p.check = nt(N), N = 0, ee = 0, p.mode = P;
          /* falls through */
          case P:
            if (p.havedict === 0)
              return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = te, p.hold = N, p.bits = ee, m;
            R.adler = p.check = 1, p.mode = E;
          /* falls through */
          case E:
            if (le === h || le === v)
              break e;
          /* falls through */
          case L:
            if (p.last) {
              N >>>= ee & 7, ee -= ee & 7, p.mode = Le;
              break;
            }
            for (; ee < 3; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            switch (p.last = N & 1, N >>>= 1, ee -= 1, N & 3) {
              case 0:
                p.mode = z;
                break;
              case 1:
                if (D(p), p.mode = Q, le === v) {
                  N >>>= 2, ee -= 2;
                  break e;
                }
                break;
              case 2:
                p.mode = B;
                break;
              case 3:
                R.msg = "invalid block type", p.mode = fe;
            }
            N >>>= 2, ee -= 2;
            break;
          case z:
            for (N >>>= ee & 7, ee -= ee & 7; ee < 32; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              R.msg = "invalid stored block lengths", p.mode = fe;
              break;
            }
            if (p.length = N & 65535, N = 0, ee = 0, p.mode = U, le === v)
              break e;
          /* falls through */
          case U:
            p.mode = X;
          /* falls through */
          case X:
            if (Ee = p.length, Ee) {
              if (Ee > te && (Ee = te), Ee > x && (Ee = x), Ee === 0)
                break e;
              e.arraySet(Ae, de, d, Ee, re), te -= Ee, d += Ee, x -= Ee, re += Ee, p.length -= Ee;
              break;
            }
            p.mode = E;
            break;
          case B:
            for (; ee < 14; ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if (p.nlen = (N & 31) + 257, N >>>= 5, ee -= 5, p.ndist = (N & 31) + 1, N >>>= 5, ee -= 5, p.ncode = (N & 15) + 4, N >>>= 4, ee -= 4, p.nlen > 286 || p.ndist > 30) {
              R.msg = "too many length or distance symbols", p.mode = fe;
              break;
            }
            p.have = 0, p.mode = ie;
          /* falls through */
          case ie:
            for (; p.have < p.ncode; ) {
              for (; ee < 3; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              p.lens[xa[p.have++]] = N & 7, N >>>= 3, ee -= 3;
            }
            for (; p.have < 19; )
              p.lens[xa[p.have++]] = 0;
            if (p.lencode = p.lendyn, p.lenbits = 7, Pt = { bits: p.lenbits }, Et = s(i, p.lens, 0, 19, p.lencode, 0, p.work, Pt), p.lenbits = Pt.bits, Et) {
              R.msg = "invalid code lengths set", p.mode = fe;
              break;
            }
            p.have = 0, p.mode = H;
          /* falls through */
          case H:
            for (; p.have < p.nlen + p.ndist; ) {
              for (; Qe = p.lencode[N & (1 << p.lenbits) - 1], qe = Qe >>> 24, it = Qe >>> 16 & 255, mt = Qe & 65535, !(qe <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              if (mt < 16)
                N >>>= qe, ee -= qe, p.lens[p.have++] = mt;
              else {
                if (mt === 16) {
                  for (Ot = qe + 2; ee < Ot; ) {
                    if (te === 0)
                      break e;
                    te--, N += de[d++] << ee, ee += 8;
                  }
                  if (N >>>= qe, ee -= qe, p.have === 0) {
                    R.msg = "invalid bit length repeat", p.mode = fe;
                    break;
                  }
                  et = p.lens[p.have - 1], Ee = 3 + (N & 3), N >>>= 2, ee -= 2;
                } else if (mt === 17) {
                  for (Ot = qe + 3; ee < Ot; ) {
                    if (te === 0)
                      break e;
                    te--, N += de[d++] << ee, ee += 8;
                  }
                  N >>>= qe, ee -= qe, et = 0, Ee = 3 + (N & 7), N >>>= 3, ee -= 3;
                } else {
                  for (Ot = qe + 7; ee < Ot; ) {
                    if (te === 0)
                      break e;
                    te--, N += de[d++] << ee, ee += 8;
                  }
                  N >>>= qe, ee -= qe, et = 0, Ee = 11 + (N & 127), N >>>= 7, ee -= 7;
                }
                if (p.have + Ee > p.nlen + p.ndist) {
                  R.msg = "invalid bit length repeat", p.mode = fe;
                  break;
                }
                for (; Ee--; )
                  p.lens[p.have++] = et;
              }
            }
            if (p.mode === fe)
              break;
            if (p.lens[256] === 0) {
              R.msg = "invalid code -- missing end-of-block", p.mode = fe;
              break;
            }
            if (p.lenbits = 9, Pt = { bits: p.lenbits }, Et = s(n, p.lens, 0, p.nlen, p.lencode, 0, p.work, Pt), p.lenbits = Pt.bits, Et) {
              R.msg = "invalid literal/lengths set", p.mode = fe;
              break;
            }
            if (p.distbits = 6, p.distcode = p.distdyn, Pt = { bits: p.distbits }, Et = s(l, p.lens, p.nlen, p.ndist, p.distcode, 0, p.work, Pt), p.distbits = Pt.bits, Et) {
              R.msg = "invalid distances set", p.mode = fe;
              break;
            }
            if (p.mode = Q, le === v)
              break e;
          /* falls through */
          case Q:
            p.mode = ae;
          /* falls through */
          case ae:
            if (te >= 6 && x >= 258) {
              R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = te, p.hold = N, p.bits = ee, r(R, xe), re = R.next_out, Ae = R.output, x = R.avail_out, d = R.next_in, de = R.input, te = R.avail_in, N = p.hold, ee = p.bits, p.mode === E && (p.back = -1);
              break;
            }
            for (p.back = 0; Qe = p.lencode[N & (1 << p.lenbits) - 1], qe = Qe >>> 24, it = Qe >>> 16 & 255, mt = Qe & 65535, !(qe <= ee); ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if (it && (it & 240) === 0) {
              for (_t = qe, fn = it, nn = mt; Qe = p.lencode[nn + ((N & (1 << _t + fn) - 1) >> _t)], qe = Qe >>> 24, it = Qe >>> 16 & 255, mt = Qe & 65535, !(_t + qe <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              N >>>= _t, ee -= _t, p.back += _t;
            }
            if (N >>>= qe, ee -= qe, p.back += qe, p.length = mt, it === 0) {
              p.mode = we;
              break;
            }
            if (it & 32) {
              p.back = -1, p.mode = E;
              break;
            }
            if (it & 64) {
              R.msg = "invalid literal/length code", p.mode = fe;
              break;
            }
            p.extra = it & 15, p.mode = ve;
          /* falls through */
          case ve:
            if (p.extra) {
              for (Ot = p.extra; ee < Ot; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              p.length += N & (1 << p.extra) - 1, N >>>= p.extra, ee -= p.extra, p.back += p.extra;
            }
            p.was = p.length, p.mode = be;
          /* falls through */
          case be:
            for (; Qe = p.distcode[N & (1 << p.distbits) - 1], qe = Qe >>> 24, it = Qe >>> 16 & 255, mt = Qe & 65535, !(qe <= ee); ) {
              if (te === 0)
                break e;
              te--, N += de[d++] << ee, ee += 8;
            }
            if ((it & 240) === 0) {
              for (_t = qe, fn = it, nn = mt; Qe = p.distcode[nn + ((N & (1 << _t + fn) - 1) >> _t)], qe = Qe >>> 24, it = Qe >>> 16 & 255, mt = Qe & 65535, !(_t + qe <= ee); ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              N >>>= _t, ee -= _t, p.back += _t;
            }
            if (N >>>= qe, ee -= qe, p.back += qe, it & 64) {
              R.msg = "invalid distance code", p.mode = fe;
              break;
            }
            p.offset = mt, p.extra = it & 15, p.mode = se;
          /* falls through */
          case se:
            if (p.extra) {
              for (Ot = p.extra; ee < Ot; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              p.offset += N & (1 << p.extra) - 1, N >>>= p.extra, ee -= p.extra, p.back += p.extra;
            }
            if (p.offset > p.dmax) {
              R.msg = "invalid distance too far back", p.mode = fe;
              break;
            }
            p.mode = ge;
          /* falls through */
          case ge:
            if (x === 0)
              break e;
            if (Ee = xe - x, p.offset > Ee) {
              if (Ee = p.offset - Ee, Ee > p.whave && p.sane) {
                R.msg = "invalid distance too far back", p.mode = fe;
                break;
              }
              Ee > p.wnext ? (Ee -= p.wnext, Ue = p.wsize - Ee) : Ue = p.wnext - Ee, Ee > p.length && (Ee = p.length), dt = p.window;
            } else
              dt = Ae, Ue = re - p.offset, Ee = p.length;
            Ee > x && (Ee = x), x -= Ee, p.length -= Ee;
            do
              Ae[re++] = dt[Ue++];
            while (--Ee);
            p.length === 0 && (p.mode = ae);
            break;
          case we:
            if (x === 0)
              break e;
            Ae[re++] = p.length, x--, p.mode = ae;
            break;
          case Le:
            if (p.wrap) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, N |= de[d++] << ee, ee += 8;
              }
              if (xe -= x, R.total_out += xe, p.total += xe, xe && (R.adler = p.check = /*UPDATE(state.check, put - _out, _out);*/
              p.flags ? a(p.check, Ae, xe, re - xe) : t(p.check, Ae, xe, re - xe)), xe = x, (p.flags ? N : nt(N)) !== p.check) {
                R.msg = "incorrect data check", p.mode = fe;
                break;
              }
              N = 0, ee = 0;
            }
            p.mode = Ze;
          /* falls through */
          case Ze:
            if (p.wrap && p.flags) {
              for (; ee < 32; ) {
                if (te === 0)
                  break e;
                te--, N += de[d++] << ee, ee += 8;
              }
              if (N !== (p.total & 4294967295)) {
                R.msg = "incorrect length check", p.mode = fe;
                break;
              }
              N = 0, ee = 0;
            }
            p.mode = Ne;
          /* falls through */
          case Ne:
            Et = f;
            break e;
          case fe:
            Et = w;
            break e;
          case Re:
            return _;
          case Be:
          /* falls through */
          default:
            return c;
        }
    return R.next_out = re, R.avail_out = x, R.next_in = d, R.avail_in = te, p.hold = N, p.bits = ee, (p.wsize || xe !== R.avail_out && p.mode < fe && (p.mode < Le || le !== o)) && k(R, R.output, R.next_out, xe - R.avail_out), De -= R.avail_in, xe -= R.avail_out, R.total_in += De, R.total_out += xe, p.total += xe, p.wrap && xe && (R.adler = p.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    p.flags ? a(p.check, Ae, xe, R.next_out - xe) : t(p.check, Ae, xe, R.next_out - xe)), R.data_type = p.bits + (p.last ? 64 : 0) + (p.mode === E ? 128 : 0) + (p.mode === Q || p.mode === U ? 256 : 0), (De === 0 && xe === 0 || le === o) && Et === u && (Et = g), Et;
  }
  function Y(R) {
    if (!R || !R.state)
      return c;
    var le = R.state;
    return le.window && (le.window = null), R.state = null, u;
  }
  function W(R, le) {
    var p;
    return !R || !R.state || (p = R.state, (p.wrap & 2) === 0) ? c : (p.head = le, le.done = !1, u);
  }
  function ce(R, le) {
    var p = le.length, de, Ae, d;
    return !R || !R.state || (de = R.state, de.wrap !== 0 && de.mode !== P) ? c : de.mode === P && (Ae = 1, Ae = t(Ae, le, p, 0), Ae !== de.check) ? w : (d = k(R, le, p, p), d ? (de.mode = Re, _) : (de.havedict = 1, u));
  }
  return Bt.inflateReset = vt, Bt.inflateReset2 = Ft, Bt.inflateResetKeep = kt, Bt.inflateInit = wt, Bt.inflateInit2 = Mt, Bt.inflate = y, Bt.inflateEnd = Y, Bt.inflateGetHeader = W, Bt.inflateSetDictionary = ce, Bt.inflateInfo = "pako inflate (from Nodeca project)", Bt;
}
var Ir, Cl;
function Ho() {
  return Cl || (Cl = 1, Ir = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Ir;
}
var Dr, El;
function th() {
  if (El) return Dr;
  El = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Dr = e, Dr;
}
var Tl;
function nh() {
  if (Tl) return On;
  Tl = 1;
  var e = eh(), t = un(), a = zo(), r = Ho(), s = hi(), i = Vo(), n = th(), l = Object.prototype.toString;
  function o(u) {
    if (!(this instanceof o)) return new o(u);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, u || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(u && u.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(s[m]);
    if (this.header = new n(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = a.string2buf(f.dictionary) : l.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(s[m]);
  }
  o.prototype.push = function(u, f) {
    var m = this.strm, c = this.options.chunkSize, w = this.options.dictionary, _, g, b, S, T, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof u == "string" ? m.input = a.binstring2buf(u) : l.call(u) === "[object ArrayBuffer]" ? m.input = new Uint8Array(u) : m.input = u, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(c), m.next_out = 0, m.avail_out = c), _ = e.inflate(m, r.Z_NO_FLUSH), _ === r.Z_NEED_DICT && w && (_ = e.inflateSetDictionary(this.strm, w)), _ === r.Z_BUF_ERROR && I === !0 && (_ = r.Z_OK, I = !1), _ !== r.Z_STREAM_END && _ !== r.Z_OK)
        return this.onEnd(_), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || _ === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = a.utf8border(m.output, m.next_out), S = m.next_out - b, T = a.buf2string(m.output, b), m.next_out = S, m.avail_out = c - S, S && t.arraySet(m.output, m.output, b, S, 0), this.onData(T)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && _ !== r.Z_STREAM_END);
    return _ === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (_ = e.inflateEnd(this.strm), this.onEnd(_), this.ended = !0, _ === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, o.prototype.onData = function(u) {
    this.chunks.push(u);
  }, o.prototype.onEnd = function(u) {
    u === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = u, this.msg = this.strm.msg;
  };
  function h(u, f) {
    var m = new o(f);
    if (m.push(u, !0), m.err)
      throw m.msg || s[m.err];
    return m.result;
  }
  function v(u, f) {
    return f = f || {}, f.raw = !0, h(u, f);
  }
  return On.Inflate = o, On.inflate = h, On.inflateRaw = v, On.ungzip = h, On;
}
var Mr, Ll;
function ah() {
  if (Ll) return Mr;
  Ll = 1;
  var e = un().assign, t = K0(), a = nh(), r = Ho(), s = {};
  return e(s, t, a, r), Mr = s, Mr;
}
var Al;
function rh() {
  return Al || (Al = 1, (function(e) {
    (function() {
      var t = {}, a;
      e.exports = t, typeof X0 == "function" ? a = ah() : a = window.pako, (function(r, s) {
        r.toRGBA8 = function(i) {
          var n = i.width, l = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, n, l, i).buffer];
          var o = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(n * l * 4), u = 0; u < i.frames.length; u++) {
            var f = i.frames[u], m = f.rect.x, c = f.rect.y, w = f.rect.width, _ = f.rect.height, g = r.toRGBA8.decodeImage(f.data, w, _, i);
            if (u == 0 ? h = g : f.blend == 0 ? r._copyTile(g, w, _, h, n, l, m, c, 0) : f.blend == 1 && r._copyTile(g, w, _, h, n, l, m, c, 1), o.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, w, _, h, n, l, m, c, 0);
              else if (f.dispose == 2) {
                for (var b = u - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(o[b]).slice(0);
              }
            }
          }
          return o;
        }, r.toRGBA8.decodeImage = function(i, n, l, o) {
          var h = n * l, v = r.decode._getBPP(o), u = Math.ceil(n * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), c = o.ctype, w = o.depth, _ = r._bin.readUshort;
          if (c == 6) {
            var g = h << 2;
            if (w == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (w == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (c == 2) {
            var S = o.tabs.tRNS, T = -1, I = -1, $ = -1;
            if (S && (T = S[0], I = S[1], $ = S[2]), w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 3;
              f[C] = i[F], f[C + 1] = i[F + 1], f[C + 2] = i[F + 2], f[C + 3] = 255, T != -1 && i[F] == T && i[F + 1] == I && i[F + 2] == $ && (f[C + 3] = 0);
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 6;
              f[C] = i[F], f[C + 1] = i[F + 2], f[C + 2] = i[F + 4], f[C + 3] = 255, T != -1 && _(i, F) == T && _(i, F + 2) == I && _(i, F + 4) == $ && (f[C + 3] = 0);
            }
          } else if (c == 3) {
            var V = o.tabs.PLTE, K = o.tabs.tRNS, O = K ? K.length : 0;
            if (w == 1) for (var G = 0; G < l; G++)
              for (var P = G * u, E = G * n, b = 0; b < n; b++) {
                var C = E + b << 2, L = i[P + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, z = 3 * L;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = L < O ? K[L] : 255;
              }
            if (w == 2) for (var G = 0; G < l; G++)
              for (var P = G * u, E = G * n, b = 0; b < n; b++) {
                var C = E + b << 2, L = i[P + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, z = 3 * L;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = L < O ? K[L] : 255;
              }
            if (w == 4) for (var G = 0; G < l; G++)
              for (var P = G * u, E = G * n, b = 0; b < n; b++) {
                var C = E + b << 2, L = i[P + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, z = 3 * L;
                f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = L < O ? K[L] : 255;
              }
            if (w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, L = i[b], z = 3 * L;
              f[C] = V[z], f[C + 1] = V[z + 1], f[C + 2] = V[z + 2], f[C + 3] = L < O ? K[L] : 255;
            }
          } else if (c == 4) {
            if (w == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 1, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 1];
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, U = b << 2, X = i[U];
              f[C] = X, f[C + 1] = X, f[C + 2] = X, f[C + 3] = i[U + 2];
            }
          } else if (c == 0) {
            var T = o.tabs.tRNS ? o.tabs.tRNS : -1;
            if (w == 1) for (var b = 0; b < h; b++) {
              var X = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), B = X == T * 255 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 2) for (var b = 0; b < h; b++) {
              var X = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), B = X == T * 85 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 4) for (var b = 0; b < h; b++) {
              var X = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), B = X == T * 17 ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 8) for (var b = 0; b < h; b++) {
              var X = i[b], B = X == T ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
            if (w == 16) for (var b = 0; b < h; b++) {
              var X = i[b << 1], B = _(i, b << 1) == T ? 0 : 255;
              m[b] = B << 24 | X << 16 | X << 8 | X;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var n = new Uint8Array(i), l = 8, o = r._bin, h = o.readUshort, v = o.readUint, u = { tabs: {}, frames: [] }, f = new Uint8Array(n.length), m = 0, c, w = 0, _ = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (n[g] != _[g]) throw "The input is not a PNG file!";
          for (; l < n.length; ) {
            var b = o.readUint(n, l);
            l += 4;
            var S = o.readASCII(n, l, 4);
            if (l += 4, S == "IHDR")
              r.decode._IHDR(n, l, u);
            else if (S == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = n[l + g];
              m += b;
            } else if (S == "acTL")
              u.tabs[S] = { num_frames: v(n, l), num_plays: v(n, l + 4) }, c = new Uint8Array(n.length);
            else if (S == "fcTL") {
              if (w != 0) {
                var T = u.frames[u.frames.length - 1];
                T.data = r.decode._decompress(u, c.slice(0, w), T.rect.width, T.rect.height), w = 0;
              }
              var I = { x: v(n, l + 12), y: v(n, l + 16), width: v(n, l + 4), height: v(n, l + 8) }, $ = h(n, l + 22);
              $ = h(n, l + 20) / ($ == 0 ? 100 : $);
              var C = { rect: I, delay: Math.round($ * 1e3), dispose: n[l + 24], blend: n[l + 25] };
              u.frames.push(C);
            } else if (S == "fdAT") {
              for (var g = 0; g < b - 4; g++) c[w + g] = n[l + g + 4];
              w += b - 4;
            } else if (S == "pHYs")
              u.tabs[S] = [o.readUint(n, l), o.readUint(n, l + 4), n[l + 8]];
            else if (S == "cHRM") {
              u.tabs[S] = [];
              for (var g = 0; g < 8; g++) u.tabs[S].push(o.readUint(n, l + g * 4));
            } else if (S == "tEXt") {
              u.tabs[S] == null && (u.tabs[S] = {});
              var F = o.nextZero(n, l), V = o.readASCII(n, l, F - l), K = o.readASCII(n, F + 1, l + b - F - 1);
              u.tabs[S][V] = K;
            } else if (S == "iTXt") {
              u.tabs[S] == null && (u.tabs[S] = {});
              var F = 0, O = l;
              F = o.nextZero(n, O);
              var V = o.readASCII(n, O, F - O);
              O = F + 1, n[O], n[O + 1], O += 2, F = o.nextZero(n, O), o.readASCII(n, O, F - O), O = F + 1, F = o.nextZero(n, O), o.readUTF8(n, O, F - O), O = F + 1;
              var K = o.readUTF8(n, O, b - (O - l));
              u.tabs[S][V] = K;
            } else if (S == "PLTE")
              u.tabs[S] = o.readBytes(n, l, b);
            else if (S == "hIST") {
              var G = u.tabs.PLTE.length / 3;
              u.tabs[S] = [];
              for (var g = 0; g < G; g++) u.tabs[S].push(h(n, l + g * 2));
            } else if (S == "tRNS")
              u.ctype == 3 ? u.tabs[S] = o.readBytes(n, l, b) : u.ctype == 0 ? u.tabs[S] = h(n, l) : u.ctype == 2 && (u.tabs[S] = [h(n, l), h(n, l + 2), h(n, l + 4)]);
            else if (S == "gAMA") u.tabs[S] = o.readUint(n, l) / 1e5;
            else if (S == "sRGB") u.tabs[S] = n[l];
            else if (S == "bKGD")
              u.ctype == 0 || u.ctype == 4 ? u.tabs[S] = [h(n, l)] : u.ctype == 2 || u.ctype == 6 ? u.tabs[S] = [h(n, l), h(n, l + 2), h(n, l + 4)] : u.ctype == 3 && (u.tabs[S] = n[l]);
            else if (S == "IEND") {
              if (w != 0) {
                var T = u.frames[u.frames.length - 1];
                T.data = r.decode._decompress(u, c.slice(0, w), T.rect.width, T.rect.height), w = 0;
              }
              u.data = r.decode._decompress(u, f, u.width, u.height);
              break;
            }
            l += b, o.readUint(n, l), l += 4;
          }
          return delete u.compress, delete u.interlace, delete u.filter, u;
        }, r.decode._decompress = function(i, n, l, o) {
          return i.compress == 0 && (n = r.decode._inflate(n)), i.interlace == 0 ? n = r.decode._filterZero(n, i, 0, l, o) : i.interlace == 1 && (n = r.decode._readInterlace(n, i)), n;
        }, r.decode._inflate = function(i) {
          return s.inflate(i);
        }, r.decode._readInterlace = function(i, n) {
          for (var l = n.width, o = n.height, h = r.decode._getBPP(n), v = h >> 3, u = Math.ceil(l * h / 8), f = new Uint8Array(o * u), m = 0, c = [0, 0, 4, 0, 2, 0, 1], w = [0, 4, 0, 2, 0, 1, 0], _ = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var S = _[b], T = g[b], I = 0, $ = 0, C = c[b]; C < o; )
              C += S, $++;
            for (var F = w[b]; F < l; )
              F += T, I++;
            var V = Math.ceil(I * h / 8);
            r.decode._filterZero(i, n, m, I, $);
            for (var K = 0, O = c[b]; O < o; ) {
              for (var G = w[b], P = m + K * V << 3; G < l; ) {
                if (h == 1) {
                  var E = i[P >> 3];
                  E = E >> 7 - (P & 7) & 1, f[O * u + (G >> 3)] |= E << 7 - ((G & 3) << 0);
                }
                if (h == 2) {
                  var E = i[P >> 3];
                  E = E >> 6 - (P & 7) & 3, f[O * u + (G >> 2)] |= E << 6 - ((G & 3) << 1);
                }
                if (h == 4) {
                  var E = i[P >> 3];
                  E = E >> 4 - (P & 7) & 15, f[O * u + (G >> 1)] |= E << 4 - ((G & 1) << 2);
                }
                if (h >= 8)
                  for (var L = O * u + G * v, z = 0; z < v; z++) f[L + z] = i[(P >> 3) + z];
                P += h, G += T;
              }
              K++, O += S;
            }
            I * $ != 0 && (m += $ * (1 + V)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var n = [1, null, 3, 1, 2, null, 4][i.ctype];
          return n * i.depth;
        }, r.decode._filterZero = function(i, n, l, o, h) {
          var v = r.decode._getBPP(n), u = Math.ceil(o * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var c = l + m * u, w = c + m + 1, _ = i[w - 1];
            if (_ == 0) for (var g = 0; g < u; g++) i[c + g] = i[w + g];
            else if (_ == 1) {
              for (var g = 0; g < v; g++) i[c + g] = i[w + g];
              for (var g = v; g < u; g++) i[c + g] = i[w + g] + i[c + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[c + g] = i[w + g];
              if (_ == 2) for (var g = v; g < u; g++) i[c + g] = i[w + g] & 255;
              if (_ == 3) for (var g = v; g < u; g++) i[c + g] = i[w + g] + (i[c + g - v] >> 1) & 255;
              if (_ == 4) for (var g = v; g < u; g++) i[c + g] = i[w + g] + f(i[c + g - v], 0, 0) & 255;
            } else {
              if (_ == 2)
                for (var g = 0; g < u; g++) i[c + g] = i[w + g] + i[c + g - u] & 255;
              if (_ == 3) {
                for (var g = 0; g < v; g++) i[c + g] = i[w + g] + (i[c + g - u] >> 1) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[w + g] + (i[c + g - u] + i[c + g - v] >> 1) & 255;
              }
              if (_ == 4) {
                for (var g = 0; g < v; g++) i[c + g] = i[w + g] + f(0, i[c + g - u], 0) & 255;
                for (var g = v; g < u; g++) i[c + g] = i[w + g] + f(i[c + g - v], i[c + g - u], i[c + g - v - u]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, n, l) {
          var o = i + n - l, h = Math.abs(o - i), v = Math.abs(o - n), u = Math.abs(o - l);
          return h <= v && h <= u ? i : v <= u ? n : l;
        }, r.decode._IHDR = function(i, n, l) {
          var o = r._bin;
          l.width = o.readUint(i, n), n += 4, l.height = o.readUint(i, n), n += 4, l.depth = i[n], n++, l.ctype = i[n], n++, l.compress = i[n], n++, l.filter = i[n], n++, l.interlace = i[n], n++;
        }, r._bin = {
          nextZero: function(i, n) {
            for (; i[n] != 0; ) n++;
            return n;
          },
          readUshort: function(i, n) {
            return i[n] << 8 | i[n + 1];
          },
          writeUshort: function(i, n, l) {
            i[n] = l >> 8 & 255, i[n + 1] = l & 255;
          },
          readUint: function(i, n) {
            return i[n] * (256 * 256 * 256) + (i[n + 1] << 16 | i[n + 2] << 8 | i[n + 3]);
          },
          writeUint: function(i, n, l) {
            i[n] = l >> 24 & 255, i[n + 1] = l >> 16 & 255, i[n + 2] = l >> 8 & 255, i[n + 3] = l & 255;
          },
          readASCII: function(i, n, l) {
            for (var o = "", h = 0; h < l; h++) o += String.fromCharCode(i[n + h]);
            return o;
          },
          writeASCII: function(i, n, l) {
            for (var o = 0; o < l.length; o++) i[n + o] = l.charCodeAt(o);
          },
          readBytes: function(i, n, l) {
            for (var o = [], h = 0; h < l; h++) o.push(i[n + h]);
            return o;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, n, l) {
            for (var o = "", h, v = 0; v < l; v++) o += "%" + r._bin.pad(i[n + v].toString(16));
            try {
              h = decodeURIComponent(o);
            } catch {
              return r._bin.readASCII(i, n, l);
            }
            return h;
          }
        }, r._copyTile = function(i, n, l, o, h, v, u, f, m) {
          for (var c = Math.min(n, h), w = Math.min(l, v), _ = 0, g = 0, b = 0; b < w; b++)
            for (var S = 0; S < c; S++)
              if (u >= 0 && f >= 0 ? (_ = b * n + S << 2, g = (f + b) * h + u + S << 2) : (_ = (-f + b) * n - u + S << 2, g = b * h + S << 2), m == 0)
                o[g] = i[_], o[g + 1] = i[_ + 1], o[g + 2] = i[_ + 2], o[g + 3] = i[_ + 3];
              else if (m == 1) {
                var T = i[_ + 3] * 0.00392156862745098, I = i[_] * T, $ = i[_ + 1] * T, C = i[_ + 2] * T, F = o[g + 3] * (1 / 255), V = o[g] * F, K = o[g + 1] * F, O = o[g + 2] * F, G = 1 - T, P = T + F * G, E = P == 0 ? 0 : 1 / P;
                o[g + 3] = 255 * P, o[g + 0] = (I + V * G) * E, o[g + 1] = ($ + K * G) * E, o[g + 2] = (C + O * G) * E;
              } else if (m == 2) {
                var T = i[_ + 3], I = i[_], $ = i[_ + 1], C = i[_ + 2], F = o[g + 3], V = o[g], K = o[g + 1], O = o[g + 2];
                T == F && I == V && $ == K && C == O ? (o[g] = 0, o[g + 1] = 0, o[g + 2] = 0, o[g + 3] = 0) : (o[g] = I, o[g + 1] = $, o[g + 2] = C, o[g + 3] = T);
              } else if (m == 3) {
                var T = i[_ + 3], I = i[_], $ = i[_ + 1], C = i[_ + 2], F = o[g + 3], V = o[g], K = o[g + 1], O = o[g + 2];
                if (T == F && I == V && $ == K && C == O) continue;
                if (T < 220 && F > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, n, l, o, h, v) {
          o == null && (o = 0), v == null && (v = !1);
          for (var u = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) u[m] = f[m];
          var c = 8, w = r._bin, _ = r.crc.crc, g = w.writeUint, b = w.writeUshort, S = w.writeASCII, T = r.encode.compressPNG(i, n, l, o, v);
          g(u, c, 13), c += 4, S(u, c, "IHDR"), c += 4, g(u, c, n), c += 4, g(u, c, l), c += 4, u[c] = T.depth, c++, u[c] = T.ctype, c++, u[c] = 0, c++, u[c] = 0, c++, u[c] = 0, c++, g(u, c, _(u, c - 17, 17)), c += 4, g(u, c, 1), c += 4, S(u, c, "sRGB"), c += 4, u[c] = 1, c++, g(u, c, _(u, c - 5, 5)), c += 4;
          var I = i.length > 1;
          if (I && (g(u, c, 8), c += 4, S(u, c, "acTL"), c += 4, g(u, c, i.length), c += 4, g(u, c, 0), c += 4, g(u, c, _(u, c - 12, 12)), c += 4), T.ctype == 3) {
            var $ = T.plte.length;
            g(u, c, $ * 3), c += 4, S(u, c, "PLTE"), c += 4;
            for (var m = 0; m < $; m++) {
              var C = m * 3, F = T.plte[m], V = F & 255, K = F >> 8 & 255, O = F >> 16 & 255;
              u[c + C + 0] = V, u[c + C + 1] = K, u[c + C + 2] = O;
            }
            if (c += $ * 3, g(u, c, _(u, c - $ * 3 - 4, $ * 3 + 4)), c += 4, T.gotAlpha) {
              g(u, c, $), c += 4, S(u, c, "tRNS"), c += 4;
              for (var m = 0; m < $; m++) u[c + m] = T.plte[m] >> 24 & 255;
              c += $, g(u, c, _(u, c - $ - 4, $ + 4)), c += 4;
            }
          }
          for (var G = 0, P = 0; P < T.frames.length; P++) {
            var E = T.frames[P];
            I && (g(u, c, 26), c += 4, S(u, c, "fcTL"), c += 4, g(u, c, G++), c += 4, g(u, c, E.rect.width), c += 4, g(u, c, E.rect.height), c += 4, g(u, c, E.rect.x), c += 4, g(u, c, E.rect.y), c += 4, b(u, c, h[P]), c += 2, b(u, c, 1e3), c += 2, u[c] = E.dispose, c++, u[c] = E.blend, c++, g(u, c, _(u, c - 30, 30)), c += 4);
            var L = E.cimg, $ = L.length;
            g(u, c, $ + (P == 0 ? 0 : 4)), c += 4;
            var z = c;
            S(u, c, P == 0 ? "IDAT" : "fdAT"), c += 4, P != 0 && (g(u, c, G++), c += 4);
            for (var m = 0; m < $; m++) u[c + m] = L[m];
            c += $, g(u, c, _(u, z, c - z)), c += 4;
          }
          return g(u, c, 0), c += 4, S(u, c, "IEND"), c += 4, g(u, c, _(u, c - 4, 4)), c += 4, u.buffer.slice(0, c);
        }, r.encode.compressPNG = function(i, n, l, o, h) {
          for (var v = r.encode.compress(i, n, l, o, !1, h), u = 0; u < i.length; u++) {
            var f = v.frames[u];
            f.rect.width;
            var m = f.rect.height, c = f.bpl, w = f.bpp, _ = new Uint8Array(m * c + m);
            f.cimg = r.encode._filterZero(f.img, m, w, c, _);
          }
          return v;
        }, r.encode.compress = function(i, n, l, o, h, v) {
          v == null && (v = !1);
          for (var u = 6, f = 8, m = 4, c = 255, w = 0; w < i.length; w++)
            for (var _ = new Uint8Array(i[w]), g = _.length, b = 0; b < g; b += 4) c &= _[b + 3];
          var S = c != 255, T = {}, I = [];
          if (i.length != 0 && (T[0] = 0, I.push(0), o != 0 && o--), o != 0) {
            var $ = r.quantize(i, o, h);
            i = $.bufs;
            for (var b = 0; b < $.plte.length; b++) {
              var C = $.plte[b].est.rgba;
              T[C] == null && (T[C] = I.length, I.push(C));
            }
          } else
            for (var w = 0; w < i.length; w++)
              for (var F = new Uint32Array(i[w]), g = F.length, b = 0; b < g; b++) {
                var C = F[b];
                if ((b < n || C != F[b - 1] && C != F[b - n]) && T[C] == null && (T[C] = I.length, I.push(C), I.length >= 300))
                  break;
              }
          var V = S ? h : !1, K = I.length;
          K <= 256 && v == !1 && (K <= 2 ? f = 1 : K <= 4 ? f = 2 : K <= 16 ? f = 4 : f = 8, h && (f = 8), S = !0);
          for (var O = [], w = 0; w < i.length; w++) {
            var G = new Uint8Array(i[w]), P = new Uint32Array(G.buffer), E = 0, L = 0, z = n, U = l, X = 0;
            if (w != 0 && !V) {
              for (var B = h || w == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, ie = 0, H = 1e9, Q = 0; Q < B; Q++) {
                for (var Ne = new Uint8Array(i[w - 1 - Q]), ae = new Uint32Array(i[w - 1 - Q]), ve = n, be = l, se = -1, ge = -1, we = 0; we < l; we++) for (var Le = 0; Le < n; Le++) {
                  var b = we * n + Le;
                  P[b] != ae[b] && (Le < ve && (ve = Le), Le > se && (se = Le), we < be && (be = we), we > ge && (ge = we));
                }
                var Ze = se == -1 ? 1 : (se - ve + 1) * (ge - be + 1);
                Ze < H && (H = Ze, ie = Q, se == -1 ? (E = L = 0, z = U = 1) : (E = ve, L = be, z = se - ve + 1, U = ge - be + 1));
              }
              var Ne = new Uint8Array(i[w - 1 - ie]);
              ie == 1 && (O[O.length - 1].dispose = 2);
              var fe = new Uint8Array(z * U * 4);
              new Uint32Array(fe.buffer), r._copyTile(Ne, n, l, fe, z, U, -E, -L, 0), r._copyTile(G, n, l, fe, z, U, -E, -L, 3) ? (r._copyTile(G, n, l, fe, z, U, -E, -L, 2), X = 1) : (r._copyTile(G, n, l, fe, z, U, -E, -L, 0), X = 0), G = fe, P = new Uint32Array(G.buffer);
            }
            var Re = 4 * z;
            if (K <= 256 && v == !1) {
              Re = Math.ceil(f * z / 8);
              for (var fe = new Uint8Array(Re * U), we = 0; we < U; we++) {
                var b = we * Re, Be = we * z;
                if (f == 8) for (var Le = 0; Le < z; Le++) fe[b + Le] = T[P[Be + Le]];
                else if (f == 4) for (var Le = 0; Le < z; Le++) fe[b + (Le >> 1)] |= T[P[Be + Le]] << 4 - (Le & 1) * 4;
                else if (f == 2) for (var Le = 0; Le < z; Le++) fe[b + (Le >> 2)] |= T[P[Be + Le]] << 6 - (Le & 3) * 2;
                else if (f == 1) for (var Le = 0; Le < z; Le++) fe[b + (Le >> 3)] |= T[P[Be + Le]] << 7 - (Le & 7) * 1;
              }
              G = fe, u = 3, m = 1;
            } else if (S == !1 && i.length == 1) {
              for (var fe = new Uint8Array(z * U * 3), He = z * U, b = 0; b < He; b++) {
                var We = b * 3, Pe = b * 4;
                fe[We] = G[Pe], fe[We + 1] = G[Pe + 1], fe[We + 2] = G[Pe + 2];
              }
              G = fe, u = 2, m = 3, Re = 3 * z;
            }
            O.push({ rect: { x: E, y: L, width: z, height: U }, img: G, bpl: Re, bpp: m, blend: X, dispose: V ? 1 : 0 });
          }
          return { ctype: u, depth: f, plte: I, gotAlpha: S, frames: O };
        }, r.encode._filterZero = function(i, n, l, o, h) {
          for (var v = [], u = 0; u < 5; u++)
            if (!(n * o > 5e5 && (u == 2 || u == 3 || u == 4))) {
              for (var f = 0; f < n; f++) r.encode._filterLine(h, i, f, o, l, u);
              if (v.push(s.deflate(h)), l == 1) break;
            }
          for (var m, c = 1e9, w = 0; w < v.length; w++) v[w].length < c && (m = w, c = v[w].length);
          return v[m];
        }, r.encode._filterLine = function(i, n, l, o, h, v) {
          var u = l * o, f = u + l, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var c = 0; c < o; c++) i[f + c] = n[u + c];
          else if (v == 1) {
            for (var c = 0; c < h; c++) i[f + c] = n[u + c];
            for (var c = h; c < o; c++) i[f + c] = n[u + c] - n[u + c - h] + 256 & 255;
          } else if (l == 0) {
            for (var c = 0; c < h; c++) i[f + c] = n[u + c];
            if (v == 2) for (var c = h; c < o; c++) i[f + c] = n[u + c];
            if (v == 3) for (var c = h; c < o; c++) i[f + c] = n[u + c] - (n[u + c - h] >> 1) + 256 & 255;
            if (v == 4) for (var c = h; c < o; c++) i[f + c] = n[u + c] - m(n[u + c - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var c = 0; c < o; c++) i[f + c] = n[u + c] + 256 - n[u + c - o] & 255;
            if (v == 3) {
              for (var c = 0; c < h; c++) i[f + c] = n[u + c] + 256 - (n[u + c - o] >> 1) & 255;
              for (var c = h; c < o; c++) i[f + c] = n[u + c] + 256 - (n[u + c - o] + n[u + c - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var c = 0; c < h; c++) i[f + c] = n[u + c] + 256 - m(0, n[u + c - o], 0) & 255;
              for (var c = h; c < o; c++) i[f + c] = n[u + c] + 256 - m(n[u + c - h], n[u + c - o], n[u + c - h - o]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), n = 0; n < 256; n++) {
              for (var l = n, o = 0; o < 8; o++)
                l & 1 ? l = 3988292384 ^ l >>> 1 : l = l >>> 1;
              i[n] = l;
            }
            return i;
          })(),
          update: function(i, n, l, o) {
            for (var h = 0; h < o; h++) i = r.crc.table[(i ^ n[l + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, n, l) {
            return r.crc.update(4294967295, i, n, l) ^ 4294967295;
          }
        }, r.quantize = function(i, n, l) {
          for (var o = [], h = 0, v = 0; v < i.length; v++)
            o.push(r.encode.alphaMul(new Uint8Array(i[v]), l)), h += i[v].byteLength;
          for (var u = new Uint8Array(h), f = new Uint32Array(u.buffer), m = 0, v = 0; v < o.length; v++) {
            for (var c = o[v], w = c.length, _ = 0; _ < w; _++) u[m + _] = c[_];
            m += w;
          }
          var g = { i0: 0, i1: u.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(u, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < n; ) {
            for (var S = 0, T = 0, v = 0; v < b.length; v++) b[v].est.L > S && (S = b[v].est.L, T = v);
            if (S < 1e-3) break;
            var I = b[T], $ = r.quantize.splitPixels(u, f, I.i0, I.i1, I.est.e, I.est.eMq255), C = { i0: I.i0, i1: $, bst: null, est: null, tdst: 0, left: null, right: null };
            C.bst = r.quantize.stats(u, C.i0, C.i1), C.est = r.quantize.estats(C.bst);
            var F = { i0: $, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            F.bst = { R: [], m: [], N: I.bst.N - C.bst.N };
            for (var v = 0; v < 16; v++) F.bst.R[v] = I.bst.R[v] - C.bst.R[v];
            for (var v = 0; v < 4; v++) F.bst.m[v] = I.bst.m[v] - C.bst.m[v];
            F.est = r.quantize.estats(F.bst), I.left = C, I.right = F, b[T] = C, b.push(F);
          }
          b.sort(function(B, ie) {
            return ie.bst.N - B.bst.N;
          });
          for (var V = 0; V < o.length; V++) {
            for (var K = r.quantize.planeDst, O = new Uint8Array(o[V].buffer), G = new Uint32Array(o[V].buffer), P = O.length, v = 0; v < P; v += 4) {
              for (var E = O[v] * 0.00392156862745098, L = O[v + 1] * (1 / 255), z = O[v + 2] * (1 / 255), U = O[v + 3] * (1 / 255), X = g; X.left; ) X = K(X.est, E, L, z, U) <= 0 ? X.left : X.right;
              G[v >> 2] = X.est.rgba;
            }
            o[V] = G.buffer;
          }
          return { bufs: o, plte: b };
        }, r.quantize.getNearest = function(i, n, l, o, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, n, l, o, h), i;
          var v = r.quantize.planeDst(i.est, n, l, o, h), u = i.left, f = i.right;
          v > 0 && (u = i.right, f = i.left);
          var m = r.quantize.getNearest(u, n, l, o, h);
          if (m.tdst <= v * v) return m;
          var c = r.quantize.getNearest(f, n, l, o, h);
          return c.tdst < m.tdst ? c : m;
        }, r.quantize.planeDst = function(i, n, l, o, h) {
          var v = i.e;
          return v[0] * n + v[1] * l + v[2] * o + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, n, l, o, h) {
          var v = n - i[0], u = l - i[1], f = o - i[2], m = h - i[3];
          return v * v + u * u + f * f + m * m;
        }, r.quantize.splitPixels = function(i, n, l, o, h, v) {
          var u = r.quantize.vecDot;
          for (o -= 4; l < o; ) {
            for (; u(i, l, h) <= v; ) l += 4;
            for (; u(i, o, h) > v; ) o -= 4;
            if (l >= o) break;
            var f = n[l >> 2];
            n[l >> 2] = n[o >> 2], n[o >> 2] = f, l += 4, o -= 4;
          }
          for (; u(i, l, h) > v; ) l -= 4;
          return l + 4;
        }, r.quantize.vecDot = function(i, n, l) {
          return i[n] * l[0] + i[n + 1] * l[1] + i[n + 2] * l[2] + i[n + 3] * l[3];
        }, r.quantize.stats = function(i, n, l) {
          for (var o = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = l - n >> 2, u = n; u < l; u += 4) {
            var f = i[u] * 0.00392156862745098, m = i[u + 1] * (1 / 255), c = i[u + 2] * (1 / 255), w = i[u + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += c, h[3] += w, o[0] += f * f, o[1] += f * m, o[2] += f * c, o[3] += f * w, o[5] += m * m, o[6] += m * c, o[7] += m * w, o[10] += c * c, o[11] += c * w, o[15] += w * w;
          }
          return o[4] = o[1], o[8] = o[2], o[12] = o[3], o[9] = o[6], o[13] = o[7], o[14] = o[11], { R: o, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var n = i.R, l = i.m, o = i.N, h = l[0], v = l[1], u = l[2], f = l[3], m = o == 0 ? 0 : 1 / o, c = [
            n[0] - h * h * m,
            n[1] - h * v * m,
            n[2] - h * u * m,
            n[3] - h * f * m,
            n[4] - v * h * m,
            n[5] - v * v * m,
            n[6] - v * u * m,
            n[7] - v * f * m,
            n[8] - u * h * m,
            n[9] - u * v * m,
            n[10] - u * u * m,
            n[11] - u * f * m,
            n[12] - f * h * m,
            n[13] - f * v * m,
            n[14] - f * u * m,
            n[15] - f * f * m
          ], w = c, _ = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, S = 0;
          if (o != 0)
            for (var T = 0; T < 10 && (g = _.multVec(w, g), S = Math.sqrt(_.dot(g, g)), g = _.sml(1 / S, g), !(Math.abs(S - b) < 1e-9)); T++)
              b = S;
          var I = [h * m, v * m, u * m, f * m], $ = _.dot(_.sml(255, I), g), C = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: c,
            q: I,
            e: g,
            L: b,
            eMq255: $,
            eMq: _.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * C) << 16 | Math.round(255 * I[1] * C) << 8 | Math.round(255 * I[0] * C) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, n) {
            return [
              i[0] * n[0] + i[1] * n[1] + i[2] * n[2] + i[3] * n[3],
              i[4] * n[0] + i[5] * n[1] + i[6] * n[2] + i[7] * n[3],
              i[8] * n[0] + i[9] * n[1] + i[10] * n[2] + i[11] * n[3],
              i[12] * n[0] + i[13] * n[1] + i[14] * n[2] + i[15] * n[3]
            ];
          },
          dot: function(i, n) {
            return i[0] * n[0] + i[1] * n[1] + i[2] * n[2] + i[3] * n[3];
          },
          sml: function(i, n) {
            return [i * n[0], i * n[1], i * n[2], i * n[3]];
          }
        }, r.encode.alphaMul = function(i, n) {
          for (var l = new Uint8Array(i.length), o = i.length >> 2, h = 0; h < o; h++) {
            var v = h << 2, u = i[v + 3];
            n && (u = u < 128 ? 0 : 255);
            var f = u * (1 / 255);
            l[v + 0] = i[v + 0] * f, l[v + 1] = i[v + 1] * f, l[v + 2] = i[v + 2] * f, l[v + 3] = u;
          }
          return l;
        };
      })(t, a);
    })();
  })(_r)), _r.exports;
}
var ih = rh();
const lh = /* @__PURE__ */ W0(ih), oh = () => pa() ? Fa("NuxtImg") : "img", sh = ["alt", "src"], dg = /* @__PURE__ */ _e({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = ut("wrapper"), i = oh(), n = pe(!0), l = J(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), o = J(() => s.value?.clientHeight ?? 0), h = J(() => s.value?.clientWidth ?? 0), v = J(() => e.loading || n.value), u = J(() => {
      if (!e.blurHash) return;
      const m = Z0(e.blurHash, 32, 32), c = new Uint8Array(m), w = lh.encode([c.buffer], 32, 32, 256);
      return "data:image/png;base64," + P0(w);
    }), f = () => {
      n.value = !1, r("load");
    };
    return t({
      clientHeight: o,
      clientWidth: h
    }), (m, c) => (A(), j("div", {
      ref: "wrapper",
      class: "lc-image",
      style: At({ "--image-aspect-ratio": l.value })
    }, [
      (A(), Se(Xt(q(i)), Ce({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: c[0] || (c[0] = (w) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      u.value ? (A(), Se(wn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: Ie(() => [
          Jt(ne("img", Ce({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: u.value
          }), null, 16, sh), [
            [ni, v.value]
          ])
        ]),
        _: 1
      })) : ue("", !0)
    ], 4));
  }
}), ch = {
  key: 1,
  class: "lc-info-text__content"
}, uh = {
  key: 0,
  class: "lc-info-text__text"
}, fg = /* @__PURE__ */ _e({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: "medium" },
    size: { default: "medium" },
    text: {}
  },
  setup(e) {
    const t = En(), a = J(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = J(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (s, i) => (A(), j("article", {
      class: ye(a.value)
    }, [
      Oe(q(Je), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ne("section", null, [
        e.headline ? (A(), j("span", {
          key: 0,
          class: ye(r.value)
        }, $e(e.headline), 3)) : ue("", !0),
        e.text || s.$slots.default ? (A(), j("div", ch, [
          me(s.$slots, "default", {}, () => [
            e.text ? (A(), j("p", uh, $e(e.text), 1)) : ue("", !0)
          ])
        ])) : ue("", !0)
      ])
    ], 2));
  }
}), hg = ["center", "top"], vg = ["medium", "small"], dh = { class: "lc-link-list" }, mg = /* @__PURE__ */ _e({
  __name: "LcLinkList",
  setup(e) {
    return (t, a) => (A(), j("ul", dh, [
      me(t.$slots, "default")
    ]));
  }
}), fh = { key: 0 }, hh = { class: "lc-link-list-item__headline" }, vh = {
  key: 0,
  class: "lc-link-list-item__text"
}, gg = /* @__PURE__ */ _e({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = J(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (a, r) => (A(), j("li", {
      class: ye(t.value)
    }, [
      Oe(q(ii), Ce({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: Ie(() => [
          a.$slots.default ? (A(), j("div", fh, [
            me(a.$slots, "default")
          ])) : (A(), j(Ye, { key: 1 }, [
            e.icon ? (A(), Se(q(Je), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : ue("", !0),
            ne("div", null, [
              ne("span", hh, $e(e.headline), 1),
              e.text ? (A(), j("p", vh, $e(e.text), 1)) : ue("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), mh = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", gh = { class: "lc-lottery-cutoff-time__headline" }, bh = ["src"], ph = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, yh = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, wh = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, xh = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, $l = /* @__PURE__ */ _e({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => je.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => je.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => je.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => je.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const a = t, r = pe(), s = So(() => /* @__PURE__ */ new Date()), i = J(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": h.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), n = J(() => new Date(e.cutoffTime)), l = J(
      () => Eo({
        date: v.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), o = J(() => u("days") === 0), h = J(() => {
      const m = u("minutes");
      return o.value && m ? m < e.startAnimationTime : !1;
    }), v = J({
      get: () => r.value ?? new Date(e.cutoffTime),
      set: (m) => {
        r.value = m;
      }
    }), u = (m) => {
      if (!ai(n.value)) return null;
      const { days: c = 0, hours: w = 0, minutes: _ = 0 } = Co(s.value, n.value);
      switch (m) {
        case "days":
          return c;
        case "minutes":
          return c * 24 + w * 60 + _;
      }
    }, f = () => {
      a("cutoff-time-reached"), vo(n.value) && e.nextCutoffTime && (v.value = new Date(e.nextCutoffTime));
    };
    return (m, c) => (A(), j("div", {
      class: ye(i.value)
    }, [
      ne("span", gh, [
        h.value ? (A(), j("img", {
          key: 0,
          alt: "",
          height: "16",
          src: q(mh),
          width: "16"
        }, null, 8, bh)) : (A(), Se(q(Je), {
          key: 1,
          name: o.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        me(m.$slots, "title", {}, () => [
          ne("span", ph, $e(o.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ne("span", yh, $e(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? (A(), j("span", wh, " : ")) : ue("", !0),
      ne("div", xh, [
        o.value ? (A(), Se(q(Rd), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": v.value,
          variant: e.countdownVariant,
          onExpired: f,
          onUpdate: c[0] || (c[0] = (w) => s.value = /* @__PURE__ */ new Date())
        }, null, 8, ["expires-at", "variant"])) : (A(), Se(q(bo), Ce({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...q(fi).drawingShort }, { datetime: v.value }), {
          default: Ie(() => [
            bt($e(l.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), bg = ["default", "expressive"], kh = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, _h = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, Sh = "extra", Ch = /* @__PURE__ */ _e({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = J(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), a = J(() => s.value.flat().length), r = J(() => e.rows ? Math.ceil(a.value / e.rows) : a.value), s = J(
      () => e.fields.map(
        ({ name: i, numbers: n }) => n.map(({ icon: l, ignored: o, matching: h, value: v }) => ({
          empty: !l && !o && (v === void 0 || v === ""),
          icon: l,
          ignored: o,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, n) => (A(), j("article", {
      class: ye(t.value),
      style: At({ "--items-per-row": r.value })
    }, [
      ne("ol", {
        class: ye(["lc-lottery-numbers__list", e.listClass])
      }, [
        (A(!0), j(Ye, null, ht(s.value, (l, o) => (A(), j(Ye, { key: o }, [
          (A(!0), j(Ye, null, ht(l, ({ empty: h, icon: v, ignored: u, matching: f, name: m, number: c }, w) => (A(), j(Ye, {
            key: `${o}-${w}`
          }, [
            ne("li", {
              class: "lc-lottery-numbers__list-item",
              style: At({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              me(i.$slots, `highlight-${m}`),
              ne("div", {
                class: ye(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === Sh,
                    "lc-lottery-numbers__number--ignored": u
                  },
                  e.numberClass ? e.numberClass(c, m) : ""
                ]])
              }, [
                f ? (A(), j("div", kh, [
                  Oe(q(Je), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : ue("", !0),
                me(i.$slots, `number-${m}`, Ce({ ref_for: !0 }, { icon: v, number: c }), () => [
                  v ? (A(), Se(q(Je), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : (A(), j(Ye, { key: 1 }, [
                    bt($e(u ? "X" : c), 1)
                  ], 64))
                ])
              ], 2)
            ], 4),
            o < s.value.length - 1 && w === l.length - 1 && i.$slots["field-divider"] ? (A(), j("li", _h, [
              me(i.$slots, "field-divider")
            ])) : ue("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), pg = ["large", "medium", "small"], yg = ["medium", "small"], wg = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var qt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(qt || {});
const Eh = ["id"], Th = { class: "lc-lottery-number-selector__label" }, Lh = ["for"], Ah = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], xg = /* @__PURE__ */ _e({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const a = t, r = Oo(), s = ut("numberInputs"), i = yt(e.id), n = pe(e.fixedColumns ?? 0), l = pe(0), o = J(() => T(l.value)), h = J(
      () => u.value ? c.value : f.value
    ), v = J(() => $(l.value)), u = J(() => e.value.length >= e.selectableMax), f = J(() => {
      const B = Array.from({ length: b.value }, () => []);
      return m.value.map((ie, H) => {
        B[$(H)].push(H);
      }), E(B);
    }), m = J(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (B, ie) => e.min + ie);
    }), c = J(
      () => f.value.map(
        (B) => B.map(
          (ie) => w.value.includes(ie) ? ie : -1
        )
      )
    ), w = J(() => e.value.map((B) => m.value.indexOf(B))), _ = J(() => Math.min(g.value, n.value)), g = J(() => m.value.length), b = J(() => Math.ceil(g.value / _.value)), S = (B) => {
      const ie = h.value.length, H = h.value[0].length;
      let Q = v.value, ae = o.value;
      do
        switch (B) {
          case "down":
            Q = (Q + 1) % ie, Q === 0 && (ae = (ae + 1) % H);
            break;
          case "left":
            ae = (ae - 1 + H) % H, ae === H - 1 && (Q = (Q - 1 + ie) % ie);
            break;
          case "right":
            ae = (ae + 1) % H, ae === 0 && (Q = (Q + 1) % ie);
            break;
          case "up":
            Q = (Q - 1 + ie) % ie, Q === ie - 1 && (ae = (ae - 1 + H) % H);
            break;
        }
      while (h.value[Q][ae] === -1);
      return h.value[Q][ae];
    }, T = (B) => B % _.value, I = (B) => ({
      "lc-lottery-number-selector__number": !0,
      "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
      "lc-lottery-number-selector__number--checked": L(B),
      "lc-lottery-number-selector__number--disabled": z(B)
    }), $ = (B) => Math.floor(B / _.value), C = () => {
      if (u.value) {
        const H = f.value[v.value].filter(
          (Q) => Q > l.value && w.value.includes(Q)
        ).reverse();
        if (!H.length) return;
        l.value = H[0];
        return;
      }
      const B = f.value[v.value];
      l.value = B.at(-1) ?? 0;
    }, F = () => {
      if (u.value) {
        const H = f.value[v.value].filter(
          (Q) => Q < l.value && w.value.includes(Q)
        );
        if (!H.length) return;
        l.value = H[0];
        return;
      }
      const B = f.value[v.value];
      l.value = B[0];
    }, V = () => {
      l.value = u.value ? w.value[0] : 0;
    }, K = () => {
      const B = w.value.at(-1) ?? 0;
      l.value = u.value ? B : g.value - 1;
    }, O = (B) => {
      en(B.key, qt) && (B.preventDefault(), B.stopPropagation(), B.ctrlKey ? G(B.key) : P(B.key));
    }, G = (B) => {
      switch (B) {
        case qt.End:
          K();
          break;
        case qt.Home:
          V();
          break;
      }
    }, P = (B) => {
      switch (B) {
        case qt.ArrowDown:
          l.value = S("down");
          break;
        case qt.ArrowLeft:
          l.value = S("left");
          break;
        case qt.ArrowRight:
          l.value = S("right");
          break;
        case qt.ArrowUp:
          l.value = S("up");
          break;
        case qt.End:
          C();
          break;
        case qt.Home:
          F();
          break;
      }
    }, E = (B) => {
      const ie = Math.max(...B.map((H) => H.length));
      return B.map((H) => {
        const Q = [...H];
        for (; Q.length < ie; )
          Q.push(-1);
        return Q;
      });
    }, L = (B) => e.value.includes(B), z = (B) => e.disabled || !L(B) && u.value || e.allNumbersToggled, U = (B) => {
      const ie = [...e.value], H = ie.indexOf(B);
      H > -1 ? ie.splice(H, 1) : u.value || (ie.push(B), ie.sort((Q, ae) => Q - ae)), a("update:value", ie);
    };
    Ve(
      () => e.allNumbersToggled,
      () => {
        const B = e.allNumbersToggled ? m.value : [];
        a("update:value", B);
      }
    ), Ve(l, (B) => {
      s.value?.[B].focus();
    }), Ve(u, (B) => {
      B && a("complete");
    });
    const X = Vs(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        n.value = e.fixedColumns;
        return;
      }
      const B = s.value;
      if (!r || !B?.length) return;
      const ie = B[0].getBoundingClientRect().top;
      let H = 0;
      for (const Q of B) {
        if (Q.getBoundingClientRect().top !== ie) break;
        H++;
      }
      n.value = H;
    }, 100);
    return Ve(() => e.fixedColumns, X), pt(X), on(window, "resize", X), (B, ie) => (A(), j("fieldset", Ce(B.$attrs, {
      id: q(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ne("legend", Th, $e(e.label), 1),
      (A(!0), j(Ye, null, ht(m.value, (H, Q) => (A(), j("label", {
        key: H,
        class: ye(I(H)),
        for: `gridcell-${T(Q)}-${$(Q)}-${q(i)}`
      }, [
        ne("input", {
          id: `gridcell-${T(Q)}-${$(Q)}-${q(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: L(H),
          class: "lc-lottery-number-selector__input",
          disabled: z(H),
          tabindex: l.value === Q || L(H) ? 0 : -1,
          type: "checkbox",
          onChange: () => U(H),
          onFocusin: (ae) => l.value = Q,
          onKeydown: [
            O,
            ti(() => U(H), ["enter"])
          ]
        }, null, 40, Ah),
        me(B.$slots, "cell", Ce({ ref_for: !0 }, {
          checked: L(H),
          disabled: z(H),
          number: H
        }), () => [
          bt($e(H), 1)
        ])
      ], 10, Lh))), 128))
    ], 16, Eh));
  }
}), $h = { class: "w-full" }, Ih = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, Dh = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, Mh = { class: "lc-lottery-teaser__button-container" }, Oh = { class: "lc-lottery-teaser__button-wrap" }, Rh = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, Fh = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Nh = { class: "lc-lottery-teaser__draw-date-headline" }, kg = /* @__PURE__ */ _e({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => je.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = En(), a = J(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": s.value
      }
    ]), r = J(
      () => Eo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), s = J(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = J(
      () => e.primaryButtonProps.to ? Wn(e.primaryButtonProps.to) : "div"
    );
    return (n, l) => (A(), Se(q(tr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: a.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Xa({
      header: Ie(() => [
        me(n.$slots, "lottery-logo")
      ]),
      default: Ie(() => [
        e.variant === "expressive" ? (A(), Se(q($l), Ce({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: l[0] || (l[0] = (o) => n.$emit("outdated"))
        }), null, 16)) : ue("", !0),
        ne("section", $h, [
          (A(), Se(Xt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Ie(() => [
              e.headline ? (A(), j("strong", Ih, $e(e.headline), 1)) : ue("", !0),
              Oe(q(Mo), Ce(e.jackpot, { size: "small" }), null, 16),
              e.subline ? (A(), j("strong", Dh, $e(e.subline), 1)) : ue("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ne("section", Mh, [
          ne("div", Oh, [
            me(n.$slots, "primary-button", {}, () => [
              Oe(q(Ct), Ce(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: s.value ? "primary-ghost" : "primary",
                onClick: l[1] || (l[1] = (o) => n.$emit("primary-button-click"))
              }), {
                default: Ie(() => [
                  bt($e(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          s.value ? (A(), j("div", Rh, [
            me(n.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? (A(), Se(q(Ct), Ce({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: l[2] || (l[2] = (o) => n.$emit("secondary-button-click"))
              }), {
                default: Ie(() => [
                  bt($e(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : ue("", !0)
            ])
          ])) : ue("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: Ie(() => [
          ["default", "badge"].includes(e.variant) ? (A(), j("div", Fh, [
            ne("div", Nh, [
              Oe(q(Je), {
                name: "calendar",
                size: "small"
              }),
              ne("span", null, $e(e.drawDateHeadline), 1)
            ]),
            Oe(q(bo), Ce({ locale: e.locale, ...q(fi).drawingShort }, { datetime: e.drawDate }), {
              default: Ie(() => [
                bt($e(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : ue("", !0),
          Oe(q($l), Ce({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: l[3] || (l[3] = (o) => n.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), _g = [...Fo, "expressive"], Bh = { class: "lc-masked-value-display" }, Sg = /* @__PURE__ */ _e({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, a) => (A(), j("span", Bh, [
      (A(!0), j(Ye, null, ht(e.parts, (r) => (A(), j("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        (A(!0), j(Ye, null, ht(e.masksPerPart, (s) => (A(), j("span", {
          key: s,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      me(t.$slots, "default")
    ]));
  }
}), Wr = Math.min, Nn = Math.max, Ua = Math.round, Ia = Math.floor, Kt = (e) => ({
  x: e,
  y: e
}), Ph = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function vi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qn(e) {
  return e.split("-")[0];
}
function nr(e) {
  return e.split("-")[1];
}
function zh(e) {
  return e === "x" ? "y" : "x";
}
function Uo(e) {
  return e === "y" ? "height" : "width";
}
function yn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function qo(e) {
  return zh(yn(e));
}
function Vh(e, t, a) {
  a === void 0 && (a = !1);
  const r = nr(e), s = qo(e), i = Uo(s);
  let n = s === "x" ? r === (a ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (n = qa(n)), [n, qa(n)];
}
function Hh(e) {
  const t = qa(e);
  return [Xr(e), t, Xr(t)];
}
function Xr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Il = ["left", "right"], Dl = ["right", "left"], Uh = ["top", "bottom"], qh = ["bottom", "top"];
function jh(e, t, a) {
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? Dl : Il : t ? Il : Dl;
    case "left":
    case "right":
      return t ? Uh : qh;
    default:
      return [];
  }
}
function Zh(e, t, a, r) {
  const s = nr(e);
  let i = jh(qn(e), a === "start", r);
  return s && (i = i.map((n) => n + "-" + s), t && (i = i.concat(i.map(Xr)))), i;
}
function qa(e) {
  const t = qn(e);
  return Ph[t] + e.slice(t.length);
}
function Wh(e) {
  var t, a, r, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (a = e.right) != null ? a : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function Xh(e) {
  return typeof e != "number" ? Wh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ja(e) {
  const {
    x: t,
    y: a,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: a,
    left: t,
    right: t + r,
    bottom: a + s,
    x: t,
    y: a
  };
}
function Ml(e, t, a) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = yn(t), n = qo(t), l = Uo(n), o = qn(t), h = i === "y", v = r.x + r.width / 2 - s.width / 2, u = r.y + r.height / 2 - s.height / 2, f = r[l] / 2 - s[l] / 2;
  let m;
  switch (o) {
    case "top":
      m = {
        x: v,
        y: r.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: u
      };
      break;
    case "left":
      m = {
        x: r.x - s.width,
        y: u
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const c = nr(t);
  return c && (m[n] += f * (c === "end" ? 1 : -1) * (a && h ? -1 : 1)), m;
}
async function Yh(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: n,
    elements: l,
    strategy: o
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: u = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = vi(t, e), c = Xh(m), _ = l[f ? u === "floating" ? "reference" : "floating" : u], g = ja(await i.getClippingRect({
    element: (a = await (i.isElement == null ? void 0 : i.isElement(_))) == null || a ? _ : _.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: o
  })), b = u === "floating" ? {
    x: r,
    y: s,
    width: n.floating.width,
    height: n.floating.height
  } : n.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), T = await (i.isElement == null ? void 0 : i.isElement(S)) && await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  }, I = ja(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: b,
    offsetParent: S,
    strategy: o
  }) : b);
  return {
    top: (g.top - I.top + c.top) / T.y,
    bottom: (I.bottom - g.bottom + c.bottom) / T.y,
    left: (g.left - I.left + c.left) / T.x,
    right: (I.right - g.right + c.right) / T.x
  };
}
const Gh = 50, Kh = async (e, t, a) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: n
  } = a, l = n.detectOverflow ? n : {
    ...n,
    detectOverflow: Yh
  }, o = await (n.isRTL == null ? void 0 : n.isRTL(t));
  let h = await n.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y: u
  } = Ml(h, r, o), f = r, m = 0;
  const c = {};
  for (let w = 0; w < i.length; w++) {
    const _ = i[w];
    if (!_)
      continue;
    const {
      name: g,
      fn: b
    } = _, {
      x: S,
      y: T,
      data: I,
      reset: $
    } = await b({
      x: v,
      y: u,
      initialPlacement: r,
      placement: f,
      strategy: s,
      middlewareData: c,
      rects: h,
      platform: l,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = S ?? v, u = T ?? u, c[g] = {
      ...c[g],
      ...I
    }, $ && m < Gh && (m++, typeof $ == "object" && ($.placement && (f = $.placement), $.rects && (h = $.rects === !0 ? await n.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : $.rects), {
      x: v,
      y: u
    } = Ml(h, f, o)), w = -1);
  }
  return {
    x: v,
    y: u,
    placement: f,
    strategy: s,
    middlewareData: c
  };
}, Jh = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, r;
      const {
        placement: s,
        middlewareData: i,
        rects: n,
        initialPlacement: l,
        platform: o,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: u = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: c = "none",
        flipAlignment: w = !0,
        ..._
      } = vi(e, t);
      if ((a = i.arrow) != null && a.alignmentOffset)
        return {};
      const g = qn(s), b = yn(l), S = qn(l) === l, T = await (o.isRTL == null ? void 0 : o.isRTL(h.floating)), I = f || (S || !w ? [qa(l)] : Hh(l)), $ = c !== "none";
      !f && $ && I.push(...Zh(l, w, c, T));
      const C = [l, ...I], F = await o.detectOverflow(t, _), V = [];
      let K = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && V.push(F[g]), u) {
        const E = Vh(s, n, T);
        V.push(F[E[0]], F[E[1]]);
      }
      if (K = [...K, {
        placement: s,
        overflows: V
      }], !V.every((E) => E <= 0)) {
        var O, G;
        const E = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, L = C[E];
        if (L && (!(u === "alignment" ? b !== yn(L) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        K.every((X) => yn(X.placement) === b ? X.overflows[0] > 0 : !0)))
          return {
            data: {
              index: E,
              overflows: K
            },
            reset: {
              placement: L
            }
          };
        let z = (G = K.filter((U) => U.overflows[0] <= 0).sort((U, X) => U.overflows[1] - X.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!z)
          switch (m) {
            case "bestFit": {
              var P;
              const U = (P = K.filter((X) => {
                if ($) {
                  const B = yn(X.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((X) => [X.placement, X.overflows.filter((B) => B > 0).reduce((B, ie) => B + ie, 0)]).sort((X, B) => X[1] - B[1])[0]) == null ? void 0 : P[0];
              U && (z = U);
              break;
            }
            case "initialPlacement":
              z = l;
              break;
          }
        if (s !== z)
          return {
            reset: {
              placement: z
            }
          };
      }
      return {};
    }
  };
}, Qh = /* @__PURE__ */ new Set(["left", "top"]);
async function ev(e, t) {
  const {
    placement: a,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), n = qn(a), l = nr(a), o = yn(a) === "y", h = Qh.has(n) ? -1 : 1, v = i && o ? -1 : 1, u = vi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: c
  } = typeof u == "number" ? {
    mainAxis: u,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: u.mainAxis || 0,
    crossAxis: u.crossAxis || 0,
    alignmentAxis: u.alignmentAxis
  };
  return l && typeof c == "number" && (m = l === "end" ? c * -1 : c), o ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const tv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, r;
      const {
        x: s,
        y: i,
        placement: n,
        middlewareData: l
      } = t, o = await ev(t, e);
      return n === ((a = l.offset) == null ? void 0 : a.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: s + o.x,
        y: i + o.y,
        data: {
          ...o,
          placement: n
        }
      };
    }
  };
};
function ar() {
  return typeof window < "u";
}
function An(e) {
  return mi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function It(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function tn(e) {
  var t;
  return (t = (mi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function mi(e) {
  return ar() ? e instanceof Node || e instanceof It(e).Node : !1;
}
function Zt(e) {
  return ar() ? e instanceof Element || e instanceof It(e).Element : !1;
}
function dn(e) {
  return ar() ? e instanceof HTMLElement || e instanceof It(e).HTMLElement : !1;
}
function Ol(e) {
  return !ar() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof It(e).ShadowRoot;
}
function rr(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: r,
    display: s
  } = Wt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + a) && s !== "inline" && s !== "contents";
}
function nv(e) {
  return /^(table|td|th)$/.test(An(e));
}
function ir(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const av = /transform|translate|scale|rotate|perspective|filter/, rv = /paint|layout|strict|content/, bn = (e) => !!e && e !== "none";
let Or;
function gi(e) {
  const t = Zt(e) ? Wt(e) : e;
  return bn(t.transform) || bn(t.translate) || bn(t.scale) || bn(t.rotate) || bn(t.perspective) || !bi() && (bn(t.backdropFilter) || bn(t.filter)) || av.test(t.willChange || "") || rv.test(t.contain || "");
}
function iv(e) {
  let t = Sn(e);
  for (; dn(t) && !va(t); ) {
    if (gi(t))
      return t;
    if (ir(t))
      return null;
    t = Sn(t);
  }
  return null;
}
function bi() {
  return Or == null && (Or = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Or;
}
function va(e) {
  return /^(html|body|#document)$/.test(An(e));
}
function Wt(e) {
  return It(e).getComputedStyle(e);
}
function lr(e) {
  return Zt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Sn(e) {
  if (An(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Ol(e) && e.host || // Fallback.
    tn(e)
  );
  return Ol(t) ? t.host : t;
}
function jo(e) {
  const t = Sn(e);
  return va(t) ? (e.ownerDocument || e).body : dn(t) && rr(t) ? t : jo(t);
}
function ma(e, t, a) {
  var r;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const s = jo(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), n = It(s);
  if (i) {
    const l = Yr(n);
    return t.concat(n, n.visualViewport || [], rr(s) ? s : [], l && a ? ma(l) : []);
  } else
    return t.concat(s, ma(s, [], a));
}
function Yr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Zo(e) {
  const t = Wt(e);
  let a = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = dn(e), i = s ? e.offsetWidth : a, n = s ? e.offsetHeight : r, l = Ua(a) !== i || Ua(r) !== n;
  return l && (a = i, r = n), {
    width: a,
    height: r,
    $: l
  };
}
function pi(e) {
  return Zt(e) ? e : e.contextElement;
}
function Bn(e) {
  const t = pi(e);
  if (!dn(t))
    return Kt(1);
  const a = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = Zo(t);
  let n = (i ? Ua(a.width) : a.width) / r, l = (i ? Ua(a.height) : a.height) / s;
  return (!n || !Number.isFinite(n)) && (n = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: n,
    y: l
  };
}
const lv = /* @__PURE__ */ Kt(0);
function Wo(e) {
  const t = It(e);
  return !bi() || !t.visualViewport ? lv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ov(e, t, a) {
  return t === void 0 && (t = !1), !!a && t && a === It(e);
}
function Cn(e, t, a, r) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const s = e.getBoundingClientRect(), i = pi(e);
  let n = Kt(1);
  t && (r ? Zt(r) && (n = Bn(r)) : n = Bn(e));
  const l = ov(i, a, r) ? Wo(i) : Kt(0);
  let o = (s.left + l.x) / n.x, h = (s.top + l.y) / n.y, v = s.width / n.x, u = s.height / n.y;
  if (i && r) {
    const f = It(i), m = Zt(r) ? It(r) : r;
    let c = f, w = Yr(c);
    for (; w && m !== c; ) {
      const _ = Bn(w), g = w.getBoundingClientRect(), b = Wt(w), S = g.left + (w.clientLeft + parseFloat(b.paddingLeft)) * _.x, T = g.top + (w.clientTop + parseFloat(b.paddingTop)) * _.y;
      o *= _.x, h *= _.y, v *= _.x, u *= _.y, o += S, h += T, c = It(w), w = Yr(c);
    }
  }
  return ja({
    width: v,
    height: u,
    x: o,
    y: h
  });
}
function or(e, t) {
  const a = lr(e).scrollLeft;
  return t ? t.left + a : Cn(tn(e)).left + a;
}
function Xo(e, t) {
  const a = e.getBoundingClientRect(), r = a.left + t.scrollLeft - or(e, a), s = a.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function sv(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", n = tn(r), l = t ? ir(t.floating) : !1;
  if (r === n || l && i)
    return a;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Kt(1);
  const v = Kt(0), u = dn(r);
  if ((u || !i) && ((An(r) !== "body" || rr(n)) && (o = lr(r)), u)) {
    const m = Cn(r);
    h = Bn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = n && !u && !i ? Xo(n, o) : Kt(0);
  return {
    width: a.width * h.x,
    height: a.height * h.y,
    x: a.x * h.x - o.scrollLeft * h.x + v.x + f.x,
    y: a.y * h.y - o.scrollTop * h.y + v.y + f.y
  };
}
function cv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function uv(e) {
  const t = lr(e), a = e.ownerDocument.body, r = Nn(e.scrollWidth, e.clientWidth, a.scrollWidth, a.clientWidth), s = Nn(e.scrollHeight, e.clientHeight, a.scrollHeight, a.clientHeight);
  let i = -t.scrollLeft + or(e);
  const n = -t.scrollTop;
  return Wt(a).direction === "rtl" && (i += Nn(e.clientWidth, a.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: n
  };
}
const dv = 25;
function fv(e, t, a) {
  a === void 0 && (a = "viewport");
  const r = a === "layoutViewport", s = It(e), i = tn(e), n = s.visualViewport;
  let l = i.clientWidth, o = i.clientHeight, h = 0, v = 0;
  if (n) {
    const f = !bi() || t === "fixed";
    r ? f || (h = -n.offsetLeft, v = -n.offsetTop) : (l = n.width, o = n.height, f && (h = n.offsetLeft, v = n.offsetTop));
  }
  if (or(i) <= 0) {
    const f = i.ownerDocument, m = f.body, c = getComputedStyle(m), w = f.compatMode === "CSS1Compat" && parseFloat(c.marginLeft) + parseFloat(c.marginRight) || 0, _ = Math.abs(i.clientWidth - m.clientWidth - w), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? _ / 2 : _;
    g <= dv && (l -= g);
  }
  return {
    width: l,
    height: o,
    x: h,
    y: v
  };
}
function hv(e, t) {
  const a = Cn(e, !0, t === "fixed"), r = a.top + e.clientTop, s = a.left + e.clientLeft, i = Bn(e), n = e.clientWidth * i.x, l = e.clientHeight * i.y, o = s * i.x, h = r * i.y;
  return {
    width: n,
    height: l,
    x: o,
    y: h
  };
}
function Rl(e, t, a) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = fv(e, a, t);
  else if (t === "document")
    r = uv(tn(e));
  else if (Zt(t))
    r = hv(t, a);
  else {
    const s = Wo(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return ja(r);
}
function vv(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let r = ma(e, [], !1).filter((l) => Zt(l) && An(l) !== "body"), s = null;
  const i = Wt(e).position === "fixed";
  let n = i ? Sn(e) : e;
  for (; Zt(n) && !va(n); ) {
    const l = Wt(n), o = gi(n), h = s ? s.position : i ? "fixed" : "";
    !o && (h === "fixed" || h === "absolute" && l.position === "static") ? r = r.filter((u) => u !== n) : s = l, n = Sn(n);
  }
  return t.set(e, r), r;
}
function mv(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: r,
    strategy: s
  } = e;
  const n = [...a === "clippingAncestors" ? ir(t) ? [] : vv(t, this._c) : [].concat(a), r], l = Rl(t, n[0], s);
  let o = l.top, h = l.right, v = l.bottom, u = l.left;
  for (let f = 1; f < n.length; f++) {
    const m = Rl(t, n[f], s);
    o = Nn(m.top, o), h = Wr(m.right, h), v = Wr(m.bottom, v), u = Nn(m.left, u);
  }
  return {
    width: h - u,
    height: v - o,
    x: u,
    y: o
  };
}
function gv(e) {
  const {
    width: t,
    height: a
  } = Zo(e);
  return {
    width: t,
    height: a
  };
}
function bv(e, t, a) {
  const r = dn(t), s = tn(t), i = a === "fixed", n = Cn(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const o = Kt(0);
  if ((r || !i) && ((An(t) !== "body" || rr(s)) && (l = lr(t)), r)) {
    const f = Cn(t, !0, i, t);
    o.x = f.x + t.clientLeft, o.y = f.y + t.clientTop;
  }
  !r && s && (o.x = or(s));
  const h = s && !r && !i ? Xo(s, l) : Kt(0), v = n.left + l.scrollLeft - o.x - h.x, u = n.top + l.scrollTop - o.y - h.y;
  return {
    x: v,
    y: u,
    width: n.width,
    height: n.height
  };
}
function Rr(e) {
  return Wt(e).position === "static";
}
function Fl(e, t) {
  if (!dn(e) || Wt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return tn(e) === a && (a = a.ownerDocument.body), a;
}
function Yo(e, t) {
  const a = It(e);
  if (ir(e))
    return a;
  if (!dn(e)) {
    let s = Sn(e);
    for (; s && !va(s); ) {
      if (Zt(s) && !Rr(s))
        return s;
      s = Sn(s);
    }
    return a;
  }
  let r = Fl(e, t);
  for (; r && nv(r) && Rr(r); )
    r = Fl(r, t);
  return r && va(r) && Rr(r) && !gi(r) ? a : r || iv(e) || a;
}
const pv = async function(e) {
  const t = this.getOffsetParent || Yo, a = this.getDimensions, r = await a(e.floating);
  return {
    reference: bv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function yv(e) {
  return Wt(e).direction === "rtl";
}
const wv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: sv,
  getDocumentElement: tn,
  getClippingRect: mv,
  getOffsetParent: Yo,
  getElementRects: pv,
  getClientRects: cv,
  getDimensions: gv,
  getScale: Bn,
  isElement: Zt,
  isRTL: yv
};
function Go(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function xv(e, t, a) {
  let r = null, s;
  const i = tn(e);
  function n() {
    var v;
    clearTimeout(s), (v = r) == null || v.disconnect(), r = null;
  }
  function l(v, u) {
    v === void 0 && (v = !1), u === void 0 && (u = 1), n();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: c,
      width: w,
      height: _
    } = f;
    if (v || t(), !w || !_)
      return;
    const g = Ia(c), b = Ia(i.clientWidth - (m + w)), S = Ia(i.clientHeight - (c + _)), T = Ia(m), $ = {
      rootMargin: -g + "px " + -b + "px " + -S + "px " + -T + "px",
      threshold: Nn(0, Wr(1, u)) || 1
    };
    let C = !0;
    function F(V) {
      const K = V[0].intersectionRatio;
      if (!Go(f, e.getBoundingClientRect()))
        return l();
      if (K !== u) {
        if (!C)
          return l();
        K ? l(!1, K) : s = setTimeout(() => {
          l(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...$,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, $);
    }
    r.observe(e);
  }
  const o = It(e), h = () => l(a);
  return o.addEventListener("resize", h), l(!0), () => {
    o.removeEventListener("resize", h), n();
  };
}
function Ko(e, t, a, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: n = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: o = !1
  } = r, h = pi(e), v = s || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    s && g.addEventListener("scroll", a), i && g.addEventListener("resize", a);
  });
  const u = h && l ? xv(h, a, i) : null;
  let f = -1, m = null;
  n && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), a();
  }), h && !o && m.observe(h), t && m.observe(t));
  let c, w = o ? Cn(e) : null;
  o && _();
  function _() {
    const g = Cn(e);
    w && !Go(w, g) && a(), w = g, c = requestAnimationFrame(_);
  }
  return a(), () => {
    var g;
    v.forEach((b) => {
      s && b.removeEventListener("scroll", a), i && b.removeEventListener("resize", a);
    }), u?.(), (g = m) == null || g.disconnect(), m = null, o && cancelAnimationFrame(c);
  };
}
const Jo = tv, Qo = Jh, kv = (e, t, a) => {
  const r = /* @__PURE__ */ new Map(), s = a ?? {}, i = {
    ...wv,
    ...s.platform,
    _c: r
  };
  return Kh(e, t, {
    ...s,
    platform: i
  });
};
function _v(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Nl(e) {
  if (_v(e)) {
    const t = e.$el;
    return mi(t) && An(t) === "#comment" ? null : t;
  }
  return e;
}
function es(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Bl(e, t) {
  const a = es(e);
  return Math.round(t * a) / a;
}
function ts(e, t, a) {
  a === void 0 && (a = {});
  const r = a.whileElementsMounted, s = J(() => {
    var C;
    return (C = Ge(a.open)) != null ? C : !0;
  }), i = J(() => Ge(a.middleware)), n = J(() => {
    var C;
    return (C = Ge(a.placement)) != null ? C : "bottom";
  }), l = J(() => {
    var C;
    return (C = Ge(a.strategy)) != null ? C : "absolute";
  }), o = J(() => {
    var C;
    return (C = Ge(a.transform)) != null ? C : !0;
  }), h = J(() => Nl(e.value)), v = J(() => Nl(t.value)), u = pe(0), f = pe(0), m = pe(l.value), c = pe(n.value), w = Hn({}), _ = pe(!1), g = J(() => {
    const C = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return C;
    const F = Bl(v.value, u.value), V = Bl(v.value, f.value);
    return o.value ? {
      ...C,
      transform: "translate(" + F + "px, " + V + "px)",
      ...es(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: F + "px",
      top: V + "px"
    };
  });
  let b;
  function S() {
    if (h.value == null || v.value == null)
      return;
    const C = s.value;
    kv(h.value, v.value, {
      middleware: i.value,
      placement: n.value,
      strategy: l.value
    }).then((F) => {
      u.value = F.x, f.value = F.y, m.value = F.strategy, c.value = F.placement, w.value = F.middlewareData, _.value = C !== !1;
    });
  }
  function T() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (T(), r === void 0) {
      S();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, S);
      return;
    }
  }
  function $() {
    s.value || (_.value = !1);
  }
  return Ve([i, n, l, s], S, {
    flush: "sync"
  }), Ve([h, v], I, {
    flush: "sync"
  }), Ve(s, $, {
    flush: "sync"
  }), Ts() && Ls(T), {
    x: In(u),
    y: In(f),
    strategy: In(m),
    placement: In(c),
    middlewareData: In(w),
    isPositioned: In(_),
    floatingStyles: g,
    update: S
  };
}
const Oa = pe(!1);
let Pn, zn, Vn, Gr = 0;
const yi = () => (pt(() => {
  Gr += 1, Sv();
}), Tn(() => {
  Gr -= 1, Cv();
}), Oa), Sv = () => {
  typeof window > "u" || (Pn || (Pn = () => Oa.value = !0, window.addEventListener("keydown", Pn, !0)), zn || (zn = () => Oa.value = !1, window.addEventListener("mousedown", zn, !0)), Vn || (Vn = () => Oa.value = !1, window.addEventListener("pointerdown", Vn, !0)));
}, Cv = () => {
  typeof window > "u" || Gr || (Pn && (window.removeEventListener("keydown", Pn, !0), Pn = null), zn && (window.removeEventListener("mousedown", zn, !0), zn = null), Vn && (window.removeEventListener("pointerdown", Vn, !0), Vn = null));
}, ns = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, Cg = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Vt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Vt || {});
const Ev = {
  ref: "container",
  class: "lc-menu-button"
}, Tv = ["id", "aria-activedescendant"], Lv = ["id", "aria-selected", "onClick"], Eg = /* @__PURE__ */ _e({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = ut("button"), i = ut("menu"), n = pe(null), l = pe(!1), { floatingStyles: o } = ts(s, i, {
      middleware: [
        Jo({
          alignmentAxis: 4
        }),
        Qo(),
        ns
      ],
      placement: () => e.placement,
      whileElementsMounted: Ko
    }), h = yt(e.id), v = yi(), u = J(() => {
      if (!(!l.value || !St(n.value)))
        return `${h}-menuitem-${n.value}`;
    }), f = J(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      l.value && (n.value = null, l.value = !1);
    }, c = () => {
      if (l.value) {
        m();
        return;
      }
      g();
    }, w = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, _ = (b) => {
      if (!en(b.key, Vt)) return;
      b.key !== Vt.Tab && (b.preventDefault(), b.stopPropagation());
      const S = e.options.length - 1;
      switch (b.key) {
        case Vt.ArrowDown:
          if (l.value && St(n.value)) {
            n.value = Math.min(S, n.value + 1);
            break;
          }
          n.value = 0, g();
          break;
        case Vt.ArrowUp:
          if (l.value && St(n.value)) {
            n.value = Math.max(0, n.value - 1);
            break;
          }
          n.value = S, g();
          break;
        case Vt.End:
          if (!l.value) return;
          n.value = S;
          break;
        case Vt.Enter:
        case Vt.Space:
          if (l.value && St(n.value)) {
            w(e.options[n.value]);
            break;
          }
          n.value = 0, g();
          break;
        case Vt.Escape:
        case Vt.Tab:
          m();
          break;
        case Vt.Home:
          if (!l.value) return;
          n.value = 0;
          break;
      }
    }, g = () => {
      l.value || (l.value = !0, e.value && (n.value = f.value));
    };
    return Ya(i, m, {
      ignore: [s, ...Ge(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), pt(() => {
      e.value && (n.value = f.value);
    }), (b, S) => (A(), j("div", Ev, [
      Oe(q(Ct), Ce({
        id: q(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${q(h)}-menu`,
        "aria-expanded": l.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: c,
        onKeydown: _
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      (A(), Se(ba, { to: "body" }, [
        l.value ? (A(), Se(q(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: At({ ...q(o), zIndex: e.zIndex })
        }, {
          default: Ie(() => [
            ne("ul", {
              id: `${q(h)}-menu`,
              "aria-activedescendant": u.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              (A(!0), j(Ye, null, ht(e.options, (T, I) => (A(), j("li", {
                key: `${T.label}-${"value" in T ? T.value : "action"}`,
                class: ye(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": n.value === I && q(v),
                  "lc-menu-button__menu-item--selected": "value" in T && T.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${q(h)}-menuitem-${I}`,
                  "aria-selected": "value" in T && T.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: ($) => w(T)
                }, [
                  Oe(q(Je), {
                    name: T.icon
                  }, null, 8, ["name"]),
                  ne("span", null, $e(T.label), 1),
                  "value" in T && T.value === e.value ? (A(), Se(q(Je), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : ue("", !0)
                ], 8, Lv)
              ], 2))), 128))
            ], 8, Tv)
          ]),
          _: 1
        }, 8, ["style"])) : ue("", !0)
      ]))
    ], 512));
  }
}), Av = { class: "lc-message-box__headline" }, $v = {
  key: 0,
  class: "lc-message-box__text"
}, Tg = /* @__PURE__ */ _e({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ sa({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: "medium" },
    text: {},
    variant: { default: "default" }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, a = Za(e, "modelValue"), r = J(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (s, i) => (A(), Se(q(ff), {
      modelValue: a.value,
      "onUpdate:modelValue": i[0] || (i[0] = (n) => a.value = n),
      class: ye(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: Ie(() => [
        ne("span", Av, [
          Oe(q(Je), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ne("span", null, $e(e.headline), 1)
        ])
      ]),
      default: Ie(() => [
        me(s.$slots, "default", {}, () => [
          e.text ? (A(), j("p", $v, $e(e.text), 1)) : ue("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
}), Lg = ["medium", "small"], Ag = ["default", "info", "warning"];
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var ln;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(ln || (ln = {}));
const Ra = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), as = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Fr = (e, t) => (e.match(new RegExp(Ra(t), "g")) || []).length, Iv = (e, t) => e.substring(0, e.indexOf(t)), rs = [
  ",",
  ".",
  "٫",
  "。"
], Pl = "(0|[1-9]\\d*)";
class Dv {
  constructor(t) {
    var a, r, s, i, n, l;
    const { currency: o, currencyDisplay: h, locale: v, precision: u, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: o,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const c = new Intl.NumberFormat(v, this.options), w = c.formatToParts(123456);
    this.currency = (a = w.find(({ type: b }) => b === "currency")) === null || a === void 0 ? void 0 : a.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = w.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (s = w.find(({ type: b }) => b === "group")) === null || s === void 0 ? void 0 : s.value, this.minusSign = (i = c.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof u == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = u : (this.minimumFractionDigits = (n = u?.min) !== null && n !== void 0 ? n : c.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (l = u?.max) !== null && l !== void 0 ? l : c.resolvedOptions().maximumFractionDigits);
    const _ = (b) => Iv(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = _(c.format(1)), this.suffix = g(c.format(1)), this.negativePrefix = _(c.format(-1)), this.negativeSuffix = g(c.format(-1));
  }
  parse(t) {
    if (t) {
      const a = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, a), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Ra(this.decimalSymbol)}(\\d*))?` : "", s = this.stripGroupingSeparator(t).match(new RegExp(`^${Pl}${r}$`));
      if (s && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(s[1])))
        return +`${a ? "-" : ""}${this.onlyDigits(s[1])}.${this.onlyDigits(s[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, a) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(a.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(a.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, a = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...a }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${Pl}${Ra(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, a) {
    return `${a ? this.negativePrefix : this.prefix}${t}${a ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Ra(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, a) {
    return t.replace(a ? this.negativePrefix : this.prefix, "").replace(a ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, a) {
    return rs.forEach((r) => {
      t = t.substring(0, a) + t.substring(a).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((a, r) => {
      t = t.replace(new RegExp(a, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class is {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class Mv extends is {
  conformToMask(t, a = "") {
    const r = this.currencyFormat.isNegative(t), s = (c) => c === "" && r && !(this.currencyFormat.minusSign === void 0 ? a === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : a === this.currencyFormat.negativePrefix), i = (c) => {
      if (s(c))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(c))
          return c;
        if (c.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(c);
      }
      return null;
    };
    let n = t;
    n = this.currencyFormat.stripCurrency(n, r), n = this.currencyFormat.stripSignLiterals(n);
    const l = i(n);
    if (l != null)
      return this.currencyFormat.insertCurrency(l, r);
    const [o, ...h] = n.split(this.currencyFormat.decimalSymbol), v = as(this.currencyFormat.onlyDigits(o)), u = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && u.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? a === t.slice(0, -2) + this.currencyFormat.negativeSuffix : a === t.slice(0, -1));
    return f || m || s(v) ? a : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${u}`,
      fractionDigits: u
    } : "";
  }
}
class Ov extends is {
  conformToMask(t, a = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(a) === 0 && this.currencyFormat.stripCurrency(a, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), s = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${as(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: s,
      fractionDigits: s.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Rv = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class Fv {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const a = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    a !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(a))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Rv,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new Dv(this.options), this.numberMask = this.options.autoDecimalDigits ? new Ov(this.currencyFormat) : new Mv(this.currencyFormat);
    const a = {
      [ln.precision]: this.currencyFormat.maximumFractionDigits,
      [ln.thousands]: 3,
      [ln.tenThousands]: 4,
      [ln.millions]: 6,
      [ln.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? a[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== ln.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, a;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((a = this.options.valueRange) === null || a === void 0 ? void 0 : a.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, a;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((a = this.options.valueRange) === null || a === void 0 ? void 0 : a.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, a) {
    return t / Math.pow(10, a ?? this.valueScalingFractionDigits);
  }
  toInteger(t, a) {
    return Number(t.toFixed(a ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, a = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let s;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: n } = r;
        let { maximumFractionDigits: l, minimumFractionDigits: o } = this.currencyFormat;
        this.focus ? o = a ? n.replace(/0+$/, "").length : Math.min(l, n.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || o === 0) && (o = l = 0), s = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: o,
          maximumFractionDigits: l
        });
      } else
        s = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(s) && this.currencyFormat.parse(s) !== 0 && (s = s.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = s, this.numberValue = this.currencyFormat.parse(s);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: a, selectionStart: r } = this.el, s = t;
      if (r && s.data && rs.includes(s.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(a), this.focus && r != null) {
        const i = () => {
          const { prefix: n, suffix: l, decimalSymbol: o, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let u = a.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (a.startsWith("(") || a.startsWith("-")) && !a.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Fr(this.formattedValue, v) === Fr(a, v) + 1)
            return f - u - 1;
          if (f < u)
            return r;
          if (o !== void 0 && a.indexOf(o) !== -1) {
            const m = a.indexOf(o) + 1;
            if (Math.abs(f - a.length) > 1 && r <= m)
              return this.formattedValue.indexOf(o) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(a.substring(m)).length - 1 === h && (u -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - u : Math.max(f - Math.max(u, l.length), n.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: a, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), a != null && r != null && Math.abs(a - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (a != null) {
          const s = this.getCaretPositionOnFocus(t, a);
          this.setCaretPosition(s);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, a) {
    if (this.numberValue == null)
      return a;
    const { prefix: r, negativePrefix: s, suffix: i, negativeSuffix: n, groupingSymbol: l, currency: o } = this.currencyFormat, h = this.numberValue < 0, v = h ? s : r, u = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (a <= 1)
          return 1;
        if (t.endsWith(")") && a > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? n.length : i.length;
      if (a >= t.length - m)
        return this.formattedValue.length - m;
      if (a < u)
        return u;
    }
    let f = a;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && a >= u && o !== void 0 && v.includes(o) && (f -= u, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && l !== void 0 && (f -= Fr(t.substring(0, a), l)), f;
  }
  setCaretPosition(t, a = t) {
    this.el.setSelectionRange(t, a);
  }
}
const Nv = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Bv(e, t) {
  var a, r, s, i;
  let n;
  const l = pe(null), o = pe(null), h = pe(null), v = Qr();
  v?.emit || ((r = (a = v?.proxy) === null || a === void 0 ? void 0 : a.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const u = v?.props || ((s = v?.proxy) === null || s === void 0 ? void 0 : s.$props), f = As.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = J(() => u?.[f ? "modelValue" : "value"]);
  return Ve(l, (c) => {
    var w;
    if (c) {
      const _ = Nv((w = c?.$el) !== null && w !== void 0 ? w : c);
      _ ? (n = new Fv({
        el: _,
        options: e,
        onInput: (g) => {
          h.value = g.number, o.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), n.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      n = null;
  }), {
    inputRef: l,
    numberValue: h,
    formattedValue: o,
    setValue: (c) => n?.setValue(c),
    setOptions: (c) => n?.setOptions(c)
  };
}
const zl = 2, $g = /* @__PURE__ */ _e({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => je.general.currency },
    locale: { default: () => je.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: s, inputRef: i, numberValue: n, setValue: l } = Bv(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: zl,
        valueRange: e.valueRange
      }
    ), o = J(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: u }) => u === "currency")?.value ?? e.currency
    ), h = J(
      () => St(n.value) ? parseFloat((n.value * 100).toFixed()) : null
    ), v = (u) => {
      l(St(u) ? parseFloat((u / 100).toFixed(zl)) : null);
    };
    return pt(async () => {
      St(e.value) && (await Wa(), v(e.value));
    }), Ve(h, (u) => {
      a("update:value", u);
    }), Ve(
      () => e.value,
      (u) => {
        u !== h.value && v(u);
      }
    ), (u, f) => (A(), Se(q(er), Ce({
      ref_key: "inputRef",
      ref: i
    }, { ...u.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: q(s)
    }), Xa({
      prefix: Ie(() => [
        bt($e(o.value), 1)
      ]),
      _: 2
    }, [
      u.$slots.suffix ? {
        name: "suffix",
        fn: Ie(() => [
          me(u.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Pv = ["aria-checked", "aria-label"], Ig = /* @__PURE__ */ _e({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => je.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), a = pe("password"), r = J(() => s.value ? "eye-off" : "eye"), s = J(() => a.value === "text"), i = () => {
      a.value = s.value ? "password" : "text";
    };
    return (n, l) => (A(), Se(q(er), Ce({ ...n.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: a.value
    }), {
      suffix: Ie(() => [
        ne("button", {
          "aria-checked": s.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Oe(q(Je), { name: r.value }, null, 8, ["name"])
        ], 40, Pv),
        me(n.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), Dg = ["password", "text"], zv = ["aria-valuenow"], Mg = /* @__PURE__ */ _e({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: 0 },
    size: { default: "medium" },
    variant: { default: "info" }
  },
  setup(e) {
    const t = J(() => e.size === "medium" ? 36 : 24);
    return (a, r) => (A(), j("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: ye([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Oe(q(po), Ce({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Oe(wn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: Ie(() => [
          (A(), Se(q(Je), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, zv));
  }
}), Og = ["medium", "small"], Rg = ["info", "success"], wi = /* @__PURE__ */ Symbol(), Vv = ["for"], Hv = { class: "lc-radio__control" }, Uv = ["id", "aria-labelledby", "data-click-name", "name"], qv = ["id"], jv = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const a = t, r = Zn(wi), s = yt(e.id), i = J(() => [
      "lc-radio",
      {
        "lc-radio--checked": n.value,
        "lc-radio--disabled": !!Ge(r?.disabled) || e.disabled,
        "lc-radio--error": !!Ge(r?.hasError)
      }
    ]), n = J(() => e.value === Ge(r?.value) || e.checked), l = J({
      get: () => n.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        a("change");
      }
    }), o = J(() => {
      if (Ge(r?.value))
        return n.value ? 0 : -1;
    }), h = J(() => Ge(r?.name) ?? e.name);
    return (v, u) => (A(), j("label", {
      class: ye([i.value, v.$attrs.class]),
      for: q(s)
    }, [
      ne("div", Hv, [
        Jt(ne("input", Ce({ id: q(s) }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: o.value
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => l.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, Uv), [
          [$s, l.value]
        ])
      ]),
      e.label ? (A(), j("span", {
        key: 0,
        id: `${q(s)}-label`,
        class: ye(["lc-radio__label", e.labelClass])
      }, $e(e.label), 11, qv)) : ue("", !0)
    ], 10, Vv));
  }
}), Zv = { class: "lc-radio-card__main" }, Fg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = ut("radio"), a = Zn(wi), r = J(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), s = J(() => e.value === Ge(a?.value) || e.checked), i = J(() => e.disabled || Ge(a?.disabled)), n = () => {
      if (i.value) return;
      a?.updateValue(e.value);
      const l = t.value?.$el?.querySelector("input");
      if (!l) return;
      const o = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      l.dispatchEvent(o), l.dispatchEvent(h);
    };
    return (l, o) => (A(), Se(q(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: ye([r.value, l.$attrs.class]),
      onClick: n
    }, {
      default: Ie(() => [
        ne("div", Zv, [
          Oe(q(jv), Ce({ ref: "radio" }, {
            ...Qt(l.$attrs, ["class"]),
            ...l.$props
          }), null, 16),
          me(l.$slots, "default", {
            checked: s.value,
            disabled: i.value
          })
        ]),
        Jt(ne("div", {
          class: "lc-radio-card__underneath",
          onClick: o[0] || (o[0] = oa(() => {
          }, ["stop"]))
        }, [
          me(l.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ni, s.value && l.$slots.underneath]
        ]),
        me(l.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), Wv = ["id", "aria-labelledby"], Xv = ["id"], Ng = /* @__PURE__ */ _e({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = yt(e.id), s = J(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = J(() => !!e.errorMessage);
    return pt(() => {
      e.defaultValue && a("update:value", e.defaultValue);
    }), ei(wi, {
      disabled: () => e.disabled,
      hasError: Jl(i),
      name: () => e.name,
      updateValue: (n) => {
        a("update:value", n);
      },
      value: () => e.value
    }), (n, l) => (A(), j("fieldset", Ce({
      ...n.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: q(r),
      "aria-labelledby": e.label ? `${q(r)}-label` : void 0,
      class: s.value,
      role: "radiogroup"
    }), [
      e.label ? (A(), j("legend", {
        key: 0,
        id: `${q(r)}-label`,
        class: "lc-radio-group__label"
      }, $e(e.label), 9, Xv)) : ue("", !0),
      ne("div", {
        class: ye(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        me(n.$slots, "default")
      ], 2),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, Wv));
  }
}), Bg = ["horizontal", "vertical"], Yv = { class: "lc-rating" }, Pg = /* @__PURE__ */ _e({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, a) => (A(), j("div", Yv, [
      (A(!0), j(Ye, null, ht(new Array(e.max), (r, s) => (A(), j("svg", {
        key: s,
        class: ye(["lc-rating__star", s < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...a[0] || (a[0] = [
        ne("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ne("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), Gv = /* @__PURE__ */ _e({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, a) => (A(), j("div", {
      "aria-hidden": "true",
      class: ye(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: At({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), zg = ["full", "half", "large", "medium", "none", "small"], Kv = { class: "lc-remote-list__content" }, Jv = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, Vg = /* @__PURE__ */ _e({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const a = t, r = J(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), s = J(() => e.count < e.total), i = () => {
      s.value && a("fetch-more");
    };
    return (n, l) => (A(), j("section", {
      class: ye(r.value)
    }, [
      ne("ul", Kv, [
        me(n.$slots, "default"),
        e.loading ? me(n.$slots, "loading", {}, () => [
          (A(!0), j(Ye, null, ht(e.numberOfSkeletons, (o) => (A(), Se(q(Gv), {
            key: o,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : ue("", !0)
      ]),
      !e.loading && s.value ? (A(), j("div", Jv, [
        me(n.$slots, "load-more", Lt(Rt({ fetchMore: i })), () => [
          Oe(q(Ct), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: Ie(() => [
              bt($e(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? ue("", !0) : (A(), Se(q(li), { key: 0 }))
      ])) : ue("", !0)
    ], 2));
  }
}), Qv = { class: "lc-scratchcard-teaser__button-wrap" }, Hg = /* @__PURE__ */ _e({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, a) => (A(), Se(q(tr), Ce({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: Ie(() => [
        Oe(q(ii), Ce({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: Ie(() => [
            me(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ne("div", Qv, [
          Oe(q(Ct), Ce({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: a[0] || (a[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: Ie(() => [
              bt($e(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), Ug = [...Fo];
var Yt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Yt || {});
const em = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], tm = ["id"], nm = { class: "lc-select__input" }, am = ["id", "aria-activedescendant", "aria-labelledby"], rm = ["id", "aria-selected", "onClickPassive"], qg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [je.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = ut("button"), s = ut("container"), i = ut("menu"), n = ut("options"), l = pe(null), o = pe(!1), h = Jr({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = ts(r, i, {
      middleware: [Qo(), ns, Jo(2)],
      whileElementsMounted: Ko
    }), { width: u } = Hs(s), f = yt(e.id), m = yi(), c = J(() => {
      if (!(!o.value || !St(l.value)))
        return `${f}-option-${l.value}`;
    }), w = J(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--fixed-value": b.value,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": o.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), _ = J(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = J(() => e.options.findIndex((L) => L.value === e.value)), b = J(() => e.notNullable && e.options.length === 1 && !!e.value), S = J(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), T = J(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = J(() => ({
      ...v.value,
      minWidth: `${u.value}px`
    })), $ = () => {
      o.value && (l.value = null, o.value = !1, e.onBlur?.(), C("focusout"));
    }, C = (L) => {
      const z = r.value;
      if (!z) return;
      h[L] = !0;
      const U = new Event(L, { bubbles: !0 });
      z.dispatchEvent(U);
    }, F = async () => {
      o.value || await P();
    }, V = (L) => {
      const z = L.type;
      if (!G(z)) return;
      h[z] ? h[z] = !1 : L.stopPropagation();
    }, K = async (L) => {
      if (!en(L.key, Yt)) return;
      L.key !== Yt.Tab && (L.preventDefault(), L.stopPropagation());
      const z = e.options.length - 1;
      switch (L.key) {
        case Yt.ArrowDown:
          if (o.value && St(l.value)) {
            l.value = Math.min(z, l.value + 1), E();
            break;
          }
          l.value = 0, await P();
          break;
        case Yt.ArrowUp:
          if (o.value && St(l.value)) {
            l.value = Math.max(0, l.value - 1), E();
            break;
          }
          l.value = z, await P();
          break;
        case Yt.Enter:
        case Yt.Space:
          if (o.value && St(l.value)) {
            O(e.options[l.value].value);
            break;
          }
          await P();
          break;
        case Yt.Escape:
          $();
          break;
        case Yt.Tab:
          if (!o.value || !St(l.value)) break;
          O(e.options[l.value].value);
          break;
      }
    }, O = (L) => {
      const z = e.value === L ? null : L;
      e.notNullable && z === null || (a("update:value", z), $());
    }, G = (L) => L === "focusin" || L === "focusout", P = async () => {
      o.value || (o.value = !0, e.value && (l.value = g.value), C("focusin"), await Wa(), E());
    }, E = () => {
      if (!St(l.value)) return;
      n.value?.[l.value]?.scrollIntoView({ block: "center" });
    };
    return Ya(i, $, {
      ignore: [r, ...Ge(e.ignoreOutsideClickOn)]
    }), pt(() => {
      e.autofocus && r.value?.focus(), e.value && (l.value = g.value);
    }), (L, z) => (A(), j("div", {
      ref: "container",
      class: ye([w.value, L.$attrs.class])
    }, [
      ne("button", Ce({
        id: q(f),
        ref: "button"
      }, Qt(L.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${q(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : o.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: F,
        onFocusin: V,
        onFocusout: V,
        onKeydown: K
      }), [
        !b.value && e.label ? (A(), j("span", {
          key: 0,
          id: `${q(f)}-label`,
          class: ye(S.value)
        }, $e(e.label), 11, tm)) : ue("", !0),
        ne("div", nm, $e(_.value), 1),
        b.value ? ue("", !0) : (A(), Se(q(Je), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, em),
      b.value ? ue("", !0) : (A(), Se(q(au), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: Ie(() => [
          o.value ? (A(), j("div", {
            key: 0,
            ref: "menu",
            class: ye(T.value),
            style: At(I.value)
          }, [
            ne("ul", {
              id: `${q(f)}-listbox`,
              "aria-activedescendant": c.value,
              "aria-labelledby": e.label ? `${q(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              (A(!0), j(Ye, null, ht(e.options, (U, X) => (A(), j("li", {
                key: `${U.label}-${U.value}`,
                class: ye(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": l.value === X && q(m),
                  "lc-select__menu-item--selected": U.value === e.value
                }])
              }, [
                ne("button", {
                  id: `${q(f)}-option-${X}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": U.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (B) => O(U.value)
                }, [
                  ne("span", null, $e(U.label), 1),
                  U.value === e.value ? (A(), Se(q(Je), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : ue("", !0)
                ], 40, rm)
              ], 2))), 128))
            ], 8, am)
          ], 6)) : ue("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), jg = ["default", "discreet"];
var jt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(jt || {});
const im = ["id", "aria-activedescendant"], Zg = /* @__PURE__ */ _e({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = ut("list"), s = pe(null), i = yt(e.id), n = yi(), l = J(() => {
      if (St(s.value))
        return `${i}-option-${s.value}`;
    }), o = J(() => !r.value || !St(s.value) ? null : r.value.querySelectorAll('[role="option"]')[s.value]), h = J(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = J(
      () => e.options.findIndex((T) => T.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), u = (T) => e.optionComponent ? g(T) ? "span" : e.optionComponent : _(T) ? g(T) ? "span" : Wn(T.to) : "button", f = () => {
      n.value && (s.value = Math.max(0, v.value));
    }, m = () => {
      n.value && (s.value = null);
    }, c = (T) => {
      if (!en(T.key, jt) || !St(s.value))
        return;
      T.preventDefault(), T.stopPropagation();
      const I = e.options.length - 1;
      switch (T.key) {
        case jt.ArrowDown:
        case jt.ArrowRight:
          s.value = Math.min(I, s.value + 1);
          break;
        case jt.ArrowLeft:
        case jt.ArrowUp:
          s.value = Math.max(0, s.value - 1);
          break;
        case jt.End:
          s.value = I;
          break;
        case jt.Enter:
        case jt.Space:
          o.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case jt.Home:
          s.value = 0;
          break;
      }
    }, w = (T) => {
      let I;
      if (e.multiple) {
        const $ = Array.isArray(e.value) ? e.value : [];
        I = $.includes(T) ? $.filter((C) => C !== T) : S([...$, T]);
      } else
        I = e.value === T ? void 0 : T;
      a("update:value", I);
    }, _ = ({ href: T, to: I }) => !!(T || I), g = (T) => Array.isArray(e.value) ? e.value.includes(T.value) : e.value === T.value, b = () => {
      o.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, S = (T) => {
      const I = new Map(e.options.map(($, C) => [$.value, C]));
      return [...T].sort(
        ($, C) => (I.get($) ?? 1 / 0) - (I.get(C) ?? 1 / 0)
      );
    };
    return pt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), Ve(s, (T) => {
      T !== null && b();
    }), (T, I) => (A(), j("div", {
      class: ye(h.value)
    }, [
      ne("ul", {
        id: q(i),
        ref: "list",
        "aria-activedescendant": l.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: c
      }, [
        (A(!0), j(Ye, null, ht(e.options, ($, C) => (A(), j("li", {
          key: `${$.label}-${$.value}`,
          class: ye(["lc-select-list__item", {
            "lc-select-list__item--focused": s.value === C && q(n),
            "lc-select-list__item--selected": g($)
          }])
        }, [
          (A(), Se(Xt(u($)), Ce({
            id: `${q(i)}-option-${C}`
          }, { ref_for: !0 }, {
            ...Jc($, ["href", "target", "to"]),
            ...$?.additionalProps ?? {}
          }, {
            "aria-label": $.ariaLabelText,
            "aria-selected": g($),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: _($) && !g($) ? void 0 : "button",
            onClickPassive: (F) => w($.value)
          }), {
            default: Ie(() => [
              ne("span", null, $e($.label), 1),
              g($) ? (A(), Se(q(Je), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : ue("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, im)
    ], 2));
  }
});
function Da(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function lm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ls(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var Vl = ls((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var a = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(c) {
      return c.split("").reverse().join("");
    }
    function s(c, w) {
      return c.substring(0, w.length) === w;
    }
    function i(c, w) {
      return c.slice(-1 * w.length) === w;
    }
    function n(c, w, _) {
      if ((c[w] || c[_]) && c[w] === c[_]) throw new Error(w);
    }
    function l(c) {
      return typeof c == "number" && isFinite(c);
    }
    function o(c, w) {
      return c = c.toString().split("e"), (+((c = (c = Math.round(+(c[0] + "e" + (c[1] ? +c[1] + w : w)))).toString().split("e"))[0] + "e" + (c[1] ? +c[1] - w : -w))).toFixed(w);
    }
    function h(c, w, _, g, b, S, T, I, $, C, F, V) {
      var K, O, G, P = V, E = "", L = "";
      return S && (V = S(V)), !!l(V) && (c !== !1 && parseFloat(V.toFixed(c)) === 0 && (V = 0), V < 0 && (K = !0, V = Math.abs(V)), c !== !1 && (V = o(V, c)), (V = V.toString()).indexOf(".") !== -1 ? (G = (O = V.split("."))[0], _ && (E = _ + O[1])) : G = V, w && (G = r(G).match(/.{1,3}/g), G = r(G.join(r(w)))), K && I && (L += I), g && (L += g), K && $ && (L += $), L += G, L += E, b && (L += b), C && (L = C(L, P)), L);
    }
    function v(c, w, _, g, b, S, T, I, $, C, F, V) {
      var K, O = "";
      return F && (V = F(V)), !(!V || typeof V != "string") && (I && s(V, I) && (V = V.replace(I, ""), K = !0), g && s(V, g) && (V = V.replace(g, "")), $ && s(V, $) && (V = V.replace($, ""), K = !0), b && i(V, b) && (V = V.slice(0, -1 * b.length)), w && (V = V.split(w).join("")), _ && (V = V.replace(_, ".")), K && (O += "-"), (O = (O += V).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), T && (O = T(O)), !!l(O) && O));
    }
    function u(c) {
      var w, _, g, b = {};
      for (c.suffix === void 0 && (c.suffix = c.postfix), w = 0; w < a.length; w += 1) if ((g = c[_ = a[w]]) === void 0) _ !== "negative" || b.negativeBefore ? _ === "mark" && b.thousand !== "." ? b[_] = "." : b[_] = !1 : b[_] = "-";
      else if (_ === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(_);
        b[_] = g;
      } else if (_ === "encoder" || _ === "decoder" || _ === "edit" || _ === "undo") {
        if (typeof g != "function") throw new Error(_);
        b[_] = g;
      } else {
        if (typeof g != "string") throw new Error(_);
        b[_] = g;
      }
      return n(b, "mark", "thousand"), n(b, "prefix", "negative"), n(b, "prefix", "negativeBefore"), b;
    }
    function f(c, w, _) {
      var g, b = [];
      for (g = 0; g < a.length; g += 1) b.push(c[a[g]]);
      return b.push(_), w.apply("", b);
    }
    function m(c) {
      if (!(this instanceof m)) return new m(c);
      typeof c == "object" && (c = u(c), this.to = function(w) {
        return f(c, h, w);
      }, this.from = function(w) {
        return f(c, v, w);
      });
    }
    return m;
  })();
})), om = lm(ls((function(e, t) {
  (function(a) {
    function r(D) {
      return s(D) && typeof D.from == "function";
    }
    function s(D) {
      return typeof D == "object" && typeof D.to == "function";
    }
    function i(D) {
      D.parentElement.removeChild(D);
    }
    function n(D) {
      return D != null;
    }
    function l(D) {
      D.preventDefault();
    }
    function o(D) {
      return D.filter((function(k) {
        return !this[k] && (this[k] = !0);
      }), {});
    }
    function h(D, k) {
      return Math.round(D / k) * k;
    }
    function v(D, k) {
      var y = D.getBoundingClientRect(), Y = D.ownerDocument, W = Y.documentElement, ce = S(Y);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (ce.x = 0), k ? y.top + ce.y - W.clientTop : y.left + ce.x - W.clientLeft;
    }
    function u(D) {
      return typeof D == "number" && !isNaN(D) && isFinite(D);
    }
    function f(D, k, y) {
      y > 0 && (_(D, k), setTimeout((function() {
        g(D, k);
      }), y));
    }
    function m(D) {
      return Math.max(Math.min(D, 100), 0);
    }
    function c(D) {
      return Array.isArray(D) ? D : [D];
    }
    function w(D) {
      var k = (D = String(D)).split(".");
      return k.length > 1 ? k[1].length : 0;
    }
    function _(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.add(k) : D.className += " " + k;
    }
    function g(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.remove(k) : D.className = D.className.replace(new RegExp("(^|\\b)" + k.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(D, k) {
      return D.classList ? D.classList.contains(k) : new RegExp("\\b" + k + "\\b").test(D.className);
    }
    function S(D) {
      var k = window.pageXOffset !== void 0, y = (D.compatMode || "") === "CSS1Compat";
      return { x: k ? window.pageXOffset : y ? D.documentElement.scrollLeft : D.body.scrollLeft, y: k ? window.pageYOffset : y ? D.documentElement.scrollTop : D.body.scrollTop };
    }
    function T() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var D = !1;
      try {
        var k = Object.defineProperty({}, "passive", { get: function() {
          D = !0;
        } });
        window.addEventListener("test", null, k);
      } catch {
      }
      return D;
    }
    function $() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function C(D, k) {
      return 100 / (k - D);
    }
    function F(D, k, y) {
      return 100 * k / (D[y + 1] - D[y]);
    }
    function V(D, k) {
      return F(D, D[0] < 0 ? k + Math.abs(D[0]) : k - D[0], 0);
    }
    function K(D, k) {
      return k * (D[1] - D[0]) / 100 + D[0];
    }
    function O(D, k) {
      for (var y = 1; D >= k[y]; ) y += 1;
      return y;
    }
    function G(D, k, y) {
      if (y >= D.slice(-1)[0]) return 100;
      var Y = O(y, D), W = D[Y - 1], ce = D[Y], R = k[Y - 1], le = k[Y];
      return R + V([W, ce], y) / C(R, le);
    }
    function P(D, k, y) {
      if (y >= 100) return D.slice(-1)[0];
      var Y = O(y, k), W = D[Y - 1], ce = D[Y], R = k[Y - 1];
      return K([W, ce], (y - R) * C(R, k[Y]));
    }
    function E(D, k, y, Y) {
      if (Y === 100) return Y;
      var W = O(Y, D), ce = D[W - 1], R = D[W];
      return y ? Y - ce > (R - ce) / 2 ? R : ce : k[W - 1] ? D[W - 1] + h(Y - D[W - 1], k[W - 1]) : Y;
    }
    var L, z;
    a.PipsMode = void 0, (z = a.PipsMode || (a.PipsMode = {})).Range = "range", z.Steps = "steps", z.Positions = "positions", z.Count = "count", z.Values = "values", a.PipsType = void 0, (L = a.PipsType || (a.PipsType = {}))[L.None = -1] = "None", L[L.NoValue = 0] = "NoValue", L[L.LargeValue = 1] = "LargeValue", L[L.SmallValue = 2] = "SmallValue";
    var U = (function() {
      function D(k, y, Y) {
        var W;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [Y || !1], this.xNumSteps = [!1], this.snap = y;
        var ce = [];
        for (Object.keys(k).forEach((function(R) {
          ce.push([c(k[R]), R]);
        })), ce.sort((function(R, le) {
          return R[0][0] - le[0][0];
        })), W = 0; W < ce.length; W++) this.handleEntryPoint(ce[W][1], ce[W][0]);
        for (this.xNumSteps = this.xSteps.slice(0), W = 0; W < this.xNumSteps.length; W++) this.handleStepPoint(W, this.xNumSteps[W]);
      }
      return D.prototype.getDistance = function(k) {
        for (var y = [], Y = 0; Y < this.xNumSteps.length - 1; Y++) y[Y] = F(this.xVal, k, Y);
        return y;
      }, D.prototype.getAbsoluteDistance = function(k, y, Y) {
        var W, ce = 0;
        if (k < this.xPct[this.xPct.length - 1]) for (; k > this.xPct[ce + 1]; ) ce++;
        else k === this.xPct[this.xPct.length - 1] && (ce = this.xPct.length - 2);
        Y || k !== this.xPct[ce + 1] || ce++, y === null && (y = []);
        var R = 1, le = y[ce], p = 0, de = 0, Ae = 0, d = 0;
        for (W = Y ? (k - this.xPct[ce]) / (this.xPct[ce + 1] - this.xPct[ce]) : (this.xPct[ce + 1] - k) / (this.xPct[ce + 1] - this.xPct[ce]); le > 0; ) p = this.xPct[ce + 1 + d] - this.xPct[ce + d], y[ce + d] * R + 100 - 100 * W > 100 ? (de = p * W, R = (le - 100 * W) / y[ce + d], W = 1) : (de = y[ce + d] * p / 100 * R, R = 0), Y ? (Ae -= de, this.xPct.length + d >= 1 && d--) : (Ae += de, this.xPct.length - d >= 1 && d++), le = y[ce + d] * R;
        return k + Ae;
      }, D.prototype.toStepping = function(k) {
        return k = G(this.xVal, this.xPct, k);
      }, D.prototype.fromStepping = function(k) {
        return P(this.xVal, this.xPct, k);
      }, D.prototype.getStep = function(k) {
        return k = E(this.xPct, this.xSteps, this.snap, k);
      }, D.prototype.getDefaultStep = function(k, y, Y) {
        var W = O(k, this.xPct);
        return (k === 100 || y && k === this.xPct[W - 1]) && (W = Math.max(W - 1, 1)), (this.xVal[W] - this.xVal[W - 1]) / Y;
      }, D.prototype.getNearbySteps = function(k) {
        var y = O(k, this.xPct);
        return { stepBefore: { startValue: this.xVal[y - 2], step: this.xNumSteps[y - 2], highestStep: this.xHighestCompleteStep[y - 2] }, thisStep: { startValue: this.xVal[y - 1], step: this.xNumSteps[y - 1], highestStep: this.xHighestCompleteStep[y - 1] }, stepAfter: { startValue: this.xVal[y], step: this.xNumSteps[y], highestStep: this.xHighestCompleteStep[y] } };
      }, D.prototype.countStepDecimals = function() {
        var k = this.xNumSteps.map(w);
        return Math.max.apply(null, k);
      }, D.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, D.prototype.convert = function(k) {
        return this.getStep(this.toStepping(k));
      }, D.prototype.handleEntryPoint = function(k, y) {
        var Y;
        if (!u(Y = k === "min" ? 0 : k === "max" ? 100 : parseFloat(k)) || !u(y[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(Y), this.xVal.push(y[0]);
        var W = Number(y[1]);
        Y ? this.xSteps.push(!isNaN(W) && W) : isNaN(W) || (this.xSteps[0] = W), this.xHighestCompleteStep.push(0);
      }, D.prototype.handleStepPoint = function(k, y) {
        if (y) if (this.xVal[k] !== this.xVal[k + 1]) {
          this.xSteps[k] = F([this.xVal[k], this.xVal[k + 1]], y, 0) / C(this.xPct[k], this.xPct[k + 1]);
          var Y = (this.xVal[k + 1] - this.xVal[k]) / this.xNumSteps[k], W = Math.ceil(Number(Y.toFixed(3)) - 1), ce = this.xVal[k] + this.xNumSteps[k] * W;
          this.xHighestCompleteStep[k] = ce;
        } else this.xSteps[k] = this.xHighestCompleteStep[k] = this.xVal[k];
      }, D;
    })(), X = { to: function(D) {
      return D === void 0 ? "" : D.toFixed(2);
    }, from: Number }, B = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, ie = { tooltips: ".__tooltips", aria: ".__aria" };
    function H(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'step' is not numeric.");
      D.singleStep = k;
    }
    function Q(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      D.keyboardPageMultiplier = k;
    }
    function ae(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      D.keyboardMultiplier = k;
    }
    function ve(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      D.keyboardDefaultStep = k;
    }
    function be(D, k) {
      if (typeof k != "object" || Array.isArray(k)) throw new Error("noUiSlider: 'range' is not an object.");
      if (k.min === void 0 || k.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      D.spectrum = new U(k, D.snap || !1, D.singleStep);
    }
    function se(D, k) {
      if (k = c(k), !Array.isArray(k) || !k.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      D.handles = k.length, D.start = k;
    }
    function ge(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      D.snap = k;
    }
    function we(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      D.animate = k;
    }
    function Le(D, k) {
      if (typeof k != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      D.animationDuration = k;
    }
    function Ze(D, k) {
      var y, Y = [!1];
      if (k === "lower" ? k = [!0, !1] : k === "upper" && (k = [!1, !0]), k === !0 || k === !1) {
        for (y = 1; y < D.handles; y++) Y.push(k);
        Y.push(!1);
      } else {
        if (!Array.isArray(k) || !k.length || k.length !== D.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        Y = k;
      }
      D.connect = Y;
    }
    function Ne(D, k) {
      switch (k) {
        case "horizontal":
          D.ort = 0;
          break;
        case "vertical":
          D.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function fe(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      k !== 0 && (D.margin = D.spectrum.getDistance(k));
    }
    function Re(D, k) {
      if (!u(k)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (D.limit = D.spectrum.getDistance(k), !D.limit || D.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function Be(D, k) {
      var y;
      if (!u(k) && !Array.isArray(k)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(k) && k.length !== 2 && !u(k[0]) && !u(k[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (k !== 0) {
        for (Array.isArray(k) || (k = [k, k]), D.padding = [D.spectrum.getDistance(k[0]), D.spectrum.getDistance(k[1])], y = 0; y < D.spectrum.xNumSteps.length - 1; y++) if (D.padding[0][y] < 0 || D.padding[1][y] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var Y = k[0] + k[1], W = D.spectrum.xVal[0];
        if (Y / (D.spectrum.xVal[D.spectrum.xVal.length - 1] - W) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function He(D, k) {
      switch (k) {
        case "ltr":
          D.dir = 0;
          break;
        case "rtl":
          D.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function We(D, k) {
      if (typeof k != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var y = k.indexOf("tap") >= 0, Y = k.indexOf("drag") >= 0, W = k.indexOf("fixed") >= 0, ce = k.indexOf("snap") >= 0, R = k.indexOf("hover") >= 0, le = k.indexOf("unconstrained") >= 0, p = k.indexOf("drag-all") >= 0, de = k.indexOf("smooth-steps") >= 0;
      if (W) {
        if (D.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        fe(D, D.start[1] - D.start[0]);
      }
      if (le && (D.margin || D.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      D.events = { tap: y || ce, drag: Y, dragAll: p, smoothSteps: de, fixed: W, snap: ce, hover: R, unconstrained: le };
    }
    function Pe(D, k) {
      if (k !== !1) if (k === !0 || s(k)) {
        D.tooltips = [];
        for (var y = 0; y < D.handles; y++) D.tooltips.push(k);
      } else {
        if ((k = c(k)).length !== D.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        k.forEach((function(Y) {
          if (typeof Y != "boolean" && !s(Y)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), D.tooltips = k;
      }
    }
    function Fe(D, k) {
      if (k.length !== D.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      D.handleAttributes = k;
    }
    function nt(D, k) {
      if (!s(k)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      D.ariaFormat = k;
    }
    function xt(D, k) {
      if (!r(k)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      D.format = k;
    }
    function kt(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      D.keyboardSupport = k;
    }
    function vt(D, k) {
      D.documentElement = k;
    }
    function Ft(D, k) {
      if (typeof k != "string" && k !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      D.cssPrefix = k;
    }
    function Mt(D, k) {
      if (typeof k != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof D.cssPrefix == "string" ? (D.cssClasses = {}, Object.keys(k).forEach((function(y) {
        D.cssClasses[y] = D.cssPrefix + k[y];
      }))) : D.cssClasses = k;
    }
    function wt(D) {
      var k = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: X, format: X }, y = { step: { r: !1, t: H }, keyboardPageMultiplier: { r: !1, t: Q }, keyboardMultiplier: { r: !1, t: ae }, keyboardDefaultStep: { r: !1, t: ve }, start: { r: !0, t: se }, connect: { r: !0, t: Ze }, direction: { r: !0, t: He }, snap: { r: !1, t: ge }, animate: { r: !1, t: we }, animationDuration: { r: !1, t: Le }, range: { r: !0, t: be }, orientation: { r: !1, t: Ne }, margin: { r: !1, t: fe }, limit: { r: !1, t: Re }, padding: { r: !1, t: Be }, behaviour: { r: !0, t: We }, ariaFormat: { r: !1, t: nt }, format: { r: !1, t: xt }, tooltips: { r: !1, t: Pe }, keyboardSupport: { r: !0, t: kt }, documentElement: { r: !1, t: vt }, cssPrefix: { r: !0, t: Ft }, cssClasses: { r: !0, t: Mt }, handleAttributes: { r: !1, t: Fe } }, Y = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: B, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      D.format && !D.ariaFormat && (D.ariaFormat = D.format), Object.keys(y).forEach((function(p) {
        if (n(D[p]) || Y[p] !== void 0) y[p].t(k, n(D[p]) ? D[p] : Y[p]);
        else if (y[p].r) throw new Error("noUiSlider: '" + p + "' is required.");
      })), k.pips = D.pips;
      var W = document.createElement("div"), ce = W.style.msTransform !== void 0, R = W.style.transform !== void 0;
      k.transformRule = R ? "transform" : ce ? "msTransform" : "webkitTransform";
      var le = [["left", "top"], ["right", "bottom"]];
      return k.style = le[k.dir][k.ort], k;
    }
    function Ut(D, k, y) {
      var Y, W, ce, R, le, p = T(), de = $() && I(), Ae = D, d = k.spectrum, re = [], te = [], x = [], N = 0, ee = {}, De = D.ownerDocument, xe = k.documentElement || De.documentElement, Ee = De.body, Ue = De.dir === "rtl" || k.ort === 1 ? 0 : 100;
      function dt(M, Z) {
        var oe = De.createElement("div");
        return Z && _(oe, Z), M.appendChild(oe), oe;
      }
      function Qe(M, Z) {
        var oe = dt(M, k.cssClasses.origin), he = dt(oe, k.cssClasses.handle);
        if (dt(he, k.cssClasses.touchArea), he.setAttribute("data-handle", String(Z)), k.keyboardSupport && (he.setAttribute("tabindex", "0"), he.addEventListener("keydown", (function(ke) {
          return vs(ke, Z);
        }))), k.handleAttributes !== void 0) {
          var Te = k.handleAttributes[Z];
          Object.keys(Te).forEach((function(ke) {
            he.setAttribute(ke, Te[ke]);
          }));
        }
        return he.setAttribute("role", "slider"), he.setAttribute("aria-orientation", k.ort ? "vertical" : "horizontal"), Z === 0 ? _(he, k.cssClasses.handleLower) : Z === k.handles - 1 && _(he, k.cssClasses.handleUpper), oe;
      }
      function qe(M, Z) {
        return !!Z && dt(M, k.cssClasses.connect);
      }
      function it(M, Z) {
        var oe = dt(Z, k.cssClasses.connects);
        W = [], (ce = []).push(qe(oe, M[0]));
        for (var he = 0; he < k.handles; he++) W.push(Qe(Z, he)), x[he] = he, ce.push(qe(oe, M[he + 1]));
      }
      function mt(M) {
        return _(M, k.cssClasses.target), k.dir === 0 ? _(M, k.cssClasses.ltr) : _(M, k.cssClasses.rtl), k.ort === 0 ? _(M, k.cssClasses.horizontal) : _(M, k.cssClasses.vertical), _(M, getComputedStyle(M).direction === "rtl" ? k.cssClasses.textDirectionRtl : k.cssClasses.textDirectionLtr), dt(M, k.cssClasses.base);
      }
      function _t(M, Z) {
        return !(!k.tooltips || !k.tooltips[Z]) && dt(M.firstChild, k.cssClasses.tooltip);
      }
      function fn() {
        return Ae.hasAttribute("disabled");
      }
      function nn(M) {
        return W[M].hasAttribute("disabled");
      }
      function et() {
        le && (Xn("update" + ie.tooltips), le.forEach((function(M) {
          M && i(M);
        })), le = null);
      }
      function Et() {
        et(), le = W.map(_t), fr("update" + ie.tooltips, (function(M, Z, oe) {
          if (le && k.tooltips && le[Z] !== !1) {
            var he = M[Z];
            k.tooltips[Z] !== !0 && (he = k.tooltips[Z].to(oe[Z])), le[Z].innerHTML = he;
          }
        }));
      }
      function ft() {
        Xn("update" + ie.aria), fr("update" + ie.aria, (function(M, Z, oe, he, Te) {
          x.forEach((function(ke) {
            var ze = W[ke], Me = ka(te, ke, 0, !0, !0, !0), ot = ka(te, ke, 100, !0, !0, !0), rt = Te[ke], Ke = String(k.ariaFormat.to(oe[ke]));
            Me = d.fromStepping(Me).toFixed(1), ot = d.fromStepping(ot).toFixed(1), rt = d.fromStepping(rt).toFixed(1), ze.children[0].setAttribute("aria-valuemin", Me), ze.children[0].setAttribute("aria-valuemax", ot), ze.children[0].setAttribute("aria-valuenow", rt), ze.children[0].setAttribute("aria-valuetext", Ke);
          }));
        }));
      }
      function Pt(M) {
        if (M.mode === a.PipsMode.Range || M.mode === a.PipsMode.Steps) return d.xVal;
        if (M.mode === a.PipsMode.Count) {
          if (M.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var Z = M.values - 1, oe = 100 / Z, he = []; Z--; ) he[Z] = Z * oe;
          return he.push(100), Ot(he, M.stepped);
        }
        return M.mode === a.PipsMode.Positions ? Ot(M.values, M.stepped) : M.mode === a.PipsMode.Values ? M.stepped ? M.values.map((function(Te) {
          return d.fromStepping(d.getStep(d.toStepping(Te)));
        })) : M.values : [];
      }
      function Ot(M, Z) {
        return M.map((function(oe) {
          return d.fromStepping(Z ? d.getStep(oe) : oe);
        }));
      }
      function xa(M) {
        function Z(rt, Ke) {
          return Number((rt + Ke).toFixed(7));
        }
        var oe = Pt(M), he = {}, Te = d.xVal[0], ke = d.xVal[d.xVal.length - 1], ze = !1, Me = !1, ot = 0;
        return (oe = o(oe.slice().sort((function(rt, Ke) {
          return rt - Ke;
        }))))[0] !== Te && (oe.unshift(Te), ze = !0), oe[oe.length - 1] !== ke && (oe.push(ke), Me = !0), oe.forEach((function(rt, Ke) {
          var tt, Xe, gt, Tt, ct, $i, mr, Ii, Di, Mi, gr = rt, $n = oe[Ke + 1], Oi = M.mode === a.PipsMode.Steps;
          for (Oi && (tt = d.xNumSteps[Ke]), tt || (tt = $n - gr), $n === void 0 && ($n = gr), tt = Math.max(tt, 1e-7), Xe = gr; Xe <= $n; Xe = Z(Xe, tt)) {
            for (Ii = (ct = (Tt = d.toStepping(Xe)) - ot) / (M.density || 1), Mi = ct / (Di = Math.round(Ii)), gt = 1; gt <= Di; gt += 1) he[($i = ot + gt * Mi).toFixed(5)] = [d.fromStepping($i), 0];
            mr = oe.indexOf(Xe) > -1 ? a.PipsType.LargeValue : Oi ? a.PipsType.SmallValue : a.PipsType.NoValue, !Ke && ze && Xe !== $n && (mr = 0), Xe === $n && Me || (he[Tt.toFixed(5)] = [Xe, mr]), ot = Tt;
          }
        })), he;
      }
      function os(M, Z, oe) {
        var he, Te, ke = De.createElement("div"), ze = ((he = {})[a.PipsType.None] = "", he[a.PipsType.NoValue] = k.cssClasses.valueNormal, he[a.PipsType.LargeValue] = k.cssClasses.valueLarge, he[a.PipsType.SmallValue] = k.cssClasses.valueSub, he), Me = ((Te = {})[a.PipsType.None] = "", Te[a.PipsType.NoValue] = k.cssClasses.markerNormal, Te[a.PipsType.LargeValue] = k.cssClasses.markerLarge, Te[a.PipsType.SmallValue] = k.cssClasses.markerSub, Te), ot = [k.cssClasses.valueHorizontal, k.cssClasses.valueVertical], rt = [k.cssClasses.markerHorizontal, k.cssClasses.markerVertical];
        function Ke(Xe, gt) {
          var Tt = gt === k.cssClasses.value, ct = Tt ? ze : Me;
          return gt + " " + (Tt ? ot : rt)[k.ort] + " " + ct[Xe];
        }
        function tt(Xe, gt, Tt) {
          if ((Tt = Z ? Z(gt, Tt) : Tt) !== a.PipsType.None) {
            var ct = dt(ke, !1);
            ct.className = Ke(Tt, k.cssClasses.marker), ct.style[k.style] = Xe + "%", Tt > a.PipsType.NoValue && ((ct = dt(ke, !1)).className = Ke(Tt, k.cssClasses.value), ct.setAttribute("data-value", String(gt)), ct.style[k.style] = Xe + "%", ct.innerHTML = String(oe.to(gt)));
          }
        }
        return _(ke, k.cssClasses.pips), _(ke, k.ort === 0 ? k.cssClasses.pipsHorizontal : k.cssClasses.pipsVertical), Object.keys(M).forEach((function(Xe) {
          tt(Xe, M[Xe][0], M[Xe][1]);
        })), ke;
      }
      function sr() {
        R && (i(R), R = null);
      }
      function cr(M) {
        sr();
        var Z = xa(M), oe = M.filter, he = M.format || { to: function(Te) {
          return String(Math.round(Te));
        } };
        return R = Ae.appendChild(os(Z, oe, he));
      }
      function ki() {
        var M = Y.getBoundingClientRect(), Z = "offset" + ["Width", "Height"][k.ort];
        return k.ort === 0 ? M.width || Y[Z] : M.height || Y[Z];
      }
      function hn(M, Z, oe, he) {
        var Te = function(ze) {
          var Me = ss(ze, he.pageOffset, he.target || Z);
          return !!Me && !(fn() && !he.doNotReject) && !(b(Ae, k.cssClasses.tap) && !he.doNotReject) && !(M === p.start && Me.buttons !== void 0 && Me.buttons > 1) && (!he.hover || !Me.buttons) && (de || Me.preventDefault(), Me.calcPoint = Me.points[k.ort], void oe(Me, he));
        }, ke = [];
        return M.split(" ").forEach((function(ze) {
          Z.addEventListener(ze, Te, !!de && { passive: !0 }), ke.push([ze, Te]);
        })), ke;
      }
      function ss(M, Z, oe) {
        var he = M.type.indexOf("touch") === 0, Te = M.type.indexOf("mouse") === 0, ke = M.type.indexOf("pointer") === 0, ze = 0, Me = 0;
        if (M.type.indexOf("MSPointer") === 0 && (ke = !0), M.type === "mousedown" && !M.buttons && !M.touches) return !1;
        if (he) {
          var ot = function(tt) {
            var Xe = tt.target;
            return Xe === oe || oe.contains(Xe) || M.composed && M.composedPath().shift() === oe;
          };
          if (M.type === "touchstart") {
            var rt = Array.prototype.filter.call(M.touches, ot);
            if (rt.length > 1) return !1;
            ze = rt[0].pageX, Me = rt[0].pageY;
          } else {
            var Ke = Array.prototype.find.call(M.changedTouches, ot);
            if (!Ke) return !1;
            ze = Ke.pageX, Me = Ke.pageY;
          }
        }
        return Z = Z || S(De), (Te || ke) && (ze = M.clientX + Z.x, Me = M.clientY + Z.y), M.pageOffset = Z, M.points = [ze, Me], M.cursor = Te || ke, M;
      }
      function _i(M) {
        var Z = 100 * (M - v(Y, k.ort)) / ki();
        return Z = m(Z), k.dir ? 100 - Z : Z;
      }
      function cs(M) {
        var Z = 100, oe = !1;
        return W.forEach((function(he, Te) {
          if (!nn(Te)) {
            var ke = te[Te], ze = Math.abs(ke - M);
            (ze < Z || ze <= Z && M > ke || ze === 100 && Z === 100) && (oe = Te, Z = ze);
          }
        })), oe;
      }
      function us(M, Z) {
        M.type === "mouseout" && M.target.nodeName === "HTML" && M.relatedTarget === null && ur(M, Z);
      }
      function ds(M, Z) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && M.buttons === 0 && Z.buttonsProperty !== 0) return ur(M, Z);
        var oe = (k.dir ? -1 : 1) * (M.calcPoint - Z.startCalcPoint);
        Si(oe > 0, 100 * oe / Z.baseSize, Z.locations, Z.handleNumbers, Z.connect);
      }
      function ur(M, Z) {
        Z.handle && (g(Z.handle, k.cssClasses.active), N -= 1), Z.listeners.forEach((function(oe) {
          xe.removeEventListener(oe[0], oe[1]);
        })), N === 0 && (g(Ae, k.cssClasses.drag), vr(), M.cursor && (Ee.style.cursor = "", Ee.removeEventListener("selectstart", l))), k.events.smoothSteps && (Z.handleNumbers.forEach((function(oe) {
          vn(oe, te[oe], !0, !0, !1, !1);
        })), Z.handleNumbers.forEach((function(oe) {
          lt("update", oe);
        }))), Z.handleNumbers.forEach((function(oe) {
          lt("change", oe), lt("set", oe), lt("end", oe);
        }));
      }
      function dr(M, Z) {
        if (!Z.handleNumbers.some(nn)) {
          var oe;
          Z.handleNumbers.length === 1 && (oe = W[Z.handleNumbers[0]].children[0], N += 1, _(oe, k.cssClasses.active)), M.stopPropagation();
          var he = [], Te = hn(p.move, xe, ds, { target: M.target, handle: oe, connect: Z.connect, listeners: he, startCalcPoint: M.calcPoint, baseSize: ki(), pageOffset: M.pageOffset, handleNumbers: Z.handleNumbers, buttonsProperty: M.buttons, locations: te.slice() }), ke = hn(p.end, xe, ur, { target: M.target, handle: oe, listeners: he, doNotReject: !0, handleNumbers: Z.handleNumbers }), ze = hn("mouseout", xe, us, { target: M.target, handle: oe, listeners: he, doNotReject: !0, handleNumbers: Z.handleNumbers });
          he.push.apply(he, Te.concat(ke, ze)), M.cursor && (Ee.style.cursor = getComputedStyle(M.target).cursor, W.length > 1 && _(Ae, k.cssClasses.drag), Ee.addEventListener("selectstart", l, !1)), Z.handleNumbers.forEach((function(Me) {
            lt("start", Me);
          }));
        }
      }
      function fs(M) {
        M.stopPropagation();
        var Z = _i(M.calcPoint), oe = cs(Z);
        oe !== !1 && (k.events.snap || f(Ae, k.cssClasses.tap, k.animationDuration), vn(oe, Z, !0, !0), vr(), lt("slide", oe, !0), lt("update", oe, !0), k.events.snap ? dr(M, { handleNumbers: [oe] }) : (lt("change", oe, !0), lt("set", oe, !0)));
      }
      function hs(M) {
        var Z = _i(M.calcPoint), oe = d.getStep(Z), he = d.fromStepping(oe);
        Object.keys(ee).forEach((function(Te) {
          Te.split(".")[0] === "hover" && ee[Te].forEach((function(ke) {
            ke.call(Sa, he);
          }));
        }));
      }
      function vs(M, Z) {
        if (fn() || nn(Z)) return !1;
        var oe = ["Left", "Right"], he = ["Down", "Up"], Te = ["PageDown", "PageUp"], ke = ["Home", "End"];
        k.dir && !k.ort ? oe.reverse() : k.ort && !k.dir && (he.reverse(), Te.reverse());
        var ze, Me = M.key.replace("Arrow", ""), ot = Me === Te[0], rt = Me === Te[1], Ke = Me === he[0] || Me === oe[0] || ot, tt = Me === he[1] || Me === oe[1] || rt, Xe = Me === ke[0], gt = Me === ke[1];
        if (!(Ke || tt || Xe || gt)) return !0;
        if (M.preventDefault(), tt || Ke) {
          var Tt = Ke ? 0 : 1, ct = Ai(Z)[Tt];
          if (ct === null) return !1;
          ct === !1 && (ct = d.getDefaultStep(te[Z], Ke, k.keyboardDefaultStep)), ct *= rt || ot ? k.keyboardPageMultiplier : k.keyboardMultiplier, ct = Math.max(ct, 1e-7), ct *= Ke ? -1 : 1, ze = re[Z] + ct;
        } else ze = gt ? k.spectrum.xVal[k.spectrum.xVal.length - 1] : k.spectrum.xVal[0];
        return vn(Z, d.toStepping(ze), !0, !0), lt("slide", Z), lt("update", Z), lt("change", Z), lt("set", Z), !1;
      }
      function ms(M) {
        M.fixed || W.forEach((function(Z, oe) {
          hn(p.start, Z.children[0], dr, { handleNumbers: [oe] });
        })), M.tap && hn(p.start, Y, fs, {}), M.hover && hn(p.move, Y, hs, { hover: !0 }), M.drag && ce.forEach((function(Z, oe) {
          if (Z !== !1 && oe !== 0 && oe !== ce.length - 1) {
            var he = W[oe - 1], Te = W[oe], ke = [Z], ze = [he, Te], Me = [oe - 1, oe];
            _(Z, k.cssClasses.draggable), M.fixed && (ke.push(he.children[0]), ke.push(Te.children[0])), M.dragAll && (ze = W, Me = x), ke.forEach((function(ot) {
              hn(p.start, ot, dr, { handles: ze, handleNumbers: Me, connect: Z });
            }));
          }
        }));
      }
      function fr(M, Z) {
        ee[M] = ee[M] || [], ee[M].push(Z), M.split(".")[0] === "update" && W.forEach((function(oe, he) {
          lt("update", he);
        }));
      }
      function gs(M) {
        return M === ie.aria || M === ie.tooltips;
      }
      function Xn(M) {
        var Z = M && M.split(".")[0], oe = Z ? M.substring(Z.length) : M;
        Object.keys(ee).forEach((function(he) {
          var Te = he.split(".")[0], ke = he.substring(Te.length);
          Z && Z !== Te || oe && oe !== ke || gs(ke) && oe !== ke || delete ee[he];
        }));
      }
      function lt(M, Z, oe) {
        Object.keys(ee).forEach((function(he) {
          var Te = he.split(".")[0];
          M === Te && ee[he].forEach((function(ke) {
            ke.call(Sa, re.map(k.format.to), Z, re.slice(), oe || !1, te.slice(), Sa);
          }));
        }));
      }
      function ka(M, Z, oe, he, Te, ke, ze) {
        var Me;
        return W.length > 1 && !k.events.unconstrained && (he && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], k.margin, !1), oe = Math.max(oe, Me)), Te && Z < W.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], k.margin, !0), oe = Math.min(oe, Me))), W.length > 1 && k.limit && (he && Z > 0 && (Me = d.getAbsoluteDistance(M[Z - 1], k.limit, !1), oe = Math.min(oe, Me)), Te && Z < W.length - 1 && (Me = d.getAbsoluteDistance(M[Z + 1], k.limit, !0), oe = Math.max(oe, Me))), k.padding && (Z === 0 && (Me = d.getAbsoluteDistance(0, k.padding[0], !1), oe = Math.max(oe, Me)), Z === W.length - 1 && (Me = d.getAbsoluteDistance(100, k.padding[1], !0), oe = Math.min(oe, Me))), ze || (oe = d.getStep(oe)), !((oe = m(oe)) === M[Z] && !ke) && oe;
      }
      function hr(M, Z) {
        var oe = k.ort;
        return (oe ? Z : M) + ", " + (oe ? M : Z);
      }
      function Si(M, Z, oe, he, Te) {
        var ke = oe.slice(), ze = he[0], Me = k.events.smoothSteps, ot = [!M, M], rt = [M, !M];
        he = he.slice(), M && he.reverse(), he.length > 1 ? he.forEach((function(tt, Xe) {
          var gt = ka(ke, tt, ke[tt] + Z, ot[Xe], rt[Xe], !1, Me);
          gt === !1 ? Z = 0 : (Z = gt - ke[tt], ke[tt] = gt);
        })) : ot = rt = [!0];
        var Ke = !1;
        he.forEach((function(tt, Xe) {
          Ke = vn(tt, oe[tt] + Z, ot[Xe], rt[Xe], !1, Me) || Ke;
        })), Ke && (he.forEach((function(tt) {
          lt("update", tt), lt("slide", tt);
        })), Te != null && lt("drag", ze));
      }
      function Ci(M, Z) {
        return k.dir ? 100 - M - Z : M;
      }
      function bs(M, Z) {
        te[M] = Z, re[M] = d.fromStepping(Z);
        var oe = "translate(" + hr(Ci(Z, 0) - Ue + "%", "0") + ")";
        W[M].style[k.transformRule] = oe, Ei(M), Ei(M + 1);
      }
      function vr() {
        x.forEach((function(M) {
          var Z = te[M] > 50 ? -1 : 1, oe = 3 + (W.length + Z * M);
          W[M].style.zIndex = String(oe);
        }));
      }
      function vn(M, Z, oe, he, Te, ke) {
        return Te || (Z = ka(te, M, Z, oe, he, !1, ke)), Z !== !1 && (bs(M, Z), !0);
      }
      function Ei(M) {
        if (ce[M]) {
          var Z = 0, oe = 100;
          M !== 0 && (Z = te[M - 1]), M !== ce.length - 1 && (oe = te[M]);
          var he = oe - Z, Te = "translate(" + hr(Ci(Z, he) + "%", "0") + ")", ke = "scale(" + hr(he / 100, "1") + ")";
          ce[M].style[k.transformRule] = Te + " " + ke;
        }
      }
      function Ti(M, Z) {
        return M === null || M === !1 || M === void 0 ? te[Z] : (typeof M == "number" && (M = String(M)), (M = k.format.from(M)) !== !1 && (M = d.toStepping(M)), M === !1 || isNaN(M) ? te[Z] : M);
      }
      function _a(M, Z, oe) {
        var he = c(M), Te = te[0] === void 0;
        Z = Z === void 0 || Z, k.animate && !Te && f(Ae, k.cssClasses.tap, k.animationDuration), x.forEach((function(Me) {
          vn(Me, Ti(he[Me], Me), !0, !1, oe);
        }));
        var ke = x.length === 1 ? 0 : 1;
        if (Te && d.hasNoSize() && (oe = !0, te[0] = 0, x.length > 1)) {
          var ze = 100 / (x.length - 1);
          x.forEach((function(Me) {
            te[Me] = Me * ze;
          }));
        }
        for (; ke < x.length; ++ke) x.forEach((function(Me) {
          vn(Me, te[Me], !0, !0, oe);
        }));
        vr(), x.forEach((function(Me) {
          lt("update", Me), he[Me] !== null && Z && lt("set", Me);
        }));
      }
      function ps(M) {
        _a(k.start, M);
      }
      function ys(M, Z, oe, he) {
        if (!((M = Number(M)) >= 0 && M < x.length)) throw new Error("noUiSlider: invalid handle number, got: " + M);
        vn(M, Ti(Z, M), !0, !0, he), lt("update", M), oe && lt("set", M);
      }
      function Li(M) {
        if (M === void 0 && (M = !1), M) return re.length === 1 ? re[0] : re.slice(0);
        var Z = re.map(k.format.to);
        return Z.length === 1 ? Z[0] : Z;
      }
      function ws() {
        for (Xn(ie.aria), Xn(ie.tooltips), Object.keys(k.cssClasses).forEach((function(M) {
          g(Ae, k.cssClasses[M]);
        })); Ae.firstChild; ) Ae.removeChild(Ae.firstChild);
        delete Ae.noUiSlider;
      }
      function Ai(M) {
        var Z = te[M], oe = d.getNearbySteps(Z), he = re[M], Te = oe.thisStep.step, ke = null;
        if (k.snap) return [he - oe.stepBefore.startValue || null, oe.stepAfter.startValue - he || null];
        Te !== !1 && he + Te > oe.stepAfter.startValue && (Te = oe.stepAfter.startValue - he), ke = he > oe.thisStep.startValue ? oe.thisStep.step : oe.stepBefore.step !== !1 && he - oe.stepBefore.highestStep, Z === 100 ? Te = null : Z === 0 && (ke = null);
        var ze = d.countStepDecimals();
        return Te !== null && Te !== !1 && (Te = Number(Te.toFixed(ze))), ke !== null && ke !== !1 && (ke = Number(ke.toFixed(ze))), [ke, Te];
      }
      function xs() {
        return x.map(Ai);
      }
      function ks(M, Z) {
        var oe = Li(), he = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        he.forEach((function(ke) {
          M[ke] !== void 0 && (y[ke] = M[ke]);
        }));
        var Te = wt(y);
        he.forEach((function(ke) {
          M[ke] !== void 0 && (k[ke] = Te[ke]);
        })), d = Te.spectrum, k.margin = Te.margin, k.limit = Te.limit, k.padding = Te.padding, k.pips ? cr(k.pips) : sr(), k.tooltips ? Et() : et(), te = [], _a(n(M.start) ? M.start : oe, Z);
      }
      function _s() {
        Y = mt(Ae), it(k.connect, Y), ms(k.events), _a(k.start), k.pips && cr(k.pips), k.tooltips && Et(), ft();
      }
      _s();
      var Sa = { destroy: ws, steps: xs, on: fr, off: Xn, get: Li, set: _a, setHandle: ys, reset: ps, __moveHandles: function(M, Z, oe) {
        Si(M, Z, te, oe);
      }, options: y, updateOptions: ks, target: Ae, removePips: sr, removeTooltips: et, getPositions: function() {
        return te.slice();
      }, getTooltips: function() {
        return le;
      }, getOrigins: function() {
        return W;
      }, pips: cr };
      return Sa;
    }
    function $t(D, k) {
      if (!D || !D.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + D);
      if (D.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var y = Ut(D, wt(k), k);
      return D.noUiSlider = y, y;
    }
    var st = { __spectrum: U, cssClasses: B, create: $t };
    a.create = $t, a.cssClasses = B, a.default = st, Object.defineProperty(a, "__esModule", { value: !0 });
  })(t);
})));
function Hl(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const a = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, s) {
    return r === a[s];
  }));
}
var Kr = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const a = (function(n, l, o) {
    const { value: h, modelValue: v, min: u } = Ca(n);
    let f = v && v.value !== void 0 ? v : h;
    const m = pe(f.value);
    if (Da(f.value) && (f = pe(u.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(n, l, o) {
    const { classes: h, showTooltip: v, tooltipPosition: u, orientation: f } = Ca(n), m = J((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: J((() => {
      const c = { ...m.value };
      return Object.keys(c).forEach(((w) => {
        c[w] = Array.isArray(c[w]) ? c[w].filter(((_) => _ !== null)).join(" ") : c[w];
      })), v.value !== "always" && (c.target += ` ${v.value === "drag" ? c.tooltipDrag : c.tooltipFocus}`), f.value === "horizontal" && (c.tooltip += u.value === "bottom" ? ` ${c.tooltipBottom}` : ` ${c.tooltipTop}`), f.value === "vertical" && (c.tooltip += u.value === "right" ? ` ${c.tooltipRight}` : ` ${c.tooltipLeft}`), c;
    })) };
  })(e), s = (function(n, l, o) {
    const { format: h, step: v } = Ca(n), u = o.value, f = o.classList, m = J((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : Vl({ ...h.value }) : Vl({ decimals: v.value >= 0 ? 0 : 2 }))), c = J((() => Array.isArray(u.value) ? u.value.map(((w) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: c, tooltipsMerge: (w, _, g) => {
      var b = getComputedStyle(w).direction === "rtl", S = w.noUiSlider.options.direction === "rtl", T = w.noUiSlider.options.orientation === "vertical", I = w.noUiSlider.getTooltips(), $ = w.noUiSlider.getOrigins();
      I.forEach((function(C, F) {
        C && $[F].appendChild(C);
      })), w.noUiSlider.on("update", (function(C, F, V, K, O) {
        var G = [[]], P = [[]], E = [[]], L = 0;
        I[0] && (G[0][0] = 0, P[0][0] = O[0], E[0][0] = m.value.to(parseFloat(C[0])));
        for (var z = 1; z < C.length; z++) (!I[z] || C[z] - C[z - 1] > _) && (G[++L] = [], E[L] = [], P[L] = []), I[z] && (G[L].push(z), E[L].push(m.value.to(parseFloat(C[z]))), P[L].push(O[z]));
        G.forEach((function(U, X) {
          for (var B = U.length, ie = 0; ie < B; ie++) {
            var H = U[ie];
            if (ie === B - 1) {
              var Q = 0;
              P[X].forEach((function(se) {
                Q += 1e3 - se;
              }));
              var ae = T ? "bottom" : "right", ve = S ? 0 : B - 1, be = 1e3 - P[X][ve];
              Q = (b && !T ? 100 : 0) + Q / B - be, I[H].innerHTML = E[X].join(g), I[H].style.display = "block", I[H].style[ae] = Q + "%", f.value.tooltipHidden.split(" ").forEach(((se) => {
                I[H].classList.contains(se) && I[H].classList.remove(se);
              }));
            } else I[H].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((se) => {
              I[H].classList.add(se);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: a.value, classList: r.classList }), i = (function(n, l, o) {
    const { orientation: h, direction: v, tooltips: u, step: f, min: m, max: c, merge: w, id: _, disabled: g, options: b, classes: S, format: T, lazy: I, ariaLabelledby: $, aria: C } = Ca(n), F = o.value, V = o.initialValue, K = o.tooltipsFormat, O = o.tooltipsMerge, G = o.tooltipFormat, P = o.classList, E = pe(null), L = pe(null), z = pe(!1), U = J((() => {
      let se = { cssPrefix: "", cssClasses: P.value, orientation: h.value, direction: v.value, tooltips: !!u.value && K.value, connect: "lower", start: Da(F.value) ? m.value : F.value, range: { min: m.value, max: c.value } };
      if (f.value > 0 && (se.step = f.value), Array.isArray(F.value) && (se.connect = !0), $ && $.value || C && Object.keys(C.value).length) {
        let ge = Array.isArray(F.value) ? F.value : [F.value];
        se.handleAttributes = ge.map(((we) => Object.assign({}, C.value, $ && $.value ? { "aria-labelledby": $.value } : {})));
      }
      return T.value && (se.ariaFormat = G.value), se;
    })), X = J((() => {
      let se = { id: _ && _.value ? _.value : void 0 };
      return g.value && (se.disabled = !0), se;
    })), B = J((() => Array.isArray(F.value))), ie = () => {
      let se = L.value.get();
      return Array.isArray(se) ? se.map(((ge) => parseFloat(ge))) : parseFloat(se);
    }, H = function(se) {
      let ge = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      L.value.set(se, ge);
    }, Q = (se) => {
      l.emit("input", se), l.emit("update:modelValue", se), l.emit("update", se);
    }, ae = () => {
      L.value = om.create(E.value, Object.assign({}, U.value, b.value)), u.value && B.value && w.value >= 0 && O(E.value, w.value, " - "), L.value.on("set", (() => {
        const se = ie();
        l.emit("change", se), l.emit("set", se), I.value && Q(se);
      })), L.value.on("update", (() => {
        if (!z.value) return;
        const se = ie();
        B.value && Hl(F.value, se) || !B.value && F.value == se ? l.emit("update", se) : I.value || Q(se);
      })), L.value.on("start", (() => {
        l.emit("start", ie());
      })), L.value.on("end", (() => {
        l.emit("end", ie());
      })), L.value.on("slide", (() => {
        l.emit("slide", ie());
      })), L.value.on("drag", (() => {
        l.emit("drag", ie());
      })), E.value.querySelectorAll("[data-handle]").forEach(((se) => {
        se.onblur = () => {
          E.value && P.value.focused.split(" ").forEach(((ge) => {
            E.value.classList.remove(ge);
          }));
        }, se.onfocus = () => {
          P.value.focused.split(" ").forEach(((ge) => {
            E.value.classList.add(ge);
          }));
        };
      })), z.value = !0;
    }, ve = () => {
      L.value.off(), L.value.destroy(), L.value = null;
    }, be = (se, ge) => {
      z.value = !1, ve(), ae();
    };
    return pt(ae), Tn(ve), Ve(B, be, { immediate: !1 }), Ve(m, be, { immediate: !1 }), Ve(c, be, { immediate: !1 }), Ve(f, be, { immediate: !1 }), Ve(h, be, { immediate: !1 }), Ve(v, be, { immediate: !1 }), Ve(u, be, { immediate: !1 }), Ve(w, be, { immediate: !1 }), Ve(T, be, { immediate: !1, deep: !0 }), Ve(b, be, { immediate: !1, deep: !0 }), Ve(S, be, { immediate: !1, deep: !0 }), Ve(F, ((se, ge) => {
      ge && (typeof ge == "object" && typeof se == "object" && se && Object.keys(ge) > Object.keys(se) || typeof ge == "object" && typeof se != "object" || Da(se)) && be();
    }), { immediate: !1 }), Ve(F, ((se) => {
      if (Da(se)) return void H(m.value, !1);
      let ge = ie();
      B.value && !Array.isArray(ge) && (ge = [ge]), (B.value && !Hl(se, ge) || !B.value && se != ge) && H(se, !1);
    }), { deep: !0 }), { slider: E, slider$: L, isRange: B, sliderProps: X, init: ae, destroy: ve, refresh: be, update: H, reset: () => {
      Q(V.value);
    } };
  })(e, t, { value: a.value, initialValue: a.initialValue, tooltipFormat: s.tooltipFormat, tooltipsFormat: s.tooltipsFormat, tooltipsMerge: s.tooltipsMerge, classList: r.classList });
  return { ...r, ...s, ...i };
} };
Kr.render = function(e, t, a, r, s, i) {
  return A(), j("div", Ce(e.sliderProps, { ref: "slider" }), null, 16);
}, Kr.__file = "src/Slider.vue";
const sm = ["data-click-name"], cm = { class: "lc-slider__wrap" }, um = {
  key: 0,
  class: "lc-slider__min"
}, dm = {
  key: 0,
  class: "lc-slider__slider-marks"
}, fm = ["data-testid"], hm = {
  key: 1,
  class: "lc-slider__max"
}, vm = 1, Wg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = pe(!1), r = ut("slider"), s = t, i = J({
      get: () => e.value,
      set: (f) => s("update:value", f)
    }), n = J(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), l = J(() => {
      if (n.value) return Object.keys(n.value.range);
      const f = (e.max - e.min) / e.step + vm;
      return Array.from({ length: f }, (m, c) => c);
    }), o = (f) => {
      const m = r.value;
      if (!m) return;
      const c = new Event(f, { bubbles: !0 });
      m.dispatchEvent(c);
    }, h = () => {
      a.value || (o("focusin"), o("focusout"));
    }, v = (f) => {
      a.value = f === "focusin", o(f);
    }, u = (f) => ["max", "min"].includes(String(f));
    return (f, m) => (A(), j("div", {
      ref: "slider",
      class: ye(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!n.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ne("div", cm, [
        e.hideMin ? ue("", !0) : (A(), j("span", um, [
          me(f.$slots, "min", Lt(Rt({ min: e.min })), () => [
            bt($e(e.format(e.min)), 1)
          ])
        ])),
        ne("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = oa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = oa(() => v("focusout"), ["stop"]))
        }, [
          Oe(q(Kr), Ce({
            ...Qt(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (c) => i.value = c),
            class: "lc-slider__slider",
            options: n.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? ue("", !0) : (A(), j("div", dm, [
            (A(!0), j(Ye, null, ht(l.value, (c) => (A(), j("span", {
              key: c,
              class: ye(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${c}`]: u(c)
              }]),
              "data-testid": `lc-slider-mark-${c}`,
              style: At(
                typeof c == "string" && !u(c) ? `left:${c}%` : null
              )
            }, null, 14, fm))), 128))
          ]))
        ], 32),
        e.hideMax ? ue("", !0) : (A(), j("span", hm, [
          me(f.$slots, "max", Lt(Rt({ max: e.max })), () => [
            bt($e(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, sm));
  }
});
function xn() {
  return xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var r in a)
        Object.prototype.hasOwnProperty.call(a, r) && (e[r] = a[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var mm = 0.996, gm = function(t, a) {
  return a === void 0 && (a = mm), t * a / (1 - a);
};
function bm(e) {
  return e[e.length - 1];
}
function pm(e) {
  return e.reduce(function(t, a) {
    return t + a;
  }) / e.length;
}
var ym = function(t, a, r) {
  return Math.min(Math.max(a, t), r);
};
function Nr(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(a, r) {
    return a + t[r];
  });
}
function Ul(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function jn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && jn(t);
  }), e;
}
function wm() {
  var e = {};
  function t(s, i) {
    return e[s] = (e[s] || []).concat(i), function() {
      return a(s, i);
    };
  }
  function a(s, i) {
    e[s] = (e[s] || []).filter(function(n) {
      return n !== i;
    });
  }
  function r(s, i) {
    s in e && e[s].forEach(function(n) {
      return n(i);
    });
  }
  return jn({
    on: t,
    off: a,
    dispatch: r
  });
}
function xm(e) {
  var t = [], a = function(n) {
    return n.addEventListener("wheel", e, {
      passive: !1
    }), t.push(n), function() {
      return r(n);
    };
  }, r = function(n) {
    n.removeEventListener("wheel", e), t = t.filter(function(l) {
      return l !== n;
    });
  }, s = function() {
    t.forEach(r);
  };
  return jn({
    observe: a,
    unobserve: r,
    disconnect: s
  });
}
var km = 16 * 1.125, _m = typeof window < "u" && window.innerHeight || 800, Br = [1, km, _m];
function Sm(e) {
  var t = e.deltaX * Br[e.deltaMode], a = e.deltaY * Br[e.deltaMode], r = (e.deltaZ || 0) * Br[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, a, r]
  };
}
var Cm = [-1, -1, -1];
function Em(e, t) {
  if (!t)
    return e;
  var a = t === !0 ? Cm : t.map(function(r) {
    return r ? -1 : 1;
  });
  return xn({}, e, {
    axisDelta: e.axisDelta.map(function(r, s) {
      return r * a[s];
    })
  });
}
var ql = 700, Tm = function(t) {
  return xn({}, t, {
    axisDelta: t.axisDelta.map(function(a) {
      return ym(a, -ql, ql);
    })
  });
}, Pr = process.env.NODE_ENV !== "production", Lm = 0.6, Am = 0.96, $m = 2, jl = 5, Zl = /* @__PURE__ */ jn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Im = 400;
function Wl() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Im
  };
}
function Dm(e) {
  e === void 0 && (e = {});
  var t = wm(), a = t.on, r = t.off, s = t.dispatch, i = Zl, n = Wl(), l, o = !1, h, v = function(E) {
    Array.isArray(E) ? E.forEach(function(L) {
      return c(L);
    }) : c(E);
  }, u = function(E) {
    return E === void 0 && (E = {}), Object.values(E).some(function(L) {
      return L == null;
    }) ? (Pr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = jn(xn({}, Zl, i, E));
  }, f = function(E) {
    var L = xn({
      event: l,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: n.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: n.axisVelocity,
      axisMovement: n.axisMovement,
      get axisMovementProjection() {
        return Nr(L.axisMovement, L.axisVelocity.map(function(z) {
          return gm(z);
        }));
      }
    }, E);
    s("wheel", xn({}, L, {
      previous: h
    })), h = L;
  }, m = function(E, L) {
    var z = i, U = z.preventWheelAction, X = L[0], B = L[1], ie = L[2];
    if (typeof U == "boolean") return U;
    switch (U) {
      case "x":
        return Math.abs(X) >= E;
      case "y":
        return Math.abs(B) >= E;
      case "z":
        return Math.abs(ie) >= E;
      default:
        return Pr && console.warn("unsupported preventWheelAction value: " + U, "warn"), !1;
    }
  }, c = function(E) {
    var L = Tm(Em(Sm(E), i.reverseSign)), z = L.axisDelta, U = L.timeStamp, X = Ul(z);
    if (E.preventDefault && m(X, z) && E.preventDefault(), n.isStarted ? n.isMomentum && X > Math.max(2, n.lastAbsDelta * 2) && (F(!0), $()) : $(), X === 0 && Object.is && Object.is(E.deltaX, -0)) {
      o = !0;
      return;
    }
    l = E, n.axisMovement = Nr(n.axisMovement, z), n.lastAbsDelta = X, n.scrollPointsToMerge.push({
      axisDelta: z,
      timeStamp: U
    }), w(), f({
      axisDelta: z,
      isStart: !n.isStartPublished
    }), n.isStartPublished = !0, C();
  }, w = function() {
    n.scrollPointsToMerge.length === $m ? (n.scrollPoints.unshift({
      axisDeltaSum: n.scrollPointsToMerge.map(function(E) {
        return E.axisDelta;
      }).reduce(Nr),
      timeStamp: pm(n.scrollPointsToMerge.map(function(E) {
        return E.timeStamp;
      }))
    }), g(), n.scrollPointsToMerge.length = 0, n.scrollPoints.length = 1, n.isMomentum || T()) : n.isStartPublished || _();
  }, _ = function() {
    n.axisVelocity = bm(n.scrollPointsToMerge).axisDelta.map(function(E) {
      return E / n.willEndTimeout;
    });
  }, g = function() {
    var E = n.scrollPoints, L = E[0], z = E[1];
    if (!(!z || !L)) {
      var U = L.timeStamp - z.timeStamp;
      if (U <= 0) {
        Pr && console.warn("invalid deltaTime");
        return;
      }
      var X = L.axisDeltaSum.map(function(ie) {
        return ie / U;
      }), B = X.map(function(ie, H) {
        return ie / (n.axisVelocity[H] || 1);
      });
      n.axisVelocity = X, n.accelerationFactors.push(B), b(U);
    }
  }, b = function(E) {
    var L = Math.ceil(E / 10) * 10 * 1.2;
    n.isMomentum || (L = Math.max(100, L * 2)), n.willEndTimeout = Math.min(1e3, Math.round(L));
  }, S = function(E) {
    return E === 0 ? !0 : E <= Am && E >= Lm;
  }, T = function() {
    if (n.accelerationFactors.length >= jl) {
      if (o && (o = !1, Ul(n.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var E = n.accelerationFactors.slice(jl * -1), L = E.every(function(z) {
        var U = !!z.reduce(function(B, ie) {
          return B && B < 1 && B === ie ? 1 : 0;
        }), X = z.filter(S).length === z.length;
        return U || X;
      });
      L && I(), n.accelerationFactors = E;
    }
  }, I = function() {
    n.isMomentum = !0;
  }, $ = function() {
    n = Wl(), n.isStarted = !0, n.startTime = Date.now(), h = void 0, o = !1;
  }, C = /* @__PURE__ */ (function() {
    var P;
    return function() {
      clearTimeout(P), P = setTimeout(F, n.willEndTimeout);
    };
  })(), F = function(E) {
    E === void 0 && (E = !1), n.isStarted && (n.isMomentum && E ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), n.isMomentum = !1, n.isStarted = !1);
  }, V = xm(v), K = V.observe, O = V.unobserve, G = V.disconnect;
  return u(e), jn({
    on: a,
    off: r,
    observe: K,
    unobserve: O,
    disconnect: G,
    feedWheel: v,
    updateOptions: u
  });
}
var Mm = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
xi.globalOptions = void 0;
var Om = process.env.NODE_ENV !== "production";
function xi(e) {
  e === void 0 && (e = {});
  var t, a = function() {
  };
  function r(i, n) {
    var l, o, h = n.mergeOptions, v = n.optionsAtMedia, u = h(Mm, xi.globalOptions), f = h(u, e);
    t = v(f);
    var m = i.internalEngine(), c = (l = t.target) != null ? l : i.containerNode().parentNode, w = (o = t.forceWheelAxis) != null ? o : m.options.axis, _ = Dm({
      preventWheelAction: w,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      C = (w === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = _.observe(c), S = _.on("wheel", X), T = !1, I, $ = 0, C = 0, F = !1;
    g(), i.on("resize", g);
    function V(B) {
      try {
        I = new MouseEvent("mousedown", B.event), L(I);
      } catch {
        return Om && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), a();
      }
      T = !0, $ = 0, O(), t.wheelDraggingClass && c.classList.add(t.wheelDraggingClass);
    }
    function K(B) {
      T = !1, L(E("mouseup", B)), G(), t.wheelDraggingClass && c.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", P, !0), document.documentElement.addEventListener("mouseup", P, !0), document.documentElement.addEventListener("mousedown", P, !0);
    }
    function G() {
      document.documentElement.removeEventListener("mousemove", P, !0), document.documentElement.removeEventListener("mouseup", P, !0), document.documentElement.removeEventListener("mousedown", P, !0);
    }
    function P(B) {
      T && B.isTrusted && B.stopImmediatePropagation();
    }
    function E(B, ie) {
      var H, Q;
      if (w === m.options.axis) {
        var ae = ie.axisMovement;
        H = ae[0], Q = ae[1];
      } else {
        var ve = ie.axisMovement;
        Q = ve[0], H = ve[1];
      }
      var be = z(ie), se = be.isAtBoundary;
      if (se) {
        var ge = Math.min($ / C, 1), we = 0.25 + ge * 0.5, Le = H > 0 ? -1 : 1, Ze = $ * Le, Ne = Ze * we;
        H += Ne, Q += Ne;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var fe = m.containerRect.width, Re = m.containerRect.height;
        H = H < 0 ? Math.max(H, -fe) : Math.min(H, fe), Q = Q < 0 ? Math.max(Q, -Re) : Math.min(Q, Re);
      }
      return new MouseEvent(B, {
        clientX: I.clientX + H,
        clientY: I.clientY + Q,
        screenX: I.screenX + H,
        screenY: I.screenY + Q,
        movementX: H,
        movementY: Q,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function L(B) {
      i.containerNode().dispatchEvent(B);
    }
    function z(B) {
      var ie = B.axisDelta, H = ie[0], Q = ie[1], ae = i.scrollProgress(), ve = ae < 1, be = ae > 0, se = w === "x" ? H : Q, ge = se < 0, we = se > 0, Le = ge && !ve || we && !be;
      return {
        isAtBoundary: Le,
        primaryAxisDelta: se
      };
    }
    function U(B) {
      var ie = z(B), H = ie.isAtBoundary, Q = ie.primaryAxisDelta;
      if (H && !B.isMomentum) {
        if ($ += Math.abs(Q), $ > C)
          return F = !0, K(B), !0;
      } else
        $ = 0;
      return !1;
    }
    function X(B) {
      var ie = B.axisDelta, H = ie[0], Q = ie[1], ae = w === "x" ? H : Q, ve = w === "x" ? Q : H, be = B.isMomentum && B.previous && !B.previous.isMomentum, se = B.isEnding && !B.isMomentum || be, ge = Math.abs(ae) > Math.abs(ve);
      ge && !T && !B.isMomentum && !F && V(B), F && B.isEnding && (F = !1), T && (U(B) || (se ? K(B) : L(E("mousemove", B))));
    }
    a = function() {
      b(), S(), i.off("resize", g), G();
    };
  }
  var s = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return a();
    }
  };
  return s;
}
const Rm = { class: "lc-slot-wheel__wrap" }, Xg = /* @__PURE__ */ _e({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Ka({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      xi()
    ], [n, l] = Qa(
      {
        ...s,
        startIndex: Math.max(
          0,
          e.options.findIndex(($) => $.value === e.value)
        )
      },
      i
    ), o = Zn(Zr, () => null, !0), h = no(), v = () => {
      l.value?.reInit({
        ...s,
        watchDrag: !1
      });
    }, u = () => {
      l.value?.reInit({
        ...s,
        watchDrag: !0
      });
    }, f = ($) => Math.max(
      0,
      e.options.findIndex((C) => C.value === $)
    ), m = ($) => !$ || h.value === "reduce", c = ($, C = !0) => {
      l.value?.scrollTo(f($), m(C));
    }, w = () => {
      I(), r("ready");
    }, _ = () => {
      o?.disable();
    }, g = () => {
      o?.enable();
    }, b = () => {
      I(), r("reInit");
    }, S = () => {
      const $ = l.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[$].value);
    }, T = () => {
      r("optionsChanged");
    }, I = () => {
      if (!l.value) return;
      const { rootNode: $, slideNodes: C } = l.value, V = $().getBoundingClientRect(), K = V.top + V.height / 2;
      C().forEach((O) => {
        const G = O.getBoundingClientRect(), L = (G.top + G.height / 2 - K) / (V.height / 2), z = Math.max(-1, Math.min(1, L)), U = 1 - Math.abs(z) * 0.3, X = O.style.transform.split(" ").filter((B) => !B.startsWith("scale("));
        X.push(`scale(${U})`), O.style.transform = X.join(" ");
      });
    };
    return pt(() => {
      l.value && l.value.on("init", w).on("pointerDown", _).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", S).on("slidesChanged", T);
    }), Ve(
      () => e.value,
      ($) => c($)
    ), t({
      disable: v,
      enable: u,
      moveToOption: c
    }), ($, C) => (A(), j("div", {
      ref_key: "emblaRef",
      ref: n,
      class: "lc-slot-wheel"
    }, [
      ne("div", Rm, [
        (A(!0), j(Ye, null, ht(e.options, (F, V) => (A(), j("div", {
          key: `${F.label}-${F.value}`,
          className: "lc-slot-wheel__option"
        }, [
          me($.$slots, "option", Ce({ ref_for: !0 }, { index: V, option: F }), () => [
            bt($e(F.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), Fm = ["for"], Nm = ["id", "aria-label", "data-click-name"], Bm = { class: "lc-switch__toggle" }, Yg = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: "checkmark" },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = yt(e.id), { vibrate: s } = ao(), i = J(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), n = J({
      get: () => e.value,
      set: (l) => {
        a("update:value", l), s();
      }
    });
    return (l, o) => (A(), j("label", {
      class: ye([i.value, l.$attrs.class]),
      for: q(r)
    }, [
      Jt(ne("input", Ce({
        ...Qt(l.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: q(r),
        "onUpdate:modelValue": o[0] || (o[0] = (h) => n.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: o[1] || (o[1] = ti((h) => n.value = !n.value, ["enter"]))
      }), null, 16, Nm), [
        [Kl, n.value]
      ]),
      o[2] || (o[2] = ne("div", { class: "lc-switch__track" }, null, -1)),
      ne("div", Bm, [
        Oe(q(Je), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, Fm));
  }
}), Gg = ["info", "success"], Kg = /* @__PURE__ */ _e({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = J(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (a, r) => (A(), j("table", {
      class: ye(t.value)
    }, [
      me(a.$slots, "default")
    ], 2));
  }
}), Jg = ["medium", "small"], Qg = ["column", "row"], e2 = ["bottom", "top"], t2 = ["automatic", "manual"], n2 = ["default", "divider"], a2 = /* @__PURE__ */ Symbol();
var Rn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Rn || {});
const Pm = ["id"], zm = ["id"], Vm = { class: "lc-tabs__tablist-inner" }, Hm = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], Um = {
  key: 1,
  class: "lc-tabs__header"
}, qm = ["aria-labelledby"], jm = ["id", "aria-labelledby"], r2 = /* @__PURE__ */ _e({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = ut("carousel"), i = ut("container"), n = ut("tabs"), l = yt(e.id), o = pe(0), h = pe(0), v = pe(null), u = pe(null), f = pe(!1), m = pe(!1);
    let c = null;
    const w = J(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), _ = () => {
      m.value = !0, c && clearTimeout(c), c = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = n.value?.[o.value];
      O && (v.value = `${O.offsetWidth}px`, u.value = `${O.offsetLeft}px`);
    };
    on(window, "resize", [g, _]), Us(i, g);
    const b = J(() => e.tabs.length <= 1), S = (O, G) => {
      O !== o.value && (o.value = O, G?.skipCarousel || s.value?.moveToIndex(O), G?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, T = (O) => {
      n.value?.[O].focus();
    }, I = (O) => {
      if (O !== o.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, $ = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, C = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, F = (O) => e.tabs.findIndex((G) => G.name === O), V = (O) => {
      if (!en(O.key, Rn)) return;
      O.preventDefault(), O.stopPropagation();
      let G;
      switch (O.key) {
        case Rn.ArrowLeft:
          G = C();
          break;
        case Rn.ArrowRight:
          G = $();
          break;
        case Rn.End:
          G = e.tabs.length - 1;
          break;
        case Rn.Home:
          G = 0;
          break;
      }
      h.value = G, e.trigger === "automatic" && S(G);
    }, K = () => {
      const O = F(e.value);
      O !== -1 && (o.value = O, h.value = O);
    };
    return Is(K), Ds(K), pt(() => {
      g(), b.value || (f.value = !0);
    }), Ve(o, g), Ve(h, T), Ve(
      () => e.value,
      (O) => {
        if (!O) return;
        const G = F(O);
        G !== -1 && S(G, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, G) => (A(), j("section", {
      id: q(l),
      class: ye(w.value)
    }, [
      me(O.$slots, "top"),
      b.value ? ue("", !0) : (A(), j("div", {
        key: 0,
        ref: "container",
        class: ye(["lc-tabs__nav_container", e.containerClass])
      }, [
        ne("nav", {
          id: q(l),
          class: ye(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: At({
            "--active-tab-index": o.value,
            ...u.value && { "--indicator-offset": u.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ne("div", Vm, [
            (A(!0), j(Ye, null, ht(e.tabs, (P, E) => (A(), j("button", {
              id: `${q(l)}-tab-${E}`,
              key: P.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${q(l)}-tabpanel-${E}`,
              "aria-selected": o.value === E,
              class: ye(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: o.value !== E ? -1 : void 0,
              type: "button",
              onClickPassive: (L) => S(E),
              onKeydown: V
            }, [
              O.$slots.tab ? me(O.$slots, "tab", Ce({ ref_for: !0 }, { tab: P, index: E }), void 0, void 0, 0) : (A(), j(Ye, { key: 1 }, [
                P.icon ? (A(), Se(q(Je), {
                  key: 0,
                  name: P.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : ue("", !0),
                bt(" " + $e(P.title ?? P.name), 1)
              ], 64))
            ], 42, Hm))), 128))
          ])
        ], 14, zm),
        me(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? (A(), j("header", Um, [
        me(O.$slots, "header")
      ])) : ue("", !0),
      !f.value && e.tabs.length > 0 ? (A(), j("div", {
        key: 2,
        "aria-labelledby": `${q(l)}-tab-${o.value}`,
        class: ye(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        me(O.$slots, "tab-panel", {
          index: o.value,
          tab: e.tabs[o.value]
        })
      ], 8, qm)) : ue("", !0),
      b.value ? ue("", !0) : (A(), Se(q(Ad), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: ye(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": o.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: G[0] || (G[0] = (P) => S(P, { skipCarousel: !0 })),
        onReady: G[1] || (G[1] = (P) => f.value = !0)
      }, {
        slide: Ie(({ index: P, isVisible: E, slide: L }) => [
          ne("div", Ce({
            id: `${q(l)}-tabpanel-${P}`
          }, I(P), {
            "aria-labelledby": `${q(l)}-tab-${P}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || E || P === o.value ? me(O.$slots, "tab-panel", Lt(Rt({ tab: L, index: P })), void 0, void 0, 0) : ue("", !0)
          ], 16, jm)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, Pm));
  }
}), Zm = ["for"], Wm = ["id"], Xm = ["id", "aria-labelledby", "data-click-error", "data-click-name"], Ym = { class: "lc-textarea__feedback-wrap" }, Gm = { class: "lc-textarea__counter" }, i2 = /* @__PURE__ */ _e({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const a = t, r = ut("textarea"), s = yt(e.id), i = pe(!1), n = J(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), l = J(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), o = J(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = J({
      get: () => e.value,
      set: (v) => a("update:value", v)
    });
    return pt(() => {
      e.autofocus && r.value?.focus();
    }), (v, u) => (A(), j("div", {
      class: ye([n.value, v.$attrs.class])
    }, [
      ne("label", {
        class: "lc-textarea__wrap",
        for: q(s)
      }, [
        e.label ? (A(), j("span", {
          key: 0,
          id: `${q(s)}-label`,
          class: ye(o.value)
        }, $e(e.label), 11, Wm)) : ue("", !0),
        Jt(ne("textarea", Ce({
          id: q(s),
          ref: "textarea"
        }, {
          ...Qt(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": u[0] || (u[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${q(s)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: u[1] || (u[1] = (f) => i.value = !0),
          onFocusout: u[2] || (u[2] = (f) => i.value = !1)
        }), null, 16, Xm), [
          [Ms, h.value]
        ])
      ], 8, Zm),
      ne("div", Ym, [
        e.noFeedback ? ue("", !0) : (A(), Se(q(Ln), Ce({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ne("span", Gm, [
          ne("span", null, $e(l.value) + "/" + $e(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), Km = { class: "lc-toast__indicator" }, Jm = { class: "lc-toast__content" }, Qm = {
  key: 0,
  class: "lc-toast__title"
}, e1 = {
  key: 0,
  class: "lc-toast__text"
}, l2 = /* @__PURE__ */ _e({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: "info" }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (a, r) => (A(), j("article", {
      class: ye(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ne("aside", Km, [
        Oe(q(Je), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ne("section", Jm, [
        e.headline ? (A(), j("span", Qm, $e(e.headline), 1)) : ue("", !0),
        me(a.$slots, "default", {}, () => [
          e.text ? (A(), j("p", e1, $e(e.text), 1)) : ue("", !0)
        ])
      ]),
      e.closable ? (A(), Se(q(Ct), {
        key: 0,
        "aria-label": q(je).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (s) => a.$emit("close"))
      }, null, 8, ["aria-label"])) : ue("", !0)
    ], 2));
  }
}), o2 = ["danger", "info", "success", "warning", "win"], t1 = ["left", "right"], n1 = 0.4, a1 = 0.75, Xl = 0.85, r1 = 0.2, i1 = 150, l1 = 8, o1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, s2 = /* @__PURE__ */ _e({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: a }) {
    const r = a, s = ut("lcSwipeableRef"), i = En(), n = pe(null), l = pe(0), o = pe(0), h = pe(0), v = pe(!1), u = pe(!1), f = pe(!1), m = pe(!1), c = pe(!1);
    let w = 0;
    const { distanceX: _ } = qs(s, {
      pointerTypes: e.pointerTypes,
      threshold: l1,
      onSwipe: () => {
        if (e.disabled || !s.value) return;
        v.value || P();
        const H = s.value.clientWidth, Q = o.value - _.value, ae = K(Q);
        if (ae && !I(ae)) {
          l.value = 0;
          return;
        }
        const ve = C(ae), be = V(Q, H, $(ae));
        m.value = O(H, ve), h.value = Math.min(1, Math.abs(_.value) / (H * ve));
        const se = !!(ae && T(ae)?.fullSwipe && m.value);
        E(se), L(ae), l.value = se && ae ? G(ae, H) : be, ae && ae !== n.value && z(ae);
      },
      onSwipeEnd: (H, Q) => {
        U();
        const ae = f.value;
        if (X(), m.value = !1, !(!e.disabled && (Q === "left" || Q === "right") && I(Q) && s.value !== null && O(s.value.clientWidth, C(Q)))) {
          l.value = 0;
          return;
        }
        ae || (l.value = 0), r("trigger", Q);
      }
    }), g = J(() => t1.map((H) => ({ side: H, action: T(H) }))), b = J(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": v.value && !u.value }
    ]), S = J(() => Xl + (1 - Xl) * h.value), T = (H) => H === "left" ? e.leftAction : H === "right" ? e.rightAction : void 0, I = (H) => !!(T(H) || i[`${H}-action`]), $ = (H) => T(H)?.resistanceThreshold ?? a1, C = (H) => {
      const Q = T(H);
      return Q?.fullSwipe ? $(H) : Q?.activationThreshold ?? n1;
    }, F = () => {
      if (!s.value) return 0;
      const H = s.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!H) return 0;
      const Q = getComputedStyle(H).transform;
      if (!Q || Q === "none") return 0;
      const ae = new DOMMatrix(Q).m41;
      return Number.isFinite(ae) ? ae : 0;
    }, V = (H, Q, ae) => {
      const ve = Q * ae, be = Math.abs(H);
      if (be <= ve) return H;
      const se = Q * r1, we = (1 - 1 / ((be - ve) / se + 1)) * se;
      return Math.sign(H) * (ve + we);
    }, K = (H) => H < 0 ? "left" : H > 0 ? "right" : null, O = (H, Q) => Math.abs(_.value) >= H * Q, G = (H, Q) => H === "left" ? -Q : Q, P = () => {
      o.value = F(), v.value = !0;
    }, E = (H) => {
      H !== f.value && (f.value = H, u.value = !0, w = performance.now());
    }, L = (H) => {
      !u.value || f.value || !(performance.now() - w >= i1) && H === n.value || (u.value = !1);
    }, z = (H) => {
      n.value = H, c.value = !0, r("swipe-start", H);
    }, U = () => {
      !c.value || !n.value || (c.value = !1, r("swipe-end", n.value));
    }, X = () => {
      o.value = 0, h.value = 0, v.value = !1, f.value = !1, u.value = !1;
    }, B = () => {
      u.value = !1, !v.value && l.value === 0 && (n.value = null);
    }, ie = () => {
      const H = n.value, Q = c.value;
      X(), l.value = 0, m.value = !1, c.value = !1, Q && H && r("swipe-end", H);
    };
    return on(s, "pointercancel", ie), Ve(
      () => e.disabled,
      (H) => {
        H && ie();
      }
    ), t({ close: ie }), (H, Q) => (A(), j("div", {
      ref_key: "lcSwipeableRef",
      ref: s,
      class: "lc-swipeable"
    }, [
      (A(!0), j(Ye, null, ht(g.value, ({ side: ae, action: ve }) => (A(), j(Ye, { key: ae }, [
        ve || H.$slots[`${ae}-action`] ? (A(), j("div", {
          key: 0,
          class: ye([
            "lc-swipeable__action",
            `lc-swipeable__action--${ae}`,
            {
              "lc-swipeable__action--hidden": n.value !== ae,
              "lc-swipeable__action--dragging": v.value && !u.value,
              "lc-swipeable__action--past-threshold": m.value && n.value === ae
            }
          ])
        }, [
          me(H.$slots, `${ae}-action`, {}, () => [
            ve ? (A(), j("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: At(n.value === ae ? { transform: `scale(${S.value})` } : void 0)
            }, [
              Oe(q(Je), {
                name: ve.icon
              }, null, 8, ["name"])
            ], 4)) : ue("", !0),
            ve?.label ? (A(), j("span", o1, $e(ve.label), 1)) : ue("", !0)
          ])
        ], 2)) : ue("", !0)
      ], 64))), 128)),
      ne("div", {
        class: ye(b.value),
        style: At({ transform: `translateX(${l.value}px)` }),
        onTransitionend: oa(B, ["self"])
      }, [
        me(H.$slots, "default")
      ], 38)
    ], 512));
  }
}), s1 = { class: "lc-lottery-remaining-picks__headline" }, c1 = { class: "lc-lottery-remaining-picks__done" }, u1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, d1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, f1 = /* @__PURE__ */ _e({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => je.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = pe(!1);
    Ve(
      () => e.complete,
      (r, s) => {
        r && !s ? t.value = !0 : r || (t.value = !1);
      }
    );
    const a = (r) => {
      const s = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === s && (t.value = !1);
    };
    return (r, s) => (A(), j("div", {
      class: ye([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: a
    }, [
      ne("div", s1, [
        me(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ne("div", c1, [
        ne("span", u1, [
          Oe(q(Je), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? (A(), j("span", d1, $e(e.doneLabel), 1)) : ue("", !0)
      ])
    ], 34));
  }
}), h1 = ["aria-hidden"], v1 = ["aria-hidden"], m1 = {
  key: 1,
  class: "lc-lottery-editor-card__labels"
}, g1 = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, b1 = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, p1 = { class: "lc-lottery-editor-card__footer" }, c2 = /* @__PURE__ */ _e({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ sa({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => je.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    quickPickLabel: { default: () => je.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    toggleAriaLabel: { default: () => je.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ sa(["clear", "quick-pick", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const a = t, r = Za(e, "expanded");
    return (s, i) => (A(), Se(q(ya), Ce({
      modelValue: r.value,
      "onUpdate:modelValue": i[2] || (i[2] = (n) => r.value = n),
      "body-class": "lc-lottery-editor-card__body",
      class: ["lc-lottery-editor-card", { "lc-lottery-editor-card--separated": e.separated }],
      expandable: "",
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }), {
      header: Ie(() => [
        ne("div", {
          class: ye([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ])
        }, [
          ne("div", {
            "aria-hidden": !r.value,
            class: "lc-lottery-editor-card__expanded"
          }, [
            Oe(q(f1), Lt(Rt({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
              default: Ie(({ countClass: n }) => [
                me(s.$slots, "headline", Lt(Rt({ countClass: n })))
              ]),
              _: 3
            }, 16)
          ], 8, h1),
          ne("div", {
            "aria-hidden": r.value,
            class: "lc-lottery-editor-card__summary"
          }, [
            e.fields ? (A(), Se(q(Ch), Ce({ key: 0 }, { fields: e.fields }, { size: "medium" }), null, 16)) : ue("", !0),
            e.wager || e.betType ? (A(), j("div", m1, [
              e.wager ? (A(), j("span", g1, $e(e.wager), 1)) : ue("", !0),
              e.betType ? (A(), j("span", b1, $e(e.betType), 1)) : ue("", !0)
            ])) : ue("", !0)
          ], 8, v1)
        ], 2)
      ]),
      footer: Ie(() => [
        ne("div", p1, [
          Oe(q(Ct), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "trash-full",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: i[0] || (i[0] = (n) => a("clear"))
          }, {
            default: Ie(() => [
              bt($e(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Oe(q(Ct), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: i[1] || (i[1] = (n) => a("quick-pick"))
          }, {
            default: Ie(() => [
              bt($e(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: Ie(() => [
        e.separated ? (A(), Se(q(li), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : ue("", !0),
        me(s.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "header-class"]));
  }
});
export {
  Io as AmplitudeEvents,
  Nt as FORM_FIELD_EVENTS,
  B1 as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  E1 as LC_BUTTON_ICON_POSITIONS,
  T1 as LC_BUTTON_SIZES,
  A1 as LC_BUTTON_TRIGGERS,
  L1 as LC_BUTTON_TYPES,
  $1 as LC_BUTTON_VARIANTS,
  D1 as LC_CARD_RADII,
  M1 as LC_CARD_SHADOWS,
  O1 as LC_CARD_VARIANTS,
  z1 as LC_CAROUSEL_MOVE_TRIGGERS,
  P1 as LC_CAROUSEL_VARIANTS,
  H1 as LC_COUNTDOWN_VARIANTS,
  eg as LC_FORM_FIELD_INTERACTION_MODES,
  _1 as LC_ICON_NAMES,
  k1 as LC_ICON_SIZES,
  rg as LC_INFO_BUTTON_VARIANTS,
  hg as LC_INFO_TEXT_ICON_ALIGNMENTS,
  vg as LC_INFO_TEXT_SIZES,
  j1 as LC_INPUT_MODES,
  Z1 as LC_INPUT_TYPES,
  bg as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  ag as LC_LOTTERY_JACPOT_SIZES,
  wg as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  pg as LC_LOTTERY_NUMBER_SIZES,
  yg as LC_LOTTERY_NUMBER_SPACINGS,
  _g as LC_LOTTERY_TEASER_VARIANTS,
  Cg as LC_MENU_BUTTON_PLACEMENTS,
  Lg as LC_MESSAGE_BOX_SIZES,
  Ag as LC_MESSAGE_BOX_VARIANTS,
  R1 as LC_MODAL_CLOSE_TRIGGERS,
  F1 as LC_MODAL_SPACINGS,
  Dg as LC_PASSWORD_INPUT_TYPES,
  Og as LC_PROGRESS_INDICATOR_SIZES,
  Rg as LC_PROGRESS_INDICATOR_VARIANTS,
  Bg as LC_RADIO_GROUP_LAYOUTS,
  Ug as LC_SCRATCHCARD_TEASER_VARIANTS,
  jg as LC_SELECT_LIST_VARIANTS,
  I1 as LC_SEPARATOR_VARIANTS,
  zg as LC_SKELETON_RADII,
  Gg as LC_SWITCH_VARIANTS,
  Jg as LC_TABLE_PADDINGS,
  Qg as LC_TABS_FLEX_DIRECTIONS,
  e2 as LC_TABS_NAVIGATION_POSITIONS,
  t2 as LC_TABS_TRIGGERS,
  n2 as LC_TABS_VARIANTS,
  ig as LC_TEASER_BACKGROUND_PATTERNS,
  lg as LC_TEASER_BADGE_VARIANTS,
  og as LC_TEASER_HERO_BADGE_VARIANTS,
  Fo as LC_TEASER_VARIANTS,
  o2 as LC_TOAST_VARIANTS,
  S1 as LcBadge,
  N1 as LcBottomSheet,
  Ct as LcButton,
  Ur as LcButtonActiveKeys,
  ya as LcCard,
  Ad as LcCarousel,
  Ma as LcCarouselActiveKeys,
  V1 as LcCheckbox,
  zr as LcCountBubble,
  Rd as LcCountdown,
  U1 as LcDataList,
  q1 as LcDataListItem,
  W1 as LcDateInput,
  X1 as LcDescriptionList,
  Y1 as LcDigitInput,
  rn as LcDigitInputActiveKeys,
  G1 as LcDigitInputGroup,
  ff as LcExpandable,
  K1 as LcExpandableList,
  J1 as LcFlyOut,
  Q1 as LcForm,
  tg as LcFormField,
  ng as LcHeader,
  Df as LcHighFrequencyBall,
  Do as LcHighFrequencyBallBackground,
  sg as LcHighFrequencyTeaser,
  cg as LcHighFrequencyTeaserWatch,
  Je as LcIcon,
  dg as LcImage,
  Ro as LcInfoButton,
  fg as LcInfoText,
  er as LcInput,
  mg as LcLinkList,
  gg as LcLinkListItem,
  $l as LcLotteryCutoffTime,
  c2 as LcLotteryEditorCard,
  Mo as LcLotteryJackpot,
  xg as LcLotteryNumberSelector,
  qt as LcLotteryNumberSelectorActiveKeys,
  Ch as LcLotteryNumbers,
  f1 as LcLotteryRemainingPicks,
  kg as LcLotteryTeaser,
  Sg as LcMaskedValueDisplay,
  Eg as LcMenuButton,
  Vt as LcMenuButtonActiveKeys,
  Tg as LcMessageBox,
  yo as LcModal,
  $g as LcMoneyInput,
  Ig as LcPasswordInput,
  Mg as LcProgressIndicator,
  jv as LcRadio,
  Fg as LcRadioCard,
  Ng as LcRadioGroup,
  Pg as LcRating,
  Vg as LcRemoteList,
  Hg as LcScratchcardTeaser,
  qg as LcSelect,
  Yt as LcSelectActiveKeys,
  Zg as LcSelectList,
  jt as LcSelectListActiveKeys,
  li as LcSeparator,
  Gv as LcSkeleton,
  Wg as LcSlider,
  Xg as LcSlotWheel,
  s2 as LcSwipeable,
  Yg as LcSwitch,
  Kg as LcTable,
  r2 as LcTabs,
  Rn as LcTabsActiveKeys,
  tr as LcTeaser,
  e0 as LcTeaserBadge,
  n0 as LcTeaserHeroBadge,
  No as LcTeaserHeroBadgeColor,
  i2 as LcTextarea,
  l2 as LcToast,
  Zr as carouselContext,
  je as globalConfig,
  a0 as isHeroBadge,
  eu as nuxtAppContext,
  C1 as setGlobalConfig,
  a2 as tabContext
};
